(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-materials"]) return;
  try {
    
(function() {
  var section = document.querySelector('.about-materials');
  if (!section) return;
  var track = section.querySelector('[data-materials-track]');
  var prev = section.querySelector('[data-materials-prev]');
  var next = section.querySelector('[data-materials-next]');
  var cards = track.querySelectorAll('.about-materials__card');
  if (cards.length === 0) return;

  prev.addEventListener('click', function() {
    var cardWidth = cards[0].offsetWidth + 20;
    track.scrollBy({ left: -cardWidth, behavior: 'smooth' });
  });
  next.addEventListener('click', function() {
    var cardWidth = cards[0].offsetWidth + 20;
    track.scrollBy({ left: cardWidth, behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-pricing"]) return;
  try {
    
(function() {
  var expand = document.querySelector('[data-pricing-expand]');
  if (!expand) return;
  var trigger = expand.querySelector('[data-pricing-trigger]');
  var content = expand.querySelector('[data-pricing-content]');
  if (!trigger || !content) return;

  content.style.maxHeight = '0';
  content.style.overflow = 'hidden';
  content.style.transition = 'max-height 0.4s ease';

  trigger.addEventListener('click', function() {
    var isOpen = expand.classList.contains('about-pricing__expand--open');
    if (isOpen) {
      content.style.maxHeight = '0';
      expand.classList.remove('about-pricing__expand--open');
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      expand.classList.add('about-pricing__expand--open');
    }
  });
})();

/* Bar widths, recomputed once the FX rate is known.

   Liquid sized these from mixed units: our price comes out of Markets in the
   presentment currency, while a UK-fallback compare_data price is still GBP. In
   a rate-converted market that makes the retail bar look far too short. Mirrors
   updatePricingChart() in sections/product.liquid — keep the two in step. */
(function() {
  var bars = document.querySelector('[data-ap-bars]');
  if (!bars) return;
  var ourBar = bars.querySelector('[data-ap-bar-ours]');
  var retailBar = bars.querySelector('[data-ap-bar-retail]');
  if (!ourBar || !retailBar) return;

  var rate = 1;
  if (window.Shopify && window.Shopify.currency) {
    rate = parseFloat(window.Shopify.currency.rate) || 1;
  }

  var our = parseInt(bars.dataset.apOurCents || '0', 10) / 100;
  var retail = parseInt(bars.dataset.apRetailCents || '0', 10) / 100;
  if (bars.dataset.apFallback === 'true') retail = retail * rate;

  var max = Math.max(our, retail);
  if (!(max > 0)) return;

  /* 73.75% is the Figma width of the longer bar; the shorter one scales against it. */
  var MAX_PCT = 73.75;
  ourBar.style.width = (our * MAX_PCT / max) + '%';
  retailBar.style.width = (retail * MAX_PCT / max) + '%';
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["account-orders"]) return;
  try {
    
(function () {
  const root = document.querySelector('[data-orders]');
  if (!root) return;

  const stateEl = root.querySelector('[data-orders-state]');
  if (!stateEl) return;

  /* Locale-aware root: '' on the primary locale, '/fr' etc. on secondary ones.
     Cart AJAX must carry it or Shopify answers in the shop's DEFAULT locale. */
  const LOCALE_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');

  const endpoint = root.dataset.endpoint || '/apps/track-order/orders';
  const detailEndpoint = root.dataset.detailEndpoint || '/apps/track-order/order';
  const trackingEndpoint = root.dataset.trackingEndpoint || '/apps/track-order/tracking';
  const reviewInfoEndpoint = root.dataset.reviewInfoEndpoint || '/apps/track-order/review-info';
  // Market-aware base path ("/" or "/en-au") for PDP links; trailing slash
  // stripped so rootUrl + '/products/…' never doubles the separator.
  const rootUrl = (root.dataset.rootUrl || '/').replace(/\/$/, '');
  const resendGiftCardEndpoint = root.dataset.resendGiftCardEndpoint || '/apps/track-order/resend-gift-card';

  /* QA BUG-BV-37: the orders-list URL was written out as a bare '/pages/orders'
     in the history.replaceState calls behind the detail view's back action, so
     leaving an order detail on /fr/pages/orders rewrote the address to
     /pages/orders and dropped the shopper out of French. Build it from the
     locale-aware root the section already carries (data-root-url), the way the
     sign-in link and the back <a href> do. */
  const ordersUrl = () => rootUrl + '/pages/orders';

  let labels = {};
  try {
    const el = root.querySelector('[data-orders-labels]');
    if (el) labels = JSON.parse(el.textContent);
  } catch (e) { labels = {}; }
  // Liquid's `t` filter HTML-escapes translations (only *_html keys skip it),
  // so values like "We're" / "Taxes & duties" arrive as &#39; / &amp;. These
  // strings render via textContent — decode the entities once here.
  (function () {
    const ta = document.createElement('textarea');
    Object.keys(labels).forEach(function (k) {
      if (typeof labels[k] === 'string' && labels[k].indexOf('&') !== -1) {
        ta.innerHTML = labels[k];
        labels[k] = ta.value;
      }
    });
  })();

  const tplList = document.querySelector('[data-orders-tpl-list]');
  const tplRow = document.querySelector('[data-orders-tpl-row]');
  const tplThumb = document.querySelector('[data-orders-tpl-thumb]');
  const tplItem = document.querySelector('[data-orders-tpl-item]');
  const tplEmpty = document.querySelector('[data-orders-tpl-empty]');
  const tplNoResults = document.querySelector('[data-orders-tpl-no-results]');
  const tplError = document.querySelector('[data-orders-tpl-error]');
  const tplSignin = document.querySelector('[data-orders-tpl-signin]');

  const paginationEl = root.querySelector('[data-orders-pagination]');
  const detailEl = root.querySelector('[data-orders-detail]');
  const tplDetail = document.querySelector('[data-orders-tpl-detail]');
  const searchWrap = root.querySelector('[data-orders-search]');
  const searchInput = root.querySelector('[data-orders-search-input]');
  const PAGE_SIZE = 10;
  // Show at most this many thumbnails; the rest collapse into a "+N more" tile.
  // Mobile fits 4 tiles per row (83px tiles + 4px gaps in a ~346px card), so
  // cap at 3 + more there (Figma 9702:134265); desktop rows fit 5 + more.
  function maxThumbs() {
    return window.matchMedia('(max-width: 768px)').matches ? 3 : 5;
  }
  let allOrders = [];
  // Legacy per-customer reviewed set from the /orders response — only the
  // fallback for a stale worker; each order row now carries its own
  // ORDER-scoped reviewed_product_ids (judgment is email+order+product).
  let reviewedProductIds = null;
  let query = '';
  let page = 1;
  let openMenu = null;

  function show(node) { stateEl.replaceChildren(node); }
  function labelFor(key) { return labels[key] || key; }

  // Money and dates both follow the storefront language, NOT the browser
  // locale — a zh-CN browser otherwise renders "Placed 下午6:37, 2026/06/29"
  // on the EN site (and, before BUG-BV-45, grouped/positioned the currency
  // the Chinese way too).
  const STOREFRONT_LOCALE = document.documentElement.lang || 'en';

  /* QA BUG-BV-45: this used `Intl.NumberFormat(undefined, …)`, i.e. the
     BROWSER's language, and `narrowSymbol`, which prints a bare "$". Two
     mismatches with the rest of the storefront: the format followed the wrong
     locale, and an ambiguous "$34.95" gave a Singapore or Australian shopper no
     way to tell which dollar they had been charged.

     snippets/currency-code.liquid is the site-wide rule and this mirrors it
     exactly: "$" is the only symbol shared across our enabled currencies (AUD
     CAD HKD NZD SGD TWD USD), and USD is EXEMPT because a bare "$" already
     reads as US dollars on our largest market. Testing the rendered symbol
     rather than a hardcoded currency list means a newly enabled "$" currency is
     covered automatically, same as the Liquid. */
  function formatMoney(amount, currency) {
    const value = Number(amount);
    const code = currency || 'USD';
    try {
      let out = new Intl.NumberFormat(STOREFRONT_LOCALE, {
        style: 'currency', currency: code, currencyDisplay: 'narrowSymbol'
      }).format(isFinite(value) ? value : 0);
      if (out.indexOf('$') !== -1 && code !== 'USD') out += ' ' + code;
      return out;
    } catch (e) { return (isFinite(value) ? value.toFixed(2) : amount); }
  }

  const DATE_LOCALE = STOREFRONT_LOCALE;

  /* QA BUG-BV-43: processed_at is null on a pure digital gift-card order (there
     is no payment processing step), and every date on the detail page hangs off
     it — so the "Confirmed" milestone rendered with no date, the sub-header went
     blank, and the tracking drawer got processedAt: null. Nothing errored; the
     date line was simply omitted, which reads as a rendering bug.

     created_at always exists and is the same moment the shopper thinks of as
     "when I ordered", so fall back to it. The worker now returns it alongside
     processed_at (customer-order-detail.ts) — on an older worker build this
     resolves to null and the behaviour is exactly what it was before. */
  function orderDate(order) {
    return (order && (order.processed_at || order.created_at)) || null;
  }

  function formatDate(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString(DATE_LOCALE, { month: 'short', day: 'numeric' });
  }

  // Detail view timestamps — "11:30 am, 07/02/2026" (Figma 9844:139801).
  function formatDateTime(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    const time = d.toLocaleTimeString(DATE_LOCALE, { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase();
    const date = d.toLocaleDateString(DATE_LOCALE, { month: '2-digit', day: '2-digit', year: 'numeric' });
    return time + ', ' + date;
  }

  function imgUrl(url, width) {
    return url + (url.indexOf('?') === -1 ? '?width=' + width : '&width=' + width);
  }

  function closeOpenMenu() {
    if (!openMenu) return;
    openMenu.menu.hidden = true;
    openMenu.btn.setAttribute('aria-expanded', 'false');
    openMenu = null;
  }

  // Normalize order items: new worker payload has `items` (title/variant/qty/
  // image/product_id per line); fall back to the legacy `images` array so a
  // stale worker still renders thumbnails.
  function orderItems(order) {
    if (Array.isArray(order.items) && order.items.length) return order.items;
    const imgs = (order.images && order.images.length) ? order.images : [null];
    return imgs.map(function (url) {
      // quantity 0 = unknown (legacy payload) — suppresses the qty badge.
      return { title: '', variant: null, quantity: 0, image: url, product_id: null };
    });
  }

  function thumbTile(item) {
    const t = tplThumb.content.cloneNode(true);
    const imgWrap = t.querySelector('[data-thumb-img]');
    if (item.image) {
      const img = document.createElement('img');
      img.src = imgUrl(item.image, 200);
      img.alt = '';
      img.loading = 'lazy';
      imgWrap.replaceChildren(img);
    }
    const qty = t.querySelector('[data-thumb-qty]');
    if (item.quantity > 0) { qty.textContent = 'x' + item.quantity; } else { qty.remove(); }
    return t;
  }

  function moreTile(count) {
    const t = tplThumb.content.cloneNode(true);
    const tile = t.querySelector('.aco__thumb');
    tile.classList.add('aco__thumb--more');
    t.querySelector('[data-thumb-img]').textContent = labelFor('more_thumbs').replace('[count]', count);
    t.querySelector('[data-thumb-qty]').remove();
    return t;
  }

  function renderBody(bodyEl, items) {
    if (items.length === 1 && items[0].title) {
      // Single line item — full detail (image + title / options / qty).
      const it = items[0];
      const t = tplItem.content.cloneNode(true);
      if (it.image) {
        const img = document.createElement('img');
        img.src = imgUrl(it.image, 200);
        img.alt = '';
        img.loading = 'lazy';
        t.querySelector('[data-item-img]').replaceChildren(img);
      }
      t.querySelector('[data-item-title]').textContent = it.title;
      const variantEl = t.querySelector('[data-item-variant]');
      if (it.variant) {
        variantEl.textContent = it.variant.split(' / ').join('  |  ');
        variantEl.hidden = false;
      }
      t.querySelector('[data-item-qty]').textContent = labelFor('qty').replace('[count]', it.quantity);
      bodyEl.replaceChildren(t);
      return;
    }
    // Multi-item (or legacy payload) — thumbnail row with qty badges.
    const wrap = document.createElement('div');
    wrap.className = 'aco__thumbs';
    const max = maxThumbs();
    const visible = items.length > max + 1 ? items.slice(0, max) : items;
    visible.forEach(function (it) { wrap.appendChild(thumbTile(it)); });
    if (items.length > visible.length) wrap.appendChild(moreTile(items.length - visible.length));
    bodyEl.replaceChildren(wrap);
  }

  // Okendo hosted Response Form deep-link for ONE product of an order.
  // Only the deep-link that carries the order's reviewRequestId AND
  // elementId is worth showing: it prefills the customer's profile, marks
  // the review Verified Buyer and ties the review to THIS order. The store
  // disallows anonymous reviews, so a plain okendo.reviews link would make
  // the customer retype name/email (and rrid without elementId hard-errors
  // as anonymous). Until the lazy /review-info data lands — or when Okendo
  // hasn't generated the order's review request yet — show NO link.
  function writeReviewUrlFor(order, productId) {
    if (!order.review_request_id || !order.review_element_id) return null;
    const storeId = window.okendoSubscriberId && window.okendoSubscriberId();
    if (!storeId) return null;
    const locale = (document.documentElement.lang || navigator.language || 'en').slice(0, 2);
    return 'https://okendo.reviews/?subscriberId=' + encodeURIComponent(storeId) +
      '&productId=' + encodeURIComponent('shopify-' + productId) +
      '&locale=' + encodeURIComponent(locale) +
      '&reviewRequestId=' + encodeURIComponent(order.review_request_id) +
      '&elementId=' + encodeURIComponent(order.review_element_id);
  }

  // List-row WRITE A REVIEW button (same pattern as the PDP reviews CTA).
  // Only for finished orders with a known product.
  function reviewUrl(order, items) {
    if (order.status !== 'complete' && order.status !== 'delivered') return null;
    let withProduct = items.filter(function (it) { return it.product_id; });
    if (!withProduct.length) return null;
    // Okendo reviews one product per form — target the first product the
    // customer has NOT reviewed IN THIS ORDER yet; once every product is
    // reviewed, hide the button. Reviewed set: the order's own ORDER-scoped
    // reviewed_product_ids (list rows, /order and /review-info?name= all
    // carry it); the per-customer set only as a stale-worker fallback;
    // unknown → first product.
    const reviewed = order.reviewed_product_ids || reviewedProductIds;
    if (Array.isArray(reviewed)) {
      withProduct = withProduct.filter(function (it) {
        return reviewed.indexOf(String(it.product_id)) === -1;
      });
      if (!withProduct.length) return null;
    }
    return writeReviewUrlFor(order, withProduct[0].product_id);
  }

  function renderRow(order) {
    const row = tplRow.content.cloneNode(true);
    const items = orderItems(order);

    row.querySelector('[data-name]').textContent = order.name || '';
    const link = row.querySelector('[data-row-link]');
    // Custom detail view (/pages/orders?order=<name>) — UI per Figma
    // 9844:139794. Set to false to fall back to the hosted order page.
    const USE_CUSTOM_DETAIL = true;
    const plainName = String(order.name || '').replace(/^#/, '');
    if (USE_CUSTOM_DETAIL && plainName) {
      // Internal detail view — pushState keeps the browser back button working.
      link.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'pages/orders?order=' + encodeURIComponent(plainName);
      const goDetail = function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        history.pushState({}, '', link.href);
        cameFromList = true;
        route();
      };
      link.addEventListener('click', goDetail);
      // The line-items block is a large tap target for the same navigation.
      // Guard against inner controls in case the body ever grows links.
      const body = row.querySelector('[data-body]');
      body.classList.add('aco__body--link');
      body.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        goDetail(e);
      });
    } else if (order.url) {
      link.href = order.url;
    } else {
      link.removeAttribute('href');
    }
    row.querySelector('[data-status]').textContent = labelFor(order.status);

    renderBody(row.querySelector('[data-body]'), items);

    row.querySelector('[data-total]').textContent = formatMoney(order.total && order.total.amount, order.total && order.total.currency);

    const review = row.querySelector('[data-review]');
    const rUrl = reviewUrl(order, items);
    if (rUrl) { review.href = rUrl; review.hidden = false; }

    // START A RETURN — outline button beside WRITE A REVIEW (Figma
    // 9702:134516). Worker nulls return_url for unfulfilled/cancelled orders;
    // hide again once the return went through (same guard as the detail view).
    const returnBtn = row.querySelector('[data-return]');
    if (order.return_url && order.return_status !== 'RETURNED') {
      returnBtn.href = order.return_url;
      returnBtn.hidden = false;
    }

    const buyBtn = row.querySelector('[data-buy-again]');
    buyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      buyAgain(order.reorder_items, buyBtn);
    });

    // "..." dropdown — hosted Shopify order status page, plus (mobile-only)
    // Start a return when three text buttons would crowd the card: CSS hides
    // the outline button and shows the menu item ≤768px instead.
    const moreWrap = row.querySelector('.aco__more');
    const moreBtn = row.querySelector('[data-more-toggle]');
    const menu = row.querySelector('[data-more-menu]');
    const hostedItem = row.querySelector('[data-menu-hosted]');
    const menuReturn = row.querySelector('[data-menu-return]');
    const threeActions = !review.hidden && !returnBtn.hidden;
    if (threeActions) {
      // row is the template fragment — the class goes on the card <li>.
      row.querySelector('.aco__card').classList.add('aco__card--three-actions');
      menuReturn.href = order.return_url;
      menuReturn.hidden = false;
    }
    if (!order.url && !threeActions) {
      // Nothing the menu could ever show → no "..." at all.
      moreWrap.remove();
      return row;
    }
    if (order.url) {
      hostedItem.href = order.url;
      hostedItem.hidden = false;
    } else {
      // Menu only holds the mobile return item — desktop hides the "...".
      moreWrap.classList.add('aco__more--mobile-only');
    }
    moreBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      const wasOpen = openMenu && openMenu.menu === menu;
      closeOpenMenu();
      if (!wasOpen) {
        menu.hidden = false;
        moreBtn.setAttribute('aria-expanded', 'true');
        openMenu = { menu: menu, btn: moreBtn };
      }
    });
    return row;
  }

  document.addEventListener('click', function (e) {
    if (openMenu && !openMenu.menu.contains(e.target)) closeOpenMenu();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOpenMenu();
  });

  /* QA BUG-BV-27: this returned a bare boolean, so every failure looked identical and
     the caller reported them all as "item unavailable" — including 429 throttling, which
     is the one case where the item is perfectly in stock and a retry would work. Return
     the status so the caller can tell "sold out" (422) from "try again" (429/5xx/network),
     and absorb a throttle with one short backoff before giving up. */
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  async function addToCart(payload, allowRetry) {
    let status = 0;
    try {
      const res = await fetch(LOCALE_ROOT + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (res.ok) return { ok: true, status: res.status };
      status = res.status;
    } catch (e) {
      status = 0; // network/abort
    }
    /* 429 is a burst limit, not a verdict on the item — retry once after a short wait. */
    if (allowRetry !== false && (status === 429 || status >= 500 || status === 0)) {
      await sleep(1200);
      return addToCart(payload, false);
    }
    return { ok: false, status: status };
  }

  // Re-add the order's line items to the cart, then go to the cart. Shopify's
  // cart API rejects concurrent writes to one cart (409) and throttles bursts
  // (429), so never add in parallel — that silently dropped items (#BO101933).
  // One atomic items-array request first; any unavailable item 422s the whole
  // batch, so on failure retry one-by-one, skipping items that still fail
  // (sold out / delisted) and telling the customer how many were skipped.
  async function buyAgain(items, btn) {
    if (!items || !items.length) { window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart'; return; }
    btn.disabled = true;
    const adding = btn.getAttribute('data-label-adding');
    if (adding) btn.textContent = adding;
    let unavailable = 0; // 422 — genuinely not purchasable
    let transient = 0;   // 429 / 5xx / network — the item is fine, we are not
    const batch = await addToCart({
      items: items.map(function (it) { return { id: it.id, quantity: it.quantity }; })
    });
    if (!batch.ok) {
      for (let i = 0; i < items.length; i++) {
        const r = await addToCart({ id: items[i].id, quantity: items[i].quantity });
        if (!r.ok) { if (r.status === 422) unavailable++; else transient++; }
      }
    }
    /* QA BUG-BV-27: was a browser-native alert() that also blamed the customer's items
       for what were really throttling/network failures. Site toast now, and the two
       causes say different things. */
    if (unavailable || transient) {
      /* Prefer the unavailable message whenever anything is genuinely gone: "please try
         again" is actively misleading about a sold-out item. The retry wording is only
         right when EVERY failure was transient. */
      const msg = unavailable
        ? (btn.getAttribute('data-msg-unavailable') || '').replace('[count]', String(unavailable))
        : btn.getAttribute('data-msg-retry');
      if (msg && window.__showQuickAddToast) window.__showQuickAddToast(msg, true);
    }
    window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
  }

  function filteredOrders() {
    if (!query) return allOrders;
    const q = query.replace(/^#/, '').toLowerCase();
    return allOrders.filter(function (o) {
      return String(o.name || '').replace(/^#/, '').toLowerCase().indexOf(q) !== -1;
    });
  }

  function render() {
    closeOpenMenu();
    const list = filteredOrders();
    const totalPages = Math.max(1, Math.ceil(list.length / PAGE_SIZE));
    if (page > totalPages) page = totalPages;

    if (list.length === 0) {
      show((query ? tplNoResults : tplEmpty).content.cloneNode(true));
      renderPagination(0);
      return;
    }
    const start = (page - 1) * PAGE_SIZE;
    const wrap = tplList.content.cloneNode(true);
    const ul = wrap.querySelector('[data-orders-list]');
    list.slice(start, start + PAGE_SIZE).forEach(function (o) { ul.appendChild(renderRow(o)); });
    show(wrap);
    renderPagination(totalPages);
  }

  function goTo(p) {
    page = p;
    render();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function navButton(dir, p, disabled) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'aco__page aco__page--nav';
    b.innerHTML = dir === 'prev'
      ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>'
      : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';
    if (disabled) { b.disabled = true; }
    else { b.addEventListener('click', function () { goTo(p); }); }
    return b;
  }

  function pageButton(p, active) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'aco__page' + (active ? ' aco__page--active' : '');
    b.textContent = String(p);
    if (active) b.setAttribute('aria-current', 'page');
    b.addEventListener('click', function () { goTo(p); });
    return b;
  }

  // 1 … (p-1) p (p+1) … N
  function pageList(current, total) {
    const out = [];
    const lo = Math.max(2, current - 1);
    const hi = Math.min(total - 1, current + 1);
    out.push(1);
    if (lo > 2) out.push('…');
    for (var p = lo; p <= hi; p++) out.push(p);
    if (hi < total - 1) out.push('…');
    if (total > 1) out.push(total);
    return out;
  }

  function renderPagination(totalPages) {
    paginationEl.replaceChildren();
    if (totalPages < 2) { paginationEl.hidden = true; return; }
    paginationEl.hidden = false;

    paginationEl.appendChild(navButton('prev', page - 1, page <= 1));
    pageList(page, totalPages).forEach(function (p) {
      if (p === '…') {
        const span = document.createElement('span');
        span.className = 'aco__page-ellipsis';
        span.textContent = '…';
        paginationEl.appendChild(span);
      } else {
        paginationEl.appendChild(pageButton(p, p === page));
      }
    });
    paginationEl.appendChild(navButton('next', page + 1, page >= totalPages));
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      query = searchInput.value.trim();
      page = 1;
      render();
    });
  }

  // Cross-domain market hint: GB/NZ markets are served from their own ccTLD
  // domains (their localization cookie + storefront session don't carry over),
  // so a customer whose orders ship there sees this site fall back to
  // IP-detected US. Suggest the domain matching the latest order's country.
  // Only runs on the known production hosts — never on preview/test domains.
  const MARKET_HOSTS = { GB: 'www.bonvale.co.uk', NZ: 'www.bonvale.co.nz', default: 'www.bonvale.com' };
  const MARKET_DISMISS_KEY = 'bonvale_market_banner_dismissed';

  function maybeShowMarketBanner(orders) {
    const banner = root.querySelector('[data-orders-market-banner]');
    if (!banner || !orders.length) return;
    try { if (sessionStorage.getItem(MARKET_DISMISS_KEY) === '1') return; } catch (e) {}

    const knownHosts = Object.keys(MARKET_HOSTS).map(function (k) { return MARKET_HOSTS[k]; });
    if (knownHosts.indexOf(location.hostname) === -1) return;

    const country = orders[0].shipping_country;
    if (!country) return;
    const targetHost = MARKET_HOSTS[country] || MARKET_HOSTS.default;
    if (targetHost === location.hostname) return;

    const siteKey = country === 'GB' ? 'market_site_gb' : country === 'NZ' ? 'market_site_nz' : 'market_site_default';
    const site = labelFor(siteKey);
    banner.querySelector('[data-market-text]').textContent = labelFor('market_banner_text').replace('[site]', site);
    const cta = banner.querySelector('[data-market-cta]');
    cta.textContent = labelFor('market_banner_cta').replace('[site]', site);
    cta.href = 'https://' + targetHost + location.pathname + location.search;

    const dismiss = banner.querySelector('[data-market-dismiss]');
    if (dismiss) {
      dismiss.addEventListener('click', function () {
        banner.hidden = true;
        try { sessionStorage.setItem(MARKET_DISMISS_KEY, '1'); } catch (e) {}
      }, { once: true });
    }
    banner.hidden = false;
  }

  // ── Order detail view (?order=<name>) ──
  // Client-side route swap over the same page: the list stays rendered
  // underneath (hidden), so browser back = popstate = instant return.
  const EVENT_STATUS = {
    CONFIRMED: 'confirmed',
    IN_TRANSIT: 'on_its_way',
    OUT_FOR_DELIVERY: 'out_for_delivery',
    DELIVERED: 'delivered',
    ATTEMPTED_DELIVERY: 'attempted_delivery',
    LABEL_PRINTED: 'label_created',
    LABEL_PURCHASED: 'label_created',
    READY_FOR_PICKUP: 'ready_for_pickup',
    PICKED_UP: 'picked_up',
    CARRIER_PICKED_UP: 'carrier_picked_up',
    DELAYED: 'delayed',
    FAILURE: 'failure'
  };

  // Fulfillment displayStatus → status key, for shipments with no carrier
  // events yet (digital goods never get any — gift cards show "Complete"
  // like the hosted order page).
  const FULFILLMENT_STATUS = {
    DELIVERED: 'delivered',
    OUT_FOR_DELIVERY: 'out_for_delivery',
    IN_TRANSIT: 'on_its_way',
    ATTEMPTED_DELIVERY: 'attempted_delivery',
    READY_FOR_PICKUP: 'ready_for_pickup',
    PICKED_UP: 'picked_up',
    CARRIER_PICKED_UP: 'carrier_picked_up',
    DELAYED: 'delayed',
    LABEL_PRINTED: 'label_created',
    LABEL_PURCHASED: 'label_created',
    NOT_DELIVERED: 'failure',
    FAILURE: 'failure'
    // MARKED_AS_FULFILLED / FULFILLED deliberately absent: those decide by
    // tracking number below — tracked shipment reads "On its way" (hosted
    // parity), untracked/digital reads "Complete".
  };

  // Current-milestone badge glyph (Figma 12539:43990 / :44250 / :44674):
  // truck when out for delivery, dots-horizontal while the parcel is between
  // scans, rotating arrows for an open return, check otherwise.
  const TRUCK_KEYS = { out_for_delivery: 1, carrier_picked_up: 1, picked_up: 1 };
  const DOTS_KEYS = {
    on_its_way: 1, return_completed: 1, kec_info_received: 1, kec_at_facility: 1,
    kec_in_transit: 1, kec_customs: 1, kec_customs_cleared: 1, kec_departed: 1,
    kec_arrived_country: 1, kec_local_facility: 1, kec_returning: 1
  };
  const REFRESH_KEYS = { return_in_progress: 1, return_requested: 1, refunded: 1, partially_refunded: 1 };
  const CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
  const EXTERNAL_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';
  const TRUCK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  const DOTS_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="5" cy="12" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="19" cy="12" r="1.8"/></svg>';
  const REFRESH_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>';

  // Known gateway handles → localized labels; anything else is humanized
  // (e.g. the test store's "bogus" gateway → "Bogus").
  const GATEWAY_LABELS = { shopify_payments: 'payment_credit_card', paypal: 'payment_paypal', gift_card: 'payment_gift_card' };
  function paymentLabel(gateway) {
    if (GATEWAY_LABELS[gateway]) return labelFor(GATEWAY_LABELS[gateway]);
    const s = String(gateway).replace(/[_-]+/g, ' ');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function el(tag, cls, text) {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  // The sidebar's "My Orders" is a non-link <span> on this page (active
  // item); while the detail view is open it acts as a back-to-list control —
  // same behavior as the back arrow.
  const sidebarActive = document.querySelector('.gc-view__sidebar .gc-view__nav-item--active');

  function listChrome(visible) {
    // CSS-driven (see .aco--detail rules): list chrome keeps managing its own
    // hidden attributes (async loads, pagination) without leaking into the
    // detail view.
    root.classList.toggle('aco--detail', !visible);
    if (sidebarActive) sidebarActive.classList.toggle('acd-sidebar-back', !visible);
  }

  if (sidebarActive) {
    sidebarActive.addEventListener('click', function () {
      if (!root.classList.contains('aco--detail')) return;
      if (cameFromList) {
        history.back();
      } else {
        history.replaceState({}, '', ordersUrl());
        route();
      }
    });
  }

  // Message state rendered as a centered card (hosted-page style: bold
  // title + explanation).
  function detailMessage(text, isError, title) {
    detailEl.replaceChildren();
    const frag = tplDetail.content.cloneNode(true);
    frag.querySelector('[data-detail-name]').textContent = currentDetailName;
    frag.querySelector('.acd__actions').remove();
    frag.querySelector('[data-detail-help]').remove();
    const back = frag.querySelector('[data-detail-back]');
    wireBack(back);
    const card = el('div', 'acd__msg-card');
    if (title) card.appendChild(el('p', 'acd__msg-title', title));
    card.appendChild(el('p', 'acd__msg-text' + (isError ? ' acd__msg-text--error' : ''), text));
    frag.querySelector('[data-detail-cards]').appendChild(card);
    detailEl.appendChild(frag);
  }

  function wireBack(back) {
    back.href = ordersUrl();
    back.addEventListener('click', function (e) {
      e.preventDefault();
      if (cameFromList) {
        history.back();
      } else {
        history.replaceState({}, '', ordersUrl());
        route();
      }
    });
  }

  function detailSection(cls) {
    return el('div', 'acd__sec' + (cls ? ' ' + cls : ''));
  }

  function milestone(key, date, current, location, extra) {
    const li = el('li', 'acd__ms' + (current ? ' acd__ms--current' : ''));
    const icon = el('span', 'acd__ms-icon' + (current ? ' acd__ms-icon--badge' : ''));
    if (current) {
      icon.innerHTML = TRUCK_KEYS[key] ? TRUCK_SVG
        : DOTS_KEYS[key] ? DOTS_SVG
        : REFRESH_KEYS[key] ? REFRESH_SVG
        : CHECK_SVG;
    }
    li.appendChild(icon);
    const text = el('span', 'acd__ms-text');
    if (extra) {
      // Heading row with the delivery info pushed right (Figma 12539:44137).
      const head = el('span', 'acd__ms-heading');
      head.appendChild(el('p', 'acd__ms-label', labelFor(key)));
      head.appendChild(extra);
      text.appendChild(head);
    } else {
      text.appendChild(el('p', 'acd__ms-label', labelFor(key)));
    }
    const when = formatDateTime(date);
    if (when || location) {
      text.appendChild(el('p', 'acd__ms-date', when + (location ? (when ? ' · ' : '') + location : '')));
    }
    li.appendChild(text);
    return li;
  }

  // Delivery info header row — tracking number only (deliberately NO carrier
  // name and NO link-out). "Track your order" opens the trajectory modal;
  // when the carrier has no scans yet it shows a "no updates yet" note.
  function deliveryRow(f, order) {
    const row = el('div', 'acd__delivery');
    row.appendChild(el('span', 'acd__delivery-label', labelFor('detail_delivery_info')));
    row.appendChild(el('span', 'acd__delivery-value', f.number || ''));
    if (f.number) {
      // "Track Your Orders" + external icon per Figma 9844:139811 (opens the
      // in-page modal — the icon is kept for design parity).
      const track = el('button', 'acd__track');
      track.type = 'button';
      track.appendChild(el('span', null, labelFor('detail_track')));
      const icon = el('span', 'acd__track-icon');
      icon.innerHTML = EXTERNAL_SVG;
      track.appendChild(icon);
      track.addEventListener('click', function () {
        // Late-bound: the KEC fetch may still be in flight on early clicks —
        // openTrackingModal waits it out rather than opening empty (BV-40).
        openTrackingModal(order, track);
      });
      row.appendChild(track);
    }
    return row;
  }

  // Inline "Delivery info <no> ↗" on a timeline's current milestone — split
  // orders carry per-shipment tracking there instead of the standalone row
  // (Figma 12539:44150). Same modal entry point as deliveryRow; deliberately
  // still no carrier identity.
  function deliveryInline(f, order) {
    const btn = el('button', 'acd__ms-delivery');
    btn.type = 'button';
    btn.appendChild(el('span', 'acd__ms-delivery-label', labelFor('detail_delivery_info')));
    btn.appendChild(el('span', 'acd__ms-delivery-value', f.number));
    const icon = el('span', 'acd__ms-delivery-icon');
    icon.innerHTML = EXTERNAL_SVG;
    btn.appendChild(icon);
    btn.addEventListener('click', function () {
      // Late-bound: the KEC fetch may still be in flight on early clicks —
      // openTrackingModal waits it out rather than opening empty (BV-40).
      openTrackingModal(order, btn);
    });
    return btn;
  }

  // Return flavour — the merchant-entered return tracking links out to the
  // carrier when a URL exists (returns have no KEC trajectory to show).
  function returnDeliveryInline(r) {
    const node = el(r.tracking_url ? 'a' : 'span', 'acd__ms-delivery');
    node.appendChild(el('span', 'acd__ms-delivery-label', labelFor('detail_delivery_info')));
    node.appendChild(el('span', 'acd__ms-delivery-value', r.tracking_number));
    if (r.tracking_url) {
      node.href = r.tracking_url;
      node.target = '_blank';
      node.rel = 'noopener';
      const icon = el('span', 'acd__ms-delivery-icon');
      icon.innerHTML = EXTERNAL_SVG;
      node.appendChild(icon);
    }
    return node;
  }

  // ── Carrier trajectory drawer ──
  // The drawer itself is the global snippet (window.BonvaleTrackDrawer,
  // rendered in theme.liquid). Here we just hand it the order's already-loaded
  // trajectory in "customer" mode (order number prefilled + read-only).
  // number → shipment from the worker's KEC pull, reset per detail render.
  let kecShipments = {};
  /* QA BUG-BV-40: kecShipments is filled by an async worker call, but the
     "Track your order" buttons render immediately and read it on click. Click
     inside that window (~200ms is enough) and the drawer opened with an empty
     shipments array — no trajectory, no explanation, and no way to tell it apart
     from an order that genuinely has no scans yet.

     kecPending holds the in-flight pull so an early click can WAIT for it
     instead of racing it. Null means "nothing in flight", which covers both
     before-start and after-settle. */
  let kecPending = null;

  function openTrackingModal(order, btn) {
    if (!window.BonvaleTrackDrawer) return;

    function show() {
      window.BonvaleTrackDrawer.open({
        mode: 'customer',
        orderNumber: String(order.name || currentDetailName || '').replace(/^#/, ''),
        shipments: Object.keys(kecShipments).map(function (k) { return kecShipments[k]; }),
        processedAt: orderDate(order),
      });
    }

    if (!kecPending) { show(); return; }

    /* Data still loading: hold the click. Disable the button so a second tap
       can't stack another open, and mark it so the CSS can show it as busy. */
    const waitOn = kecPending;
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
    }
    waitOn.then(function () {
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
      show();
    });
  }

  // Timeline from the fulfillment's carrier events (worker returns them
  // newest-first); "Confirmed" (order placed) is always the base node.
  function statusSection(order, f, delivery) {
    const s = detailSection();
    // Marked so loadKecTracking can swap in the carrier trajectory later.
    s.setAttribute('data-status-sec', '');
    if (f && f.number) s.setAttribute('data-number', f.number);
    if (order.cancelled_at) {
      s.appendChild(el('p', 'acd__cancelled', labelFor('cancelled')));
      s.appendChild(el('p', 'acd__cancelled-note', labelFor('detail_cancelled')));
      s.appendChild(el('p', 'acd__ms-date', formatDateTime(order.cancelled_at)));
      return s;
    }
    let events = [];
    if (f) {
      if (f.events && f.events.length) {
        // Shopify adds a default CONFIRMED event when a fulfillment is
        // created — drop those (the base "Confirmed" node below already
        // covers order confirmation) so the label can't duplicate.
        events = f.events
          .map(function (e) {
            return { key: EVENT_STATUS[e.status] || String(e.status).toLowerCase(), date: e.happened_at };
          })
          .filter(function (ev) { return ev.key !== 'confirmed'; });
      }
      if (!events.length) {
        // No real carrier progress: milestone from the fulfillment itself —
        // tracked shipments read "On its way", digital fulfillments (gift
        // cards) read "Complete" like the hosted order page.
        const key = FULFILLMENT_STATUS[f.display_status] || (f.number ? 'on_its_way' : 'complete');
        events = [{ key: key, date: f.created_at }];
      }
    }
    if (orderDate(order) || !events.length) {
      events.push({ key: 'confirmed', date: orderDate(order) });
    }
    /* BUG-BV-53: a refund is the most recent thing that happened to the money, so it
       leads the timeline. Placed with unshift rather than sorted in: carrier events
       carry scan timestamps from a different clock than the refund, and an ordering
       flip would put "Refunded" under "Delivered" on the strength of a few seconds.
       REFUNDED vs PARTIALLY_REFUNDED comes from Shopify's own financial status — the
       amounts alone cannot tell a full refund from a partial one on an edited order. */
    const lastRefund = (t2 => t2 && t2.refunds && t2.refunds.length ? t2.refunds[t2.refunds.length - 1] : null)(order.totals);
    if (lastRefund) {
      const fs = (order.totals || {}).financial_status;
      events.unshift({ key: fs === 'PARTIALLY_REFUNDED' ? 'partially_refunded' : 'refunded', date: lastRefund.refunded_at });
    }
    // Awaiting fulfillment: a dashed stub above the milestone hints at the
    // steps to come (Figma 9721:134767).
    const list = el('ul', 'acd__timeline' + (f ? '' : ' acd__timeline--pending'));
    events.forEach(function (ev, i) {
      list.appendChild(milestone(ev.key, ev.date, i === 0, null, i === 0 ? delivery : null));
    });
    s.appendChild(list);
    return s;
  }

  // Return card section — hosted order status page parity: returned-item
  // thumbnails, a return timeline (requested → in progress → completed with
  // the refunded amount), and, while the return is open, the merchant's
  // return shipping info (tracking number + Print shipping label).
  // Worker payload: order.returns[] (empty until the store token has
  // read_returns — the section simply doesn't render then).
  function returnMilestone(labelKey, note, date, current) {
    const li = milestone(labelKey, date, current);
    if (note) {
      const text = li.querySelector('.acd__ms-text');
      text.insertBefore(el('p', 'acd__ms-note', note), text.querySelector('.acd__ms-date'));
    }
    return li;
  }

  // Return card (Figma 12539:44674) — full item cards over the return
  // timeline; while the return is open the merchant's return tracking sits
  // inline on the current milestone and the dashed stub above hints at the
  // steps to come.
  function returnSection(order, r) {
    const s = detailSection('acd__sec--return');

    if (r.items && r.items.length) {
      s.appendChild(sectionItems(order, r.items, { review: false }));
    }

    const open = r.status === 'OPEN' || r.status === 'REQUESTED';
    const delivery = open && r.tracking_number ? returnDeliveryInline(r) : null;
    const list = el('ul', 'acd__timeline' + (open ? ' acd__timeline--pending' : ''));
    const refundedNote = r.total_refunded
      ? labelFor('detail_return_refunded').replace('[amount]', formatMoney(r.total_refunded.amount, r.total_refunded.currency))
      : null;
    if (r.status === 'CLOSED') {
      list.appendChild(returnMilestone('return_completed', refundedNote, r.refunded_at || r.closed_at, true));
      list.appendChild(milestone('return_in_progress', r.requested_at, false));
    } else if (r.status === 'DECLINED') {
      list.appendChild(milestone('return_declined', r.closed_at || r.requested_at, true));
      list.appendChild(milestone('return_requested', r.requested_at, false));
    } else if (r.status === 'REQUESTED') {
      list.appendChild(milestone('return_requested', r.requested_at, true, null, delivery));
    } else {
      // OPEN (and any unknown future status): the return is in progress.
      list.appendChild(milestone('return_in_progress', r.requested_at, true, null, delivery));
    }
    s.appendChild(list);

    // Merchant-provided return label — only meaningful while the customer
    // still has to send the parcel back.
    if (open && r.label_url) {
      s.appendChild(el('p', 'acd__return-note', labelFor('detail_return_approved')));
      const btn = el('a', 'aco__btn aco__btn--outline acd__return-label-btn', labelFor('detail_return_label'));
      btn.href = r.label_url;
      btn.target = '_blank';
      btn.rel = 'noopener';
      s.appendChild(btn);
    }
    return s;
  }

  // --- Per-item review row (Figma 9924:147319) ---
  // Reviewed items show the customer's star rating + "See your review" (PDP
  // reviews section); unreviewed items in a finished order show empty stars
  // + a per-product Verified-Buyer "Write a review" deep-link. Each item gets
  // a placeholder slot so the lazy /review-info upgrade can re-render in
  // place once the reviewed set / reviewRequestId lands.
  let detailReviewSlots = [];
  // line_id → true once a card carried the review row this render (a line
  // split across packages must not repeat it).
  let detailReviewLines = {};

  function starsNode(filledCount) {
    const wrap = el('span', 'acd__stars');
    let html = '';
    for (let i = 1; i <= 5; i++) {
      html += '<svg width="14" height="14" viewBox="0 0 14 14" style="overflow:visible" aria-hidden="true" ' +
        (i <= filledCount
          ? 'fill="currentColor"'
          : 'fill="none" stroke="currentColor" stroke-width="1" stroke-linejoin="round"') +
        '><path d="M7 0.56l1.79 4.14 4.46.36c.54.04.66.38.24.74L10.1 8.62l1.08 4.56c.13.54-.15.74-.63.44L7 11.22l-3.55 2.4c-.48.3-.76.1-.63-.44l1.08-4.56L.51 5.8c-.42-.36-.3-.7.24-.74l4.46-.36L7 0.56z"/></svg>';
    }
    wrap.innerHTML = html;
    return wrap;
  }

  function itemReviewNode(order, it) {
    if (order.status !== 'complete' && order.status !== 'delivered') return null;
    if (!it.product_id) return null;
    // Reviewed set: reviewed_items ({product_id, rating}) from a current
    // worker; plain reviewed_product_ids as the stale-worker fallback.
    let entry = null;
    if (Array.isArray(order.reviewed_items)) {
      entry = order.reviewed_items.find(function (x) {
        return String(x.product_id) === String(it.product_id);
      }) || null;
    } else if (
      Array.isArray(order.reviewed_product_ids) &&
      order.reviewed_product_ids.indexOf(String(it.product_id)) !== -1
    ) {
      entry = { rating: null };
    }
    // Reviewed but still in Okendo moderation: show NOTHING — the PDP
    // reviews widget can't display an unpublished review, and Okendo
    // rejects a second review for the product, so neither link is usable.
    if (entry && entry.published === false) return null;
    const box = el('div', 'acd__item-review');
    const row = el('div', 'acd__item-review-row');
    if (entry) {
      const rating = Math.round(Number(entry.rating));
      if (rating >= 1 && rating <= 5) {
        const stars = starsNode(rating);
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', rating + '/5');
        row.appendChild(stars);
      }
      if (it.product_handle) {
        const a = el('a', 'acd__item-review-link', labelFor('see_your_review'));
        // ?okrev=<reviewId> lets the PDP reviews widget highlight + center
        // the customer's own review; without it the hash still scrolls to
        // the reviews section.
        const okrev = entry.review_id ? '?okrev=' + encodeURIComponent(entry.review_id) : '';
        a.href = rootUrl + '/products/' + it.product_handle + okrev + '#okendo-reviews-' + it.product_id;
        row.appendChild(a);
      }
      if (!row.childNodes.length) return null; // no rating known, no PDP link
      box.appendChild(el('p', 'acd__item-review-label', labelFor('your_review')));
    } else {
      const url = writeReviewUrlFor(order, it.product_id);
      if (!url) return null; // reviewed set / request id not loaded (yet)
      row.appendChild(starsNode(0));
      const a = el('a', 'acd__item-review-link', labelFor('write_review'));
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      row.appendChild(a);
      box.appendChild(el('p', 'acd__item-review-label', labelFor('how_is_it')));
    }
    box.appendChild(row);
    return box;
  }

  function renderItemReview(slot, order, it) {
    slot.replaceChildren();
    const node = itemReviewNode(order, it);
    if (node) slot.appendChild(node);
  }

  function applyItemReviews(order) {
    detailReviewSlots.forEach(function (s) { renderItemReview(s.slot, order, s.item); });
  }

  // One full item card (image+qty / title+variant+review / unit price) —
  // shared by the order summary on single-shipment orders and the
  // per-package / per-return blocks on split orders (Figma 12539:44031).
  function itemCard(order, it, opts) {
    opts = opts || {};
    const row = el('div', 'acd__item');
    const imgWrap = el(it.product_handle ? 'a' : 'span', 'acd__item-img');
    if (it.product_handle) imgWrap.href = rootUrl + '/products/' + it.product_handle;
    if (it.image) {
      const img = document.createElement('img');
      img.src = imgUrl(it.image, 200);
      img.alt = '';
      img.loading = 'lazy';
      imgWrap.appendChild(img);
    }
    imgWrap.appendChild(el('span', 'acd__item-qty', 'x' + it.quantity));
    row.appendChild(imgWrap);
    const main = el('div', 'acd__item-main');
    main.appendChild(el('p', 'acd__item-title', it.title));
    if (it.variant) main.appendChild(el('p', 'acd__item-variant', it.variant.split(' / ').join('  |  ')));
    // A line split across several packages still gets exactly one review row.
    if (opts.review !== false && !(it.line_id && detailReviewLines[it.line_id])) {
      if (it.line_id) detailReviewLines[it.line_id] = true;
      const reviewSlot = el('div', 'acd__item-review-slot');
      detailReviewSlots.push({ slot: reviewSlot, item: it });
      renderItemReview(reviewSlot, order, it);
      main.appendChild(reviewSlot);
    }
    row.appendChild(main);
    // Per-unit price, discounted shown in promo red over the struck original
    // (Figma 9844:139262). Line totals are the fallback for a stale worker;
    // a return item that couldn't be joined back to its order line has no
    // price to show.
    const unit = it.unit_price || it.discounted_total;
    const unitOrig = it.unit_price_original || it.original_total;
    if (unit) {
      const price = el('div', 'acd__item-price');
      const cur = Number(unit.amount);
      const orig = unitOrig ? Number(unitOrig.amount) : NaN;
      if (isFinite(cur) && isFinite(orig) && orig - cur > 0.004) {
        price.appendChild(el('p', 'acd__price acd__price--promo', formatMoney(unit.amount, unit.currency)));
        price.appendChild(el('p', 'acd__price-original', formatMoney(unitOrig.amount, unitOrig.currency)));
      } else {
        price.appendChild(el('p', 'acd__price', formatMoney(unit.amount, unit.currency)));
      }
      row.appendChild(price);
    }
    return row;
  }

  // Shipment items join back to their order line on line_id; return items
  // (no line_id in the payload) fall back to title+variant. The order line
  // supplies price/product metadata, the package supplies the quantity.
  function resolveItem(order, ref) {
    const items = order.items || [];
    let full = null;
    if (ref.line_id) {
      full = items.find(function (it) { return String(it.line_id) === String(ref.line_id); }) || null;
    } else {
      full = items.find(function (it) {
        return it.title === ref.title && (it.variant || null) === (ref.variant || null);
      }) || null;
    }
    return full ? Object.assign({}, full, { quantity: ref.quantity }) : ref;
  }

  // Full item cards heading a package / return block (Figma 12539:44008).
  function sectionItems(order, items, opts) {
    const wrap = el('div', 'acd__items acd__sec-items');
    items.forEach(function (ref) {
      wrap.appendChild(itemCard(order, resolveItem(order, ref), opts));
    });
    return wrap;
  }

  function summarySection(order, includeItems) {
    const s = detailSection();
    s.appendChild(el('p', 'acd__sec-label', labelFor('detail_summary')));

    // Split orders list their items per package above — the summary keeps
    // only the money rows then (Figma 12539:43936).
    if (includeItems) {
      const items = el('div', 'acd__items');
      (order.items || []).forEach(function (it) {
        items.appendChild(itemCard(order, it));
      });
      s.appendChild(items);
    }

    const t = order.totals || {};
    const totals = el('div', 'acd__totals' + (includeItems ? '' : ' acd__totals--bare'));
    function trow(label, valueNode) {
      const row = el('div', 'acd__trow');
      row.appendChild(el('span', 'acd__trow-label', label));
      row.appendChild(valueNode);
      totals.appendChild(row);
    }

    if (t.subtotal) trow(labelFor('detail_subtotal'), el('span', null, formatMoney(t.subtotal.amount, t.subtotal.currency)));

    if (t.shipping_original || t.shipping_current) {
      const val = el('span');
      const orig = t.shipping_original ? Number(t.shipping_original.amount) : 0;
      const cur = t.shipping_current ? Number(t.shipping_current.amount) : orig;
      if (orig > cur) {
        val.appendChild(el('span', 'acd__shipping-original', formatMoney(t.shipping_original.amount, t.shipping_original.currency)));
      }
      val.appendChild(document.createTextNode(cur > 0 ? formatMoney(t.shipping_current.amount, t.shipping_current.currency) : labelFor('detail_free')));
      trow(labelFor('detail_shipping'), val);
    }

    // One row per discount application — "Discount (EARLYBIRD) -$12.70"
    // (Figma 9844:139293). Aggregate row is the stale-worker fallback.
    if (t.discounts && t.discounts.length) {
      t.discounts.forEach(function (d) {
        trow(
          labelFor('detail_order_discount') + (d.label ? ' (' + d.label + ')' : ''),
          el('span', null, '-' + formatMoney(d.amount.amount, d.amount.currency))
        );
      });
    } else if (t.order_discount) {
      const codes = (t.discount_codes || []).join(', ');
      trow(
        labelFor('detail_order_discount') + (codes ? ' (' + codes + ')' : ''),
        el('span', null, '-' + formatMoney(t.order_discount.amount, t.order_discount.currency))
      );
    }

    if (t.tax) trow(labelFor('detail_taxes'), el('span', null, formatMoney(t.tax.amount, t.tax.currency)));

    if (t.total) {
      const row = el('div', 'acd__trow acd__trow--total');
      row.appendChild(el('span', null, labelFor('detail_total')));
      const val = el('div', 'acd__tval');
      val.appendChild(el('p', null, formatMoney(t.total.amount, t.total.currency)));
      if (t.savings) {
        val.appendChild(el('p', 'acd__savings', labelFor('detail_savings').replace('[amount]', formatMoney(t.savings.amount, t.savings.currency))));
      }
      row.appendChild(val);
      totals.appendChild(row);
    }

    /* QA BUG-BV-53: a plain admin Refund left no trace here — Shopify keeps the order
       total at its original value and records the money in totalRefundedSet, so the
       shopper saw "Total $70.00" on an order they had been refunded $30 of and had no
       way to tell the refund had happened. The Total row above stays as-is (it is not
       wrong, just incomplete); these two rows carry what was missing. Rendered AFTER
       the total so the reading order is charged → refunded → actually paid. */
    if (t.total_refunded) {
      trow(
        labelFor('detail_refunded'),
        el('span', 'acd__refunded', '-' + formatMoney(t.total_refunded.amount, t.total_refunded.currency))
      );
    }
    if (t.net_payment) {
      const row = el('div', 'acd__trow acd__trow--total');
      row.appendChild(el('span', null, labelFor('detail_net_payment')));
      const val = el('div', 'acd__tval');
      val.appendChild(el('p', null, formatMoney(t.net_payment.amount, t.net_payment.currency)));
      row.appendChild(val);
      totals.appendChild(row);
    }

    s.appendChild(totals);
    return s;
  }

  function paymentSection(order) {
    const s = detailSection('acd__sec--payment');
    function block(labelKey, valueNode) {
      const b = el('div', 'acd__block');
      b.appendChild(el('p', 'acd__block-label', labelFor(labelKey)));
      b.appendChild(valueNode);
      return b;
    }
    function addressValue(a) {
      const v = el('div', 'acd__block-value');
      if (a.name) v.appendChild(el('p', null, a.name));
      (a.lines || []).forEach(function (l) { v.appendChild(el('p', null, l)); });
      if (a.phone) v.appendChild(el('p', null, a.phone));
      return v;
    }
    function sameAddress(a, b) {
      if (!a || !b) return false;
      return JSON.stringify([a.name, a.lines, a.phone]) === JSON.stringify([b.name, b.lines, b.phone]);
    }

    // Per-transaction detail like the hosted page ("Gift card · 4E3H",
    // "$36.78 · date"); split payments produce one row each. Falls back to
    // the plain gateway list on a stale worker payload.
    if (order.payments && order.payments.length) {
      const v = el('div', 'acd__block-value acd__payments');
      order.payments.forEach(function (p) {
        const row = el('div', 'acd__payment');
        let label;
        if (p.gateway === 'gift_card') {
          label = labelFor('payment_gift_card') + (p.gift_card_last_chars ? ' · ' + p.gift_card_last_chars : '');
        } else if (p.card_company) {
          label = p.card_company + (p.card_last ? ' · ' + p.card_last : '');
        } else {
          label = paymentLabel(p.gateway);
        }
        row.appendChild(el('p', null, label));
        const meta = formatMoney(p.amount.amount, p.amount.currency) +
          (p.date ? ' · ' + formatDateTime(p.date) : '');
        row.appendChild(el('p', 'acd__payment-meta', meta));
        v.appendChild(row);
      });
      s.appendChild(block('detail_payment', v));
    } else if (order.payment_gateways && order.payment_gateways.length) {
      const v = el('div', 'acd__block-value');
      v.appendChild(el('p', null, order.payment_gateways.map(paymentLabel).join(', ')));
      s.appendChild(block('detail_payment', v));
    }

    if (order.customer_name || order.contact_email) {
      const v = el('div', 'acd__block-value');
      if (order.customer_name) v.appendChild(el('p', null, order.customer_name));
      if (order.contact_email) v.appendChild(el('p', null, order.contact_email));
      s.appendChild(block('detail_customer', v));
    }

    if (order.shipping_address || order.billing_address) {
      const grid = el('div', 'acd__addresses');
      if (order.shipping_address) {
        grid.appendChild(block('detail_shipping_address', addressValue(order.shipping_address)));
      }
      if (order.billing_address) {
        // Identical billing collapses to a note (Figma 9844:139399).
        const v = sameAddress(order.billing_address, order.shipping_address)
          ? (function () {
              const same = el('div', 'acd__block-value');
              same.appendChild(el('p', null, labelFor('detail_billing_same')));
              return same;
            })()
          : addressValue(order.billing_address);
        grid.appendChild(block('detail_billing_address', v));
      }
      s.appendChild(grid);
    }

    if (order.shipping_method) {
      const v = el('div', 'acd__block-value');
      v.appendChild(el('p', null, order.shipping_method));
      s.appendChild(block('detail_shipping_method', v));
    }
    return s;
  }

  // Order-scoped review metadata for the detail view — fetched lazily (the
  // reviewRequestId lookup behind it is slow). Re-renders each item's review
  // row once the reviewed set (with ratings) and the Verified Buyer
  // reviewRequestId land.
  async function loadReviewInfo(order, seq) {
    if (order.status !== 'complete' && order.status !== 'delivered') return;
    try {
      const name = String(order.name || '').replace(/^#/, '');
      const res = await fetch(reviewInfoEndpoint + '?name=' + encodeURIComponent(name), {
        headers: { Accept: 'application/json' }, credentials: 'same-origin'
      });
      if (seq !== detailSeq || !res.ok) return;
      const data = await res.json();
      if (seq !== detailSeq || data.status !== 'ok') return;
      order.review_request_id = data.review_request_id || null;
      order.review_element_id = data.review_element_id || null;
      order.reviewed_product_ids = Array.isArray(data.reviewed_product_ids) ? data.reviewed_product_ids : null;
      order.reviewed_items = Array.isArray(data.reviewed_items) ? data.reviewed_items : order.reviewed_items || null;
      applyItemReviews(order);
    } catch (e) { /* keep the initially rendered review rows */ }
  }

  // Fetch the carrier's full trajectory (worker KEC pull) and light up the
  // "Track your order" button(s) that open the modal. Fails silent: without
  // data the button stays hidden and the in-card Shopify-events timeline is
  // all the customer sees.
  async function loadKecTracking(order, card, seq) {
    if (order.cancelled_at) return;
    const hasNumber = (order.fulfillments || []).some(function (f) { return f.number; });
    if (!hasNumber) return;
    try {
      const name = String(order.name || '').replace(/^#/, '');
      const res = await fetch(trackingEndpoint + '?name=' + encodeURIComponent(name), {
        headers: { Accept: 'application/json' }, credentials: 'same-origin'
      });
      if (seq !== detailSeq || !res.ok) return;
      const data = await res.json();
      if (seq !== detailSeq || data.status !== 'ok' || !Array.isArray(data.shipments)) return;
      data.shipments.forEach(function (shipment) {
        if (!shipment.events || !shipment.events.length || !shipment.number) return;
        kecShipments[shipment.number] = shipment;
      });
    } catch (e) { /* modal falls back to the no-updates note */ }
  }

  /* Wrapper so an early "Track your order" click has something to await
     (BV-40). Always resolves — a failed pull still has to release any click
     waiting on it, otherwise the button would stay disabled forever. */
  function startKecTracking(order, card, seq) {
    const p = loadKecTracking(order, card, seq).catch(function () {}).then(function () {
      if (kecPending === p) kecPending = null;   // settled: later clicks go straight through
    });
    kecPending = p;
    return p;
  }

  function renderDetail(order) {
    detailEl.replaceChildren();
    const frag = tplDetail.content.cloneNode(true);
    frag.querySelector('[data-detail-name]').textContent = String(order.name || currentDetailName).replace(/^#/, '');
    const sub = frag.querySelector('[data-detail-sub]');
    if (order.cancelled_at) {
      sub.textContent = labelFor('cancelled') + ' ' + formatDateTime(order.cancelled_at);
    } else if (orderDate(order)) {
      sub.textContent = labelFor('detail_placed').replace('[date]', formatDateTime(orderDate(order)));
    } else {
      sub.textContent = '';
    }
    wireBack(frag.querySelector('[data-detail-back]'));

    // START A RETURN: worker nulls return_url for unfulfilled/cancelled orders;
    // also hidden once the aggregated OrderReturnStatus reports items RETURNED.
    const returnBtn = frag.querySelector('[data-detail-return]');
    if (order.return_url && order.return_status !== 'RETURNED') {
      returnBtn.href = order.return_url;
      returnBtn.hidden = false;
    } else {
      returnBtn.remove();
    }

    const buyBtn = frag.querySelector('[data-detail-buy]');
    buyBtn.addEventListener('click', function () { buyAgain(order.reorder_items, buyBtn); });

    const cards = frag.querySelector('[data-detail-cards]');
    const card = el('div', 'acd__card');
    detailReviewSlots = [];
    detailReviewLines = {};
    const fulfillments = order.fulfillments || [];
    kecShipments = {};
    // …and drop any pull still in flight for the PREVIOUS order, so a click on
    // this one is never held behind it (BV-40).
    kecPending = null;
    // Return cards first — the hosted order status page puts returns above
    // the fulfillment timelines.
    (order.returns || []).forEach(function (r) {
      card.appendChild(returnSection(order, r));
    });

    // Split-order support (Mechanic splits one order into several
    // fulfillments): the not-yet-shipped remainder = order items minus every
    // shipment's items, joined on line_id (absent on a stale worker payload —
    // remainder stays empty and the pre-split render is unchanged).
    const shippedByLine = {};
    fulfillments.forEach(function (f) {
      (f.items || []).forEach(function (it) {
        if (!it.line_id) return;
        shippedByLine[it.line_id] = (shippedByLine[it.line_id] || 0) + it.quantity;
      });
    });
    const unshipped = fulfillments.length
      ? (order.items || [])
          .filter(function (it) { return it.line_id; })
          .map(function (it) {
            const left = it.quantity - (shippedByLine[it.line_id] || 0);
            return { line_id: it.line_id, title: it.title, variant: it.variant, quantity: left, image: it.image };
          })
          .filter(function (it) { return it.quantity > 0; })
      : [];
    // Per-package blocks only when the split is visible to the customer —
    // a plain single-shipment order keeps the original layout (items live in
    // the Order summary, tracking in the standalone row on top).
    const splitView = fulfillments.length > 1 || unshipped.length > 0;

    if (order.cancelled_at || !fulfillments.length) {
      card.appendChild(statusSection(order, null));
    } else {
      fulfillments.forEach(function (f) {
        // Split orders: each package is its own block — full item cards over
        // the timeline, tracking inline on the current milestone
        // (Figma 12539:44007).
        let delivery = null;
        if (f.number) {
          if (splitView) delivery = deliveryInline(f, order);
          else card.appendChild(deliveryRow(f, order));
        }
        const sec = statusSection(order, f, delivery);
        if (splitView && f.items && f.items.length) {
          sec.insertBefore(sectionItems(order, f.items), sec.firstChild);
        }
        card.appendChild(sec);
      });
      // Not-yet-shipped remainder — own section with the pending dashed stub,
      // mirroring the hosted page's extra "preparing" block.
      if (unshipped.length) {
        const sec = detailSection();
        sec.appendChild(sectionItems(order, unshipped));
        const list = el('ul', 'acd__timeline acd__timeline--pending');
        list.appendChild(milestone('confirmed', orderDate(order), true));
        sec.appendChild(list);
        card.appendChild(sec);
      }
    }

    // Gift-card orders: "Resend gift card" under the timeline, parity with
    // the hosted order status page.
    if (order.has_gift_card && !order.cancelled_at) {
      const sec = card.querySelector('[data-status-sec]');
      if (sec) {
        const wrap = el('div', 'acd__resend');
        const btn = el('button', 'aco__btn aco__btn--outline', labelFor('resend_gift_card'));
        btn.type = 'button';
        btn.addEventListener('click', async function () {
          if (btn.disabled) return;
          btn.disabled = true;
          btn.textContent = labelFor('resend_gift_card_sending');
          try {
            const name = String(order.name || '').replace(/^#/, '');
            const res = await fetch(resendGiftCardEndpoint + '?name=' + encodeURIComponent(name), {
              method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin'
            });
            const data = res.ok ? await res.json() : null;
            if (data && data.status === 'ok') {
              btn.textContent = labelFor('resend_gift_card_sent');
              // Gifted cards notify the RECIPIENT — say where it went so the
              // purchaser doesn't wait for an email that isn't coming to them.
              if (Array.isArray(data.sent_to) && data.sent_to.length) {
                wrap.appendChild(el('p', 'acd__resend-note',
                  labelFor('resend_gift_card_sent_to').replace('[email]', data.sent_to.join(', '))));
              }
              return; // stays disabled — worker enforces a cooldown anyway
            }
            throw new Error('resend failed');
          } catch (e) {
            btn.disabled = false;
            btn.textContent = labelFor('resend_gift_card');
            wrap.appendChild(el('p', 'acd__resend-error', labelFor('resend_gift_card_error')));
          }
        });
        wrap.appendChild(btn);
        sec.appendChild(wrap);
      }
    }
    card.appendChild(summarySection(order, !splitView));
    const pay = paymentSection(order);
    if (pay.children.length) card.appendChild(pay);
    cards.appendChild(card);

    // Lazily upgrade the timeline with the carrier's full trajectory and the
    // per-item review rows with reviewed-set / Verified Buyer metadata.
    startKecTracking(order, card, detailSeq);
    loadReviewInfo(order, detailSeq);

    const help = frag.querySelector('[data-detail-help]');
    if (root.dataset.supportUrl) {
      const support = help.querySelector('[data-detail-support]');
      support.href = root.dataset.supportUrl;
      // Open the Gorgias chat widget directly (same pattern as the contact
      // page's "Chat with us now"); the contact-page link is the fallback
      // when the widget isn't available within 5s.
      support.addEventListener('click', function (e) {
        e.preventDefault();
        const deadline = Date.now() + 5000;
        (function tryOpen() {
          const g = window.GorgiasChat;
          if (g && typeof g.open === 'function') { g.open(); return; }
          if (g && typeof g.init === 'function') { g.init().then(function () { g.open(); }); return; }
          if (Date.now() < deadline) { setTimeout(tryOpen, 100); return; }
          window.location.href = support.href;
        })();
      });
      help.hidden = false;
    }
    detailEl.appendChild(frag);
  }

  let currentDetailName = '';
  let cameFromList = false;
  let detailSeq = 0;

  async function showDetail(name) {
    currentDetailName = name;
    listChrome(false);
    detailEl.hidden = false;
    detailEl.replaceChildren();
    const spinner = el('div', 'aco__state');
    spinner.innerHTML = stateEl.dataset.loadingHtml || '';
    detailEl.appendChild(spinner);
    const seq = ++detailSeq;
    try {
      const res = await fetch(detailEndpoint + '?name=' + encodeURIComponent(name), {
        headers: { Accept: 'application/json' }, credentials: 'same-origin'
      });
      if (seq !== detailSeq) return;
      if (!res.ok) { detailMessage(labelFor('detail_error'), true); return; }
      const data = await res.json();
      if (seq !== detailSeq) return;
      if (data.status === 'not_logged_in') {
        if (window.bvLoginRedirect) window.bvLoginRedirect();
        detailMessage(labelFor('detail_error'), false);
        return;
      }
      if (data.status === 'ok' && data.order) { renderDetail(data.order); return; }
      detailMessage(labelFor('detail_not_found'), false, labelFor('detail_not_found_title'));
    } catch (err) {
      if (seq === detailSeq) detailMessage(labelFor('detail_error'), true);
    }
  }

  function route() {
    const name = new URLSearchParams(location.search).get('order');
    if (name) {
      showDetail(name.replace(/^#/, ''));
    } else {
      detailSeq++;
      detailEl.hidden = true;
      detailEl.replaceChildren();
      listChrome(true);
    }
  }

  window.addEventListener('popstate', function () {
    cameFromList = true;
    route();
  });

  // Customer-wide review-request-id map (order number → id), fetched lazily
  // AFTER the list renders (the Klaviyo scan behind it runs seconds cold).
  // With it every list WRITE A REVIEW link carries its order's
  // reviewRequestId, so Okendo attributes the review to the right order —
  // which the order-scoped "already reviewed" judgment depends on.
  async function loadListReviewInfo() {
    try {
      const res = await fetch(reviewInfoEndpoint, {
        headers: { Accept: 'application/json' }, credentials: 'same-origin'
      });
      if (!res.ok) return;
      const data = await res.json();
      if (data.status !== 'ok' || !data.review_request_ids) return;
      const map = data.review_request_ids;
      const emap = data.review_element_ids || {};
      let changed = false;
      allOrders.forEach(function (o) {
        const plain = String(o.name || '').replace(/^#/, '');
        if (map[plain] && !o.review_request_id) {
          o.review_request_id = map[plain];
          o.review_element_id = emap[plain] || null;
          changed = true;
        }
      });
      // Re-render refreshes the button hrefs; harmless while the (CSS-hidden)
      // detail view is open — the list keeps its own state.
      if (changed) render();
    } catch (e) { /* links keep working without reviewRequestId */ }
  }

  async function load() {
    try {
      const res = await fetch(endpoint, { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!res.ok) { show(tplError.content.cloneNode(true)); return; }
      const data = await res.json();
      // Worker is authoritative for login state (this page's Liquid render may be
      // a cached logged-out variant). Auto-redirect to login via bvLoginRedirect
      // (snippet account-login-redirect) — its sessionStorage guard prevents a
      // loop if the redirect recurs; the inline sign-in prompt is the fallback.
      if (data.status === 'not_logged_in') {
        if (paginationEl) paginationEl.hidden = true;
        show(tplSignin.content.cloneNode(true));
        if (window.bvLoginRedirect) window.bvLoginRedirect();
        return;
      }
      if (data.status === 'ok' && Array.isArray(data.orders)) {
        allOrders = data.orders;
        // Legacy per-customer Okendo reviewed-products set (stale-worker
        // fallback) — each row now carries order-scoped reviewed_product_ids.
        reviewedProductIds = Array.isArray(data.reviewed_product_ids) ? data.reviewed_product_ids : null;
        /* BUG-BV-70: the list hit the worker's cap — say so instead of passing
           a partial list off as the whole history. Truthiness check keeps this
           inert against a stale worker that doesn't send the field yet. */
        var truncEl = root.querySelector('[data-orders-truncated]');
        if (truncEl) truncEl.hidden = !data.truncated;
        if (searchWrap) searchWrap.hidden = allOrders.length === 0;
        maybeShowMarketBanner(allOrders);
        render();
        loadListReviewInfo();
        return;
      }
      show(tplError.content.cloneNode(true));
    } catch (err) {
      show(tplError.content.cloneNode(true));
    }
  }

  // Keep a copy of the loading logo so the detail view can reuse it.
  stateEl.dataset.loadingHtml = stateEl.innerHTML;

  load();
  route();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["account-referrals"]) return;
  try {
    
/* QA BUG-BV-41: give the Okendo referrals widget a deadline.

   The loader was hidden by CSS alone, which only ever fires on success — if the
   widget never populates the shopper watches the BONVALE logo spin indefinitely
   with no error and no retry. Watch the container, and if nothing has been
   injected by the deadline, swap the spinner for the fallback message.

   Purely additive: on the happy path the MutationObserver settles early and the
   existing CSS rule does the hiding exactly as before. */
(function () {
  var wrap = document.querySelector('.acr__widget-wrap');
  if (!wrap) return;

  var widget = wrap.querySelector('.acr__widget');
  var loading = wrap.querySelector('[data-acr-loading]');
  var fallback = wrap.querySelector('[data-acr-fallback]');
  if (!widget || !fallback) return;

  /* Okendo hydrates well inside this on a normal connection; long enough not to
     accuse a slow network, short enough not to feel abandoned. */
  var DEADLINE_MS = 8000;
  var settled = false;
  var observer = null;
  var timer = null;

  function populated() {
    return widget.children.length > 0 || widget.textContent.trim() !== '';
  }

  function settle(ok) {
    if (settled) return;
    settled = true;
    if (observer) observer.disconnect();
    clearTimeout(timer);
    /* On success leave the DOM alone — the stylesheet already hides both
       overlays once .acr__widget is non-empty. */
    if (ok) return;
    if (loading) loading.style.display = 'none';
    fallback.hidden = false;
  }

  if ('MutationObserver' in window) {
    observer = new MutationObserver(function () { if (populated()) settle(true); });
    observer.observe(widget, { childList: true, subtree: true });
  }
  timer = setTimeout(function () { settle(populated()); }, DEADLINE_MS);

  var retry = wrap.querySelector('[data-acr-retry]');
  if (retry) retry.addEventListener('click', function () { window.location.reload(); });

  if (populated()) settle(true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["account-rewards"]) return;
  try {
    
  (function() {
    var config = document.querySelector('[data-oke-loyalty-copy-fr]');
    if (!config) return;

    var copy;
    try {
      copy = JSON.parse(config.textContent);
    } catch (e) {
      return;
    }

    var roots = document.querySelectorAll('[data-oke-loyalty-embedded-widget]');
    if (!roots.length) return;
    var keys = Object.keys(copy).sort(function(a, b) { return b.length - a.length; });

    function translateString(input) {
      var output = input;
      keys.forEach(function(source) {
        output = output.split(source).join(copy[source]);
      });
      return output;
    }

    function translateRoot(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var translated = translateString(node.nodeValue);
        if (translated !== node.nodeValue) node.nodeValue = translated;
      }
      root.querySelectorAll('[aria-label], [title]').forEach(function(el) {
        ['aria-label', 'title'].forEach(function(attr) {
          if (!el.hasAttribute(attr)) return;
          var value = el.getAttribute(attr);
          var translated = translateString(value);
          if (translated !== value) el.setAttribute(attr, translated);
        });
      });
    }

    roots.forEach(function(root) {
      translateRoot(root);
      new MutationObserver(function() { translateRoot(root); }).observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    /* Locale-aware root: '' on the primary locale, '/fr' etc. on secondary ones.
       Cart AJAX must carry it or Shopify answers in the shop's DEFAULT locale
       (untranslated line-item titles / discount messages). */
    var LOCALE_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');

    /* ===== Free-shipping note: upgrade the cross-currency fallback =====
       Liquid rendered a plain statement of the threshold because it has no FX
       rate to convert the ROW USD figure with. window.BonvaleFreeShipping does
       (shop_cents from the daily worker cron × the live Shopify.currency.rate),
       so when it yields a local figure, replace the sentence with a real
       "you're X away" — and with "Free" once the cart clears it.
       If anything is missing we leave the server-rendered text untouched, which
       is already correct, just less useful. See snippets/free-shipping-data. */
    function upgradeFreeShippingNote() {
      var wrap = document.querySelector('[data-fs-wrap]');
      var fs = window.BonvaleFreeShipping;
      if (!wrap || !fs || fs.localCents == null || fs.source !== 'converted') return;
      /* source === 'native' means Liquid already had comparable money and got it
         right; only the converted case needs client-side help. */
      if (!window.BonvaleMoney) return;

      var subtotal = parseInt(wrap.dataset.fsSubtotal || '0', 10);
      if (!isFinite(subtotal)) return;
      var remaining = fs.localCents - subtotal;
      var note = wrap.querySelector('[data-fs-note]');
      if (!note) return;

      if (remaining <= 0 || wrap.dataset.fsHasCode) {
        /* fs.localText, not format(localCents): the converted threshold is rounded
           up to a clean figure, and localText carries it without the ".00" that
           re-formatting would put back. The banner, the drawer and this note must
           all print the same number. See snippets/free-shipping-data. */
        note.textContent = (wrap.dataset.fsOverTmpl || '')
          .replace('__AMOUNT__', fs.localText || window.BonvaleMoney.format(fs.localCents));
        if (!wrap.querySelector('[data-fs-free]')) {
          var row = wrap.querySelector('.cdp-summary__row');
          if (row) {
            var span = document.createElement('span');
            span.className = 'cdp-summary__free';
            span.setAttribute('data-fs-free', '');
            span.textContent = wrap.dataset.fsFreeLabel || '';
            row.appendChild(span);
          }
        }
        return;
      }

      /* Rebuild the highlighted-amount sentence (Figma 7527:116357) rather than
         setting textContent, so the promo-coloured span survives. */
      note.textContent = '';
      note.appendChild(document.createTextNode(wrap.dataset.fsAwayBefore || ''));
      var amt = document.createElement('span');
      amt.className = 'cdp-summary__shipping-amount';
      amt.textContent = window.BonvaleMoney.format(remaining);
      note.appendChild(amt);
      note.appendChild(document.createTextNode(wrap.dataset.fsAwayAfter || ''));
      var stale = wrap.querySelector('[data-fs-free]');
      if (stale) stale.remove();
    }
    upgradeFreeShippingNote();

    /* ===== Cart drawer — auto-open on page load ===== */
    /* ===== Quantity selector + remove (BUG-BV-12) =====

       Every quantity change used to end in location.reload(). Measured on prod
       2026-08-06 that cost 4.3s of white page for a single "+" tap, and holding
       the button queued one full reload per click. The bag DRAWER was already
       moved off that pattern (BV-04); this brings the /cart page in line.

       Three parts, and all three are needed together:

       1. OPTIMISTIC input — the number moves the instant it is clicked, so the
          control never feels like it is waiting on the network.
       2. DEBOUNCE per line — rapid +/+/+ coalesces into ONE /cart/change.js for
          the final quantity instead of one request per tap.
       3. SECTION SWAP — re-render this section through the Section Rendering API
          and replace #cdp, so line totals, the order summary, the free-shipping
          bar and the item count all come back server-rendered (the same numbers
          the reload produced) with no page load.

       Because (3) is asynchronous, responses can land out of order — the exact
       race BV-28 describes in the drawer. `renderSeq` makes the newest request
       the only one allowed to paint; stale responses are dropped. Dropping the
       sequencing here would trade a slow cart for a wrong one. */
    var CART_ROOT = '#cdp';
    var qtyTimers = {};        /* line key -> pending debounce timer */
    var renderSeq = 0;         /* newest render request wins */
    var busyTimer = null;
    var moveInFlight = {};     /* line key -> true while its wishlist add runs */

    function busyEl() { return document.querySelector('[data-cdp-busy]'); }

    /* Show the overlay only if the round-trip is actually slow. A partial render
       usually lands well inside this, and flashing a spinner over the lines for
       150ms reads worse than not showing one at all. Re-queried on every call
       rather than cached: the section swap replaces the element, and the empty-bag
       branch has none at all — hence the null guards. */
    function busyOn() {
      if (busyTimer) return;
      busyTimer = setTimeout(function() {
        var el = busyEl();
        if (el) el.classList.add('is-active');
      }, 400);
    }
    function busyOff() {
      clearTimeout(busyTimer);
      busyTimer = null;
      var el = busyEl();
      if (el) el.classList.remove('is-active');
    }

    function cartSectionId() {
      var root = document.querySelector('[data-cart-section]');
      return root ? root.getAttribute('data-cart-section') : null;
    }

    /* Re-render the cart section in place. Falls back to a full reload on any
       failure, so a broken swap can never leave a stale cart on screen. */
    function renderCart(seq) {
      var sid = cartSectionId();
      if (!sid || !('fetch' in window) || !('DOMParser' in window)) { location.reload(); return; }

      fetch(LOCALE_ROOT + '/cart?section_id=' + encodeURIComponent(sid), {
        credentials: 'same-origin'
      })
        .then(function(res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function(html) {
          if (seq !== renderSeq) return;          /* a newer change already won */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector(CART_ROOT);
          var current = document.querySelector(CART_ROOT);
          if (!incoming || !current) { location.reload(); return; }
          current.replaceWith(incoming);
          busyOff();

          var count = parseInt(incoming.getAttribute('data-cart-item-count'), 10);
          if (!isNaN(count) && window.__setCartCount) window.__setCartCount(count);

          /* Anything bound to the swapped-out DOM re-initialises here. The
             quantity, remove and promo handlers are delegated on document, so
             they are deliberately NOT in this list.

             · the free-shipping note is a client-side upgrade of the server's
               cross-currency fallback — without this the "you're X away"
               sentence reverts to the plain threshold on every quantity change
               in a converted-currency market.
             · cdp:summary-replaced is the pre-existing hook the mobile summary
               collapse toggle already listens on; the swap replaces .cdp-summary
               so it has to fire. */
          upgradeFreeShippingNote();
          document.dispatchEvent(new CustomEvent('cdp:summary-replaced'));

          /* A line whose "move to wishlist" is still in flight was hidden on
             click, and this swap brings back the server's copy of it — visible.
             Re-hide it, or an unrelated quantity edit makes a row the shopper
             already moved reappear for as long as Swym takes. */
          Object.keys(moveInFlight).forEach(function(k) {
            var row = incoming.querySelector('.cdp-item[data-key="' + k + '"]');
            if (row) row.classList.add('cdp-item--moving');
          });

          /* The two carousels inside .cdp__reco-inline are part of the swapped
             subtree, and both bind to element nodes rather than to document, so
             they come back inert: the "You May Also Like" arrows stop working and
             a card click navigates to the PDP instead of opening quick-add, while
             Recently Viewed loses its client-fetched cards entirely. Both inits
             are guarded, so re-calling them is cheap. */
          if (window.__initTasteGrids) window.__initTasteGrids();
          if (window.__initCdpRecentlyViewed) window.__initCdpRecentlyViewed();
        })
        .catch(function() { location.reload(); });
    }

    /* QA BUG-BV-26: two gaps were left in the writer above.

       1. NO CONCURRENCY GUARD. The debounce is per LINE (`qtyTimers[key]`), so editing
          two different lines in quick succession fires two overlapping /cart/change.js
          calls. `renderSeq` decides which response may PAINT, but it has no say over the
          order Shopify APPLIES the writes — the same divergence BV-28 fixed in the
          drawer, where the UI showed 2 and the server had settled on 5. Writes are now
          serialised on one chain, so the order Shopify applies is the order the shopper
          performed. The chain must survive a rejection (`.then(run, run)`) or one failed
          edit would silently swallow every later one.

       2. FAILURE WAS SILENT. `.catch(location.reload)` turned a 429 (Shopify throttles
          cart bursts) into a full page load that redisplayed the UNCHANGED cart with no
          explanation — indistinguishable from success to the shopper, and it threw away
          their optimistic input. Now: one retry on a throttle or 5xx, and if it still
          fails we stop, drop the overlay and say so.

       cartWriteInFlight is a COUNT, not a boolean: an early failure must not clear the
       busy overlay while a later queued write is still running. */
    var cartWriteChain = Promise.resolve();
    var cartWriteInFlight = 0;

    function postChange(payload, allowRetry) {
      function retryOr(result) {
        if (allowRetry === false) return result;
        return new Promise(function(r) { setTimeout(r, 1200); })
          .then(function() { return postChange(payload, false); });
      }
      return fetch(LOCALE_ROOT + '/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function(res) {
          if (res.ok) return { ok: true };
          /* A throttle or a server blip is worth one more try; a 4xx that is not 429 is
             a real rejection (bad line key, gone variant) and retrying just doubles it. */
          if (res.status === 429 || res.status >= 500) return retryOr({ ok: false });
          return { ok: false };
        })
        .catch(function() { return retryOr({ ok: false }); });
    }

    function cartWriteFailed() {
      var el = busyEl();
      var msg = el && el.getAttribute('data-msg-failed');
      if (msg && window.__showQuickAddToast) window.__showQuickAddToast(msg, true);
    }

    /* Swym fails on prod often enough that surfacing this put a red error banner in
       front of shoppers for a fault they can neither cause nor act on (seen live
       2026-08-08). Nothing is ever lost — the add is what failed, so the line is
       still in the bag and the row is repainted below — which is why the wishlist
       heart has always failed silently too. Keep the diagnosis in the console. */
    function wishlistMoveFailed() {
      if (window.console && console.warn) {
        console.warn('[cart] move to wishlist failed; item kept in bag');
      }
    }

    function changeLine(key, quantity, seq) {
      var run = function() {
        cartWriteInFlight++;
        return postChange({ id: key, quantity: quantity }).then(function(res) {
          cartWriteInFlight--;
          if (!res || !res.ok) {
            /* Only the last write standing clears the overlay and reports. */
            if (!cartWriteInFlight) { busyOff(); cartWriteFailed(); }
            return;
          }
          if (seq !== renderSeq) return;
          renderCart(seq);
        });
      };
      cartWriteChain = cartWriteChain.then(run, run);
      return cartWriteChain;
    }

    /* Read the cap the server stamped on this line. Absent = no cap (inventory
       untracked or overselling allowed). */
    function maxFor(selector) {
      var max = parseInt(selector.dataset.qtyMax, 10);
      return (isNaN(max) || max <= 0) ? null : max;
    }
    function showMaxMsg(selector, show) {
      var msg = selector.parentNode ? selector.parentNode.querySelector('[data-qty-max-msg]') : null;
      if (msg) msg.hidden = !show;
      var plus = selector.querySelector('.qty-selector__plus');
      if (plus) plus.disabled = !!show;
    }

    function queueChange(selector, quantity) {
      var item = selector.closest('.cdp-item');
      if (!item) return;
      var key = item.dataset.key;
      if (!key || isNaN(quantity)) return;

      busyOn();
      var seq = ++renderSeq;
      clearTimeout(qtyTimers[key]);
      qtyTimers[key] = setTimeout(function() {
        delete qtyTimers[key];
        changeLine(key, quantity, seq);
      }, 250);
    }

    /* Delegated so the handlers survive the section swap above. */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.qty-selector__minus, .qty-selector__plus');
      if (!btn) return;
      var selector = btn.closest('.qty-selector');
      if (!selector || selector.classList.contains('qty-selector--disabled')) return;
      var input = selector.querySelector('.qty-selector__input');
      if (!input) return;

      var max = maxFor(selector);
      var val = parseInt(input.value, 10) || 0;

      if (btn.classList.contains('qty-selector__minus')) {
        if (val <= 1) return;
        if (max !== null) showMaxMsg(selector, false);
        input.value = val - 1;
      } else {
        if (max !== null && val >= max) { showMaxMsg(selector, true); return; }
        input.value = val + 1;
        if (max !== null && val + 1 >= max) showMaxMsg(selector, true);
      }
      queueChange(selector, parseInt(input.value, 10));
    });

    document.addEventListener('change', function(e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains('qty-selector__input')) return;
      var selector = input.closest('.qty-selector');
      if (!selector || selector.classList.contains('qty-selector--disabled')) return;

      var max = maxFor(selector);
      var val = parseInt(input.value, 10);
      if (max !== null && !isNaN(val) && val > max) {
        input.value = max;
        showMaxMsg(selector, true);
      } else if (max !== null) {
        showMaxMsg(selector, false);
      }
      queueChange(selector, parseInt(input.value, 10));
    });

    /* Remove links (text "Remove" + trash icon) — intercept default navigation
       and re-render rather than reload. Removal is not debounced: it is a single
       deliberate action, and delaying it would leave the row on screen. */
    document.addEventListener('click', function(e) {
      var link = e.target.closest('.cdp-item__remove, .cdp-item__trash');
      if (!link) return;
      var item = link.closest('.cdp-item');
      if (!item) return;
      var key = item.dataset.key;
      if (!key) return;
      e.preventDefault();
      busyOn();
      clearTimeout(qtyTimers[key]);
      delete qtyTimers[key];
      changeLine(key, 0, ++renderSeq);
    });

    /* ===== Move to wishlist =====

       This is a MOVE, so the cart line may only go once the wishlist add has
       actually LANDED. Swym fails often enough to matter — a silent no-op (no
       request, neither callback fired), a server-side NPE and `sw-unauth-acl`
       were all seen on prod within one day, 2026-08-06 — and removing regardless
       deleted the shopper's item with nothing saved.

       Waiting on that is what made the button feel broken, not the ordering:
       Wishlist.toggle() budgets 12s (5s per call plus two retries), and the old
       handler held a full-page overlay up for all of it, then finished with
       location.reload() on top. So the WAIT moves off screen while the ORDER
       stays: the row is hidden the instant it is clicked, the add runs in the
       background, and the line is removed for real — through the same serialised
       writer + section swap every other cart mutation uses — only once the add
       succeeds. If it fails the row comes back and we say so.

       Delegated, like the quantity and remove handlers: bound directly, it went
       inert the moment a quantity edit swapped the section out. */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-move-wishlist]');
      if (!btn) return;
      /* The cart DRAWER marks its own buttons with the same attribute and binds
         its own handler to them; .cdp-item keeps this listener off those. */
      var item = btn.closest('.cdp-item');
      if (!item) return;
      var key = item.dataset.key;
      if (!key || moveInFlight[key]) return;
      /* No wishlist module at all — the move cannot happen, so don't drop the line. */
      if (!window.Wishlist) return;

      e.preventDefault();

      /* Re-query rather than reuse the clicked row: an intervening section swap
         replaces that node, and the swap re-hides whatever is still in flight. */
      function unhideLine() {
        var row = document.querySelector('.cdp-item[data-key="' + key + '"]');
        if (row) row.classList.remove('cdp-item--moving');
      }

      function commit() {
        delete moveInFlight[key];
        clearTimeout(qtyTimers[key]);
        delete qtyTimers[key];
        busyOn();
        /* When the write succeeds the swap drops the row outright and this finds
           nothing. It matters when the write FAILS: the row is already hidden,
           and leaving it that way would hide an item still in the bag. */
        changeLine(key, 0, ++renderSeq).then(unhideLine);
      }

      /* Already wishlisted — nothing to wait for, so this is an ordinary line
         removal: no optimistic hide, same overlay-after-400ms as Remove. */
      if (window.Wishlist.isWishlisted(btn.dataset.productId)) { commit(); return; }

      moveInFlight[key] = true;

      /* Wishlist.toggle reads its product data off the element's dataset and
         decides add-vs-remove from it; this row's button is not a wishlist
         button, so hand it a stand-in carrying the same attributes. */
      var proxy = document.createElement('span');
      proxy.setAttribute('data-wishlist-btn', '');
      ['productId', 'variantId', 'productUrl', 'productTitle', 'productPrice', 'productImage']
        .forEach(function(name) { proxy.dataset[name] = btn.dataset[name] || ''; });

      item.classList.add('cdp-item--moving');

      Promise.resolve(window.Wishlist.toggle(proxy)).then(function(result) {
        if (result && result.ok) { commit(); return; }
        /* Keep the item in the bag — losing it is worse than not moving it. */
        delete moveInFlight[key];
        unhideLine();
        wishlistMoveFailed();
      });
    });

    /* Let other scripts re-render the bag in place. Only quick-add uses this
       today: adding from "You May Also Like" on /cart used to slide the cart
       DRAWER over the cart PAGE, so the shopper ended up looking at a second
       copy of the bag they were already on and had to dismiss it to get back.

       quick-add-modal also treats the presence of this global as "I am on the
       cart page", so it must NOT exist anywhere else — hence the #cdp check
       rather than defining it unconditionally. Everything else in this block is
       delegated on document and no-ops off the cart page; this would not. */
    if (document.querySelector(CART_ROOT)) {
      window.__refreshCartPage = function() {
        busyOn();
        renderCart(++renderSeq);
      };
    }
  })();

  /* Promo code: AJAX apply with inline error. Delegated so listeners survive summary re-render. */
  (function() {
    /* Locale-aware root — see the note on the block above. */
    var LOCALE_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');

    /* Defaults are last-resort only — the real copy rides in on the form's data attributes. */
    var FALLBACK_REJECTED = "We couldn't apply this code. It may be invalid, expired, or not eligible for your current cart.";
    var FALLBACK_NETWORK = 'Could not apply code. Please try again.';
    function rejectedMsg(form) { return (form && form.dataset.msgRejected) || FALLBACK_REJECTED; }
    function networkMsg(form) { return (form && form.dataset.msgNetwork) || FALLBACK_NETWORK; }

    function findPromoError(form) {
      var parent = form.parentNode;
      return parent ? parent.querySelector('[data-promo-error]') : null;
    }

    function showError(form, msg) {
      var el = findPromoError(form);
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    }

    function clearError(form) {
      var el = findPromoError(form);
      if (!el) return;
      el.textContent = '';
      el.hidden = true;
    }

    function setBusy(form, busy) {
      if (!form) return;
      var wrap = form.closest('[data-promo-wrap]');
      if (wrap) wrap.classList.toggle('is-loading', !!busy);
      var btn = form.querySelector('[data-promo-apply]');
      if (btn) btn.disabled = !!busy;
    }

    /* Apply a discount code via the AJAX Cart API using the singular "discount"
       string parameter (the documented format — not "discount_codes" array which
       is the Storefront GraphQL API format and is ignored by the AJAX API).
       Invalid / expired / min-spend / not-eligible all return HTTP 200 with
       cart.discount_codes[].applicable === false, so we must inspect the body
       before deciding whether to reload or surface an inline error. */
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('[data-promo-form]');
      if (!form) return;
      e.preventDefault();

      var input = form.querySelector('.cdp-summary__promo-input');
      var code = (input && input.value || '').trim();
      if (!code) return;

      clearError(form);
      setBusy(form, true);

      /* QA BUG-BV-123: the AJAX Cart API's `discount` param REPLACES the whole set,
         so posting just the new code dropped any already-applied stackable codes.
         Submit the existing codes (from the applied-code [data-promo-remove] buttons,
         deduped) PLUS the new one, so stackable codes accumulate. Bonus: if the new
         code is invalid, Shopify still keeps the valid existing ones we resubmitted,
         instead of the old behaviour that wiped them. Sibling of BV-120 (remove). */
      var applyCodes = [];
      var applySeen = {};
      document.querySelectorAll('[data-promo-remove]').forEach(function (el) {
        var c = (el.getAttribute('data-promo-remove') || '').trim();
        if (!c) return;
        var k = c.toLowerCase();
        if (applySeen[k]) return;
        applySeen[k] = true;
        applyCodes.push(c);
      });
      if (!applySeen[code.toLowerCase()]) applyCodes.push(code);

      fetch(LOCALE_ROOT + '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: applyCodes.join(',') })
      })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var codes = (cart && cart.discount_codes) || [];
          var target = code.toLowerCase();
          for (var i = 0; i < codes.length; i++) {
            if ((codes[i].code || '').toLowerCase() === target && codes[i].applicable) {
              location.reload();
              return;
            }
          }
          setBusy(form, false);
          showError(form, rejectedMsg(form));
        })
        .catch(function() {
          setBusy(form, false);
          showError(form, networkMsg(form));
        });
    });

    document.addEventListener('input', function(e) {
      var input = e.target;
      if (!input || !input.classList || !input.classList.contains('cdp-summary__promo-input')) return;
      var form = input.closest('[data-promo-form]');
      if (form) clearError(form);
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-promo-remove]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;

      /* QA BUG-BV-120: this used to POST { discount: '' } — which the AJAX Cart
         API treats as "clear ALL codes", so removing one of several stackable
         codes wiped every code and reset the Total to full price. The API's
         `discount` param REPLACES the whole set (empty = none, comma-separated =
         all listed), with no "remove one" verb — so rebuild it: collect every
         currently-applied code from the [data-promo-remove] buttons, drop the one
         clicked, and submit the remainder. Codes are de-duped because the desktop
         and mobile summaries both render a button per code. */
      var removeCode = (btn.getAttribute('data-promo-remove') || '').trim();
      var remaining = [];
      var seen = {};
      document.querySelectorAll('[data-promo-remove]').forEach(function (el) {
        var code = (el.getAttribute('data-promo-remove') || '').trim();
        if (!code) return;
        var key = code.toLowerCase();
        if (key === removeCode.toLowerCase() || seen[key]) return;
        seen[key] = true;
        remaining.push(code);
      });

      fetch(LOCALE_ROOT + '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: remaining.join(',') })
      })
      .then(function() { location.reload(); })
      .catch(function() { location.reload(); });
    });

  })();

  /* Mobile order-summary collapse toggle. Tapping the Total row's chevron
     expands the breakdown above (Subtotal, Shipping, Discounts, taxes note);
     a second tap collapses it back to just the Total + CTA.
     Re-initialised whenever replaceSummary swaps out the .cdp-summary element. */
  (function() {
    var mq = window.matchMedia('(max-width: 768px)');
    var resizeObserver = null;

    function initToggle() {
      var summary = document.querySelector('.cdp-summary');
      if (!summary) return;

      var toggle = summary.querySelector('[data-summary-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function() {
          if (!mq.matches) return;
          var expanded = summary.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      }

      function updateHeight() {
        document.documentElement.style.setProperty('--cdp-summary-h', summary.offsetHeight + 'px');
      }
      updateHeight();
      if (resizeObserver) resizeObserver.disconnect();
      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(summary);
      } else {
        window.addEventListener('resize', updateHeight);
      }
    }

    initToggle();
    document.addEventListener('cdp:summary-replaced', initToggle);

    /* Publish the visible header chrome height as --cdp-sticky-top so the
       desktop sticky cart-summary docks just below the header. Can't reuse
       the header's own --header-total-height: that variable is only refreshed
       when the search dropdown opens (sections/header.liquid:updateHeaderHeight),
       so on a normal cart page load it's undefined → the sticky panel docks at
       top:0, hiding the ORDER SUMMARY label behind the header.
       Read the bottom of `.shopify-section-group-header-group` (the wrapper
       that includes announcement + main + nav), which already accounts for the
       header's own negative-top sticky offset (announcement tucks above viewport
       as the user scrolls). */
    var headerGroup = document.querySelector('.shopify-section-group-header-group');
    var cdpStickyRaf = 0;
    function publishStickyTop() {
      if (!headerGroup) return;
      var bottom = Math.max(0, headerGroup.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--cdp-sticky-top', bottom + 'px');
      /* Toggle .is-sticky on the summary panel so padding-top drops from 106px
         (aligns ORDER SUMMARY with the list header) to 40px (pinned state).
         Only meaningful on desktop two-column layout (≥1280px).
         Guard with scrollY > 0: at scroll=0 the summary naturally sits right
         at headerBottom, making summaryTop ≈ bottom even before sticking. */
      if (window.matchMedia('(min-width: 1280px)').matches) {
        var summary = document.querySelector('.cdp-summary');
        if (summary) {
          var summaryTop = summary.getBoundingClientRect().top;
          summary.classList.toggle('is-sticky', window.scrollY > 0 && summaryTop <= bottom + 1);
        }
      }
    }
    function scheduleStickyTop() {
      if (cdpStickyRaf) return;
      cdpStickyRaf = requestAnimationFrame(function() {
        cdpStickyRaf = 0;
        publishStickyTop();
      });
    }
    publishStickyTop();
    window.addEventListener('scroll', scheduleStickyTop, { passive: true });
    window.addEventListener('resize', scheduleStickyTop);

    /* Track on-screen keyboard visibility. Two viewport behaviors to handle:
         - Android Chrome (default): window.innerHeight itself shrinks when
           the keyboard opens, so we compare against the tallest height we've
           ever seen (set before/between keyboard sessions).
         - iOS Safari: window.innerHeight stays put but visualViewport.height
           shrinks. Detect via the gap between the two.
       Either signal flips the body class. Threshold 150px filters out
       browser-chrome show/hide. */
    var maxHeight = window.innerHeight;
    var syncKeyboard = function() {
      var ih = window.innerHeight;
      if (ih > maxHeight) maxHeight = ih;
      var androidGap = maxHeight - ih;
      var iosGap = window.visualViewport ? (ih - window.visualViewport.height) : 0;
      var open = androidGap > 150 || iosGap > 150;
      document.body.classList.toggle('cdp-keyboard-open', open);
    };
    window.addEventListener('resize', syncKeyboard);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncKeyboard);
    }
    syncKeyboard();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-v2"]) return;
  try {
    
/* ═══ Collection v2 — no-reload (AJAX) faceted filtering ═══
   INTENTIONALLY DIVERGES from sections/collection.liquid (which keeps the
   original full-reload flow). Here every filter / sort / chip / clear applies
   via the Section Rendering API (?section_id=…) with no page reload, matching
   the Vuori-style in-page filtering UX.

   Design: all user interactions are bound via delegation on `document` so they
   survive the DOM swaps that AJAX rendering performs (no re-binding needed).
   Only stateful bits (infinite-scroll observer + desktop sidebar auto-open) are
   re-initialised after each swap via initDynamic(). Any fetch failure falls
   back to a normal full-page navigation so filtering never hard-breaks.

   Once the `product_type` facet is enabled in Search & Discovery it appears as
   the left "Category" group automatically (rendered by filter-sidebar) and is
   driven by this same engine — no extra JS. */
(function () {
  if (!document.querySelector('[data-collection]')) return;

  function q(sel) { return document.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }
  function sectionId() {
    var el = q('[data-collection]');
    return el ? el.getAttribute('data-collection-section') : null;
  }

  // Smooth-scroll the filter bar + grid into view (Vuori-style), offset for a
  // sticky header so the toolbar isn't hidden under it. Used on category-card
  // clicks, where the results otherwise stay below the tall card row.
  function scrollToResults() {
    var anchor = q('.collection__toolbar') || q('[data-collection]');
    if (!anchor) return;
    // Once scrolled, the sticky header group pins ONLY its inner nav bar
    // (.header-main ~69px) — the announcement bar scrolls off (group sticky top
    // is negative). Offset by that pinned bar so the filter row lands snug just
    // below it (Figma target), not with the full-group gap. +20px breathing room.
    var offset = 0;
    var bar = q('.header-main');
    if (bar) {
      offset = bar.getBoundingClientRect().height;
    } else {
      var grp = q('.shopify-section-group-header-group');
      if (grp) offset = grp.getBoundingClientRect().height + (parseFloat(getComputedStyle(grp).top) || 0);
    }
    var top = anchor.getBoundingClientRect().top + window.scrollY - offset - 20;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  }

  /* ---------- sidebar open / close ---------- */
  var sidebarOpen = false; // tracked across renders to preserve desktop state
  function setFilterBtnActive(on) {
    qa('.collection__filter-btn').forEach(function (b) {
      b.classList.toggle('collection__filter-btn--active', on);
    });
  }
  /* Drives the desktop column count: with the sidebar taking its track the grid
     is 3-up (Figma 7318:78257), without it 4-up (12928:63535). Keyed off an
     explicit class rather than the sidebar's inline display so the CSS does not
     have to sniff a style attribute. Desktop only — below 769 the sidebar is a
     modal overlay and the grid stays 2-up. */
  function setBodyFiltered(on) {
    var body = q('[data-collection-body]');
    if (body) body.classList.toggle('collection__body--filtered', on);
  }

  /* Metrics for the animated filter column — see the --anim block in
     sections/collection.liquid for the geometry and why these can't be
     percentages. Re-run from initDynamic() because the AJAX swap replaces
     [data-collection] wholesale, taking the inline custom properties (and the
     observed node) with it. */
  var metricsObserver = null;
  function syncFilterMetrics() {
    var body = q('[data-collection-body]');
    if (!body) return;
    var w = body.clientWidth;
    if (!w) return;
    body.style.setProperty('--filters-w', w * 0.25 + 2 + 'px');
    body.style.setProperty('--card-w', (w - 12) / 4 - 0.5 + 'px');
    if (window.ResizeObserver) {
      if (metricsObserver) metricsObserver.disconnect();
      metricsObserver = new ResizeObserver(function () {
        var b = q('[data-collection-body]');
        if (!b || !b.clientWidth) return;
        b.style.setProperty('--filters-w', b.clientWidth * 0.25 + 2 + 'px');
        b.style.setProperty('--card-w', (b.clientWidth - 12) / 4 - 0.5 + 'px');
      });
      metricsObserver.observe(body);
    }
  }

  /* Re-open the column without replaying the 300ms slide. The swapped-in body
     always arrives unfiltered, so a plain openSidebar() after a filter tick
     would animate it open again on every checkbox. */
  function restoreSidebarInstantly() {
    var body = q('[data-collection-body]');
    if (body) body.classList.add('collection__body--instant');
    openSidebar();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var b = q('[data-collection-body]');
        if (b) b.classList.remove('collection__body--instant');
      });
    });
  }
  function openSidebar() {
    var sb = q('[data-filter-sidebar]'), bd = q('[data-filter-backdrop]');
    if (sb) sb.style.display = '';
    if (bd) bd.style.display = '';
    /* QA BUG-BV-128: also lock <html> — body{overflow:hidden} alone doesn't hold
       under the theme's html{overflow-x:clip}, so the grid behind still scrolled. */
    if (isMobile()) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
    setBodyFiltered(!isMobile());
    setFilterBtnActive(true);
    sidebarOpen = true;
    /* QA BUG-BV-126: while the mobile filter drawer is open, hide the Gorgias
       chat launcher so its collapsed bubble can't sit over the Apply button's
       right edge (CSS below is mobile-gated, so desktop keeps the launcher). */
    document.body.classList.add('has-filter-drawer-open');
  }
  function closeSidebar() {
    var sb = q('[data-filter-sidebar]'), bd = q('[data-filter-backdrop]');
    if (sb) sb.style.display = 'none';
    if (bd) bd.style.display = 'none';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    setBodyFiltered(false);
    setFilterBtnActive(false);
    sidebarOpen = false;
    document.body.classList.remove('has-filter-drawer-open');
  }
  function hasActiveFilters() {
    var sb = q('[data-filter-sidebar]');
    return !!(sb && sb.getAttribute('data-has-active-filters') === '1');
  }

  /* ---------- AJAX render via Section Rendering API ---------- */
  var pending = null;
  function ajaxRender(url, push) {
    var sid = sectionId();
    if (!sid || !('fetch' in window) || !('DOMParser' in window)) { window.location = url; return; }
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid);
    var live = q('[data-collection]');
    if (live) live.classList.add('collection--loading');
    if (pending && pending.abort) pending.abort();
    pending = ('AbortController' in window) ? new AbortController() : null;
    fetch(fetchUrl, pending ? { signal: pending.signal } : undefined)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-collection]');
        var current = q('[data-collection]');
        if (!incoming || !current) { window.location = url; return; }
        current.replaceWith(incoming);
        // Mobile item count sits outside [data-collection]; keep it in sync.
        var newCount = doc.querySelector('[data-collection-count]');
        var liveCount = q('[data-collection-count]');
        if (newCount && liveCount) liveCount.replaceWith(newCount);
        if (push !== false) history.pushState({ bvCollection: 1 }, '', url);
        initDynamic();
        // Keep the desktop sidebar open through filtering.
        if (!isMobile() && (sidebarOpen || hasActiveFilters())) restoreSidebarInstantly();
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        window.location = url;
      });
  }

  // Build the filtered URL from the sidebar GET form (mirrors a native submit).
  function buildFormUrl(form) {
    var fd = new FormData(form);
    var parts = [];
    fd.forEach(function (v, k) {
      if (v !== '' && v != null) parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });
    var action = form.getAttribute('action') || location.pathname;
    return action + (parts.length ? '?' + parts.join('&') : '');
  }

  /* ---------- delegated interactions (bound once, survive swaps) ---------- */

  // Desktop: checkbox change auto-applies (CTA bar is hidden on desktop).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'checkbox') return;
    var form = input.closest && input.closest('[data-filter-form]');
    if (!form || isMobile()) return;
    ajaxRender(buildFormUrl(form), true);
  });

  // Filter form submit: mobile Apply (animate sheet down first) / desktop Apply.
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-filter-form]') : null;
    if (!form) return;
    e.preventDefault();
    var url = buildFormUrl(form);
    if (isMobile()) {
      var sb = q('[data-filter-sidebar]'), bd = q('[data-filter-backdrop]');
      if (sb) sb.classList.add('collection__sidebar--closing');
      if (bd) bd.classList.add('collection__sidebar-backdrop--closing');
      setTimeout(function () { closeSidebar(); ajaxRender(url, true); }, 250);
    } else {
      ajaxRender(url, true);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-filter-toggle]')) {
      var sb = q('[data-filter-sidebar]');
      if (sb && sb.style.display !== 'none') closeSidebar(); else openSidebar();
      return;
    }
    if (t.closest('[data-filter-close]') || t.closest('[data-filter-backdrop]')) { closeSidebar(); return; }

    // Mobile: open sidebar with only the tapped group expanded.
    var groupBtn = t.closest('[data-mobile-filter-group]');
    if (groupBtn) {
      var label = groupBtn.getAttribute('data-mobile-filter-group');
      openSidebar();
      qa('[data-filter-sidebar] [data-filter-group]').forEach(function (group) {
        var nameEl = group.querySelector('.filter-group__name');
        var body = group.querySelector('[data-filter-body]');
        if (!body) return;
        var match = nameEl && nameEl.textContent.trim() === label;
        body.style.display = match ? '' : 'none';
        group.classList.toggle('filter-group--open', match);
      });
      return;
    }

    // Accordion open / close.
    var acc = t.closest('[data-filter-accordion]');
    if (acc) {
      var g = acc.closest('[data-filter-group]');
      var body2 = g && g.querySelector('[data-filter-body]');
      if (body2) {
        var open = body2.style.display !== 'none';
        body2.style.display = open ? 'none' : '';
        g.classList.toggle('filter-group--open', !open);
      }
      return;
    }

    // Desktop sort dropdown trigger.
    var sortTrigger = t.closest('[data-sort-trigger]');
    if (sortTrigger) {
      e.stopPropagation();
      var wrap = sortTrigger.closest('[data-sort-wrap]');
      qa('[data-sort-wrap]').forEach(function (o) { if (o !== wrap) o.classList.remove('collection__sort--open'); });
      if (wrap) wrap.classList.toggle('collection__sort--open');
      return;
    }

    // Sort option (desktop dropdown or mobile sheet).
    var sortBtn = t.closest('[data-sort]');
    if (sortBtn) {
      e.stopPropagation();
      var sortVal = sortBtn.getAttribute('data-sort');
      var u = new URL(window.location.href);
      if (sortVal) u.searchParams.set('sort_by', sortVal); else u.searchParams.delete('sort_by');
      u.searchParams.delete('page');
      var target = u.pathname + u.search;
      if (sortBtn.closest('[data-sort-sheet]')) {
        closeSortSheet(function () { ajaxRender(target, true); });
      } else {
        qa('[data-sort-wrap]').forEach(function (w) { w.classList.remove('collection__sort--open'); });
        ajaxRender(target, true);
      }
      return;
    }

    // Mobile sort sheet open / close.
    if (t.closest('[data-sort-sheet-trigger]')) { openSortSheet(); return; }
    if (t.closest('[data-sort-sheet-close]') || t.closest('[data-sort-sheet-backdrop]')) { closeSortSheet(); return; }

    // Top category strip (facet-card mode): clicking a card TOGGLES its facet
    // value (param from data-facet-param, e.g. filter.p.tag) on the current URL
    // — unified with the left "Category" sidebar. Toggle is computed in JS (add
    // if absent, remove if present) so the strip needn't be swapped per filter.
    var facetCard = t.closest('a.collection-guides__card[data-facet-card]');
    if (facetCard) {
      e.preventDefault();
      var param = facetCard.getAttribute('data-facet-param') || 'filter.p.tag';
      var val = facetCard.getAttribute('data-facet-value');
      var cu = new URL(window.location.href);
      var existing = cu.searchParams.getAll(param);
      var wasActive = existing.indexOf(val) !== -1;
      cu.searchParams.delete(param);
      cu.searchParams.delete('page');
      existing.forEach(function (p) { if (p !== val) cu.searchParams.append(param, p); });
      if (!wasActive) cu.searchParams.append(param, val);
      ajaxRender(cu.pathname + cu.search, true);
      // Vuori-style: bring the filter bar + results into view so the filtered
      // products are visible instead of staying hidden under the big card row.
      // Only on card clicks — sidebar/chip/sort are already at results level.
      scrollToResults();
      return;
    }

    // Active-filter chips / clear links → intercept the <a href> and AJAX it.
    // (Mobile checkbox-derived pills carry data-pill-name and are toggled by
    // filter-sidebar's own handler before Apply — don't hijack those on mobile.)
    var link = t.closest('a.collection__tag, a.collection__clear-btn, a.collection__sidebar-clear, a.filter-active-tag[href]');
    if (link && link.getAttribute('href')) {
      if (link.hasAttribute('data-pill-name') && isMobile()) return;
      e.preventDefault();
      ajaxRender(link.getAttribute('href'), true);
      return;
    }

    // Outside click closes any open desktop sort dropdown.
    if (!t.closest('[data-sort-wrap]')) {
      qa('[data-sort-wrap]').forEach(function (w) { w.classList.remove('collection__sort--open'); });
    }
  });

  // Back / forward navigation re-renders the corresponding filtered view.
  window.addEventListener('popstate', function () {
    ajaxRender(location.pathname + location.search, false);
  });

  /* ---------- mobile sort bottom sheet ---------- */
  var SORT_SHEET_ANIM_MS = 250;
  function openSortSheet() {
    var sheet = q('[data-sort-sheet]'), bd = q('[data-sort-sheet-backdrop]');
    if (sheet) sheet.style.display = '';
    if (bd) bd.style.display = 'block';
    requestAnimationFrame(function () {
      if (sheet) sheet.classList.add('is-open');
      if (bd) bd.classList.add('is-open');
    });
  }
  function closeSortSheet(onClosed) {
    var sheet = q('[data-sort-sheet]'), bd = q('[data-sort-sheet-backdrop]');
    if (sheet) sheet.classList.remove('is-open');
    if (bd) bd.classList.remove('is-open');
    setTimeout(function () {
      if (sheet) sheet.style.display = 'none';
      if (bd) bd.style.display = 'none';
      if (typeof onClosed === 'function') onClosed();
    }, SORT_SHEET_ANIM_MS);
  }

  // Reflect the active product-category facet values on the top strip cards
  // (underline). The strip DOM is intentionally NOT swapped on AJAX (keeps its
  // representative images stable), so active state is toggled here from the URL.
  function syncGuideActive() {
    var params = new URL(window.location.href).searchParams;
    qa('a.collection-guides__card[data-facet-card]').forEach(function (card) {
      var p = card.getAttribute('data-facet-param') || 'filter.p.tag';
      var v = card.getAttribute('data-facet-value');
      card.classList.toggle('collection-guides__card--active', params.getAll(p).indexOf(v) !== -1);
    });
  }

  /* ---------- per-render (stateful) init ---------- */
  var observer = null;
  function initDynamic() {
    syncGuideActive();
    syncFilterMetrics();
    if (observer) { observer.disconnect(); observer = null; }
    var grid = q('[data-product-grid]');
    var logoArea = q('[data-infinite-scroll]');
    if (!grid || !logoArea || !logoArea.dataset.nextUrl) return;

    var loading = false;
    var nextUrl = logoArea.dataset.nextUrl;

    function isElementInViewport(el) {
      return el.getBoundingClientRect().top < window.innerHeight + 200;
    }
    function loadMore() {
      if (!nextUrl || loading) return;
      loading = true;
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          tmp.querySelectorAll('[data-product-grid] .product-card').forEach(function (card) {
            // product-card marks the first row of each rendered page as the LCP
            // candidate (eager + fetchpriority=high, keyed on card_index). That
            // is right for a direct ?page=N load, but an APPENDED page is never
            // the LCP — leaving the hint on makes page 2's first image outrank
            // the images the shopper is currently looking at. Downgrade it.
            card.querySelectorAll('img[fetchpriority="high"]').forEach(function (img) {
              img.setAttribute('fetchpriority', 'auto');
            });
            grid.appendChild(card);
          });
          var newLogoArea = tmp.querySelector('[data-infinite-scroll]');
          if (newLogoArea && newLogoArea.dataset.nextUrl) {
            nextUrl = newLogoArea.dataset.nextUrl;
          } else {
            nextUrl = null;
            if (observer) observer.disconnect();
            logoArea.style.display = 'none';
            grid.classList.add('collection__grid--done');
          }
          loading = false;
          if (nextUrl && isElementInViewport(logoArea)) loadMore();
        })
        .catch(function () { loading = false; });
    }

    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !loading && nextUrl) loadMore();
    }, { rootMargin: '200px' });
    observer.observe(logoArea);
  }

  /* ---------- initial ---------- */
  // initDynamic() first: it seeds --filters-w / --card-w, which the column
  // needs before it is shown.
  initDynamic();
  if (hasActiveFilters() && !isMobile()) restoreSidebarInstantly();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-v3"]) return;
  try {
    
/* ═══ Collection v3 — v2's AJAX faceted filtering + in-grid promo tiles ═══
   A hand-kept copy of sections/collection-v2.liquid's engine. Section JS only
   runs for sections actually rendered on the page, so this copy never collides
   with v1's or v2's despite sharing every data attribute (verified on prod
   2026-08-06 — see the comment at the top of this file).

   The ONLY diff from v2 is inside loadMore(): the appended nodes are the
   incoming grid's children rather than its `.product-card`s, so promo tiles
   survive pagination. Keep the rest in sync with v2 by hand.

   INTENTIONALLY DIVERGES from sections/collection.liquid (which keeps the
   original full-reload flow). Here every filter / sort / chip / clear applies
   via the Section Rendering API (?section_id=…) with no page reload, matching
   the Vuori-style in-page filtering UX.

   Design: all user interactions are bound via delegation on `document` so they
   survive the DOM swaps that AJAX rendering performs (no re-binding needed).
   Only stateful bits (infinite-scroll observer + desktop sidebar auto-open) are
   re-initialised after each swap via initDynamic(). Any fetch failure falls
   back to a normal full-page navigation so filtering never hard-breaks.

   Once the `product_type` facet is enabled in Search & Discovery it appears as
   the left "Category" group automatically (rendered by filter-sidebar) and is
   driven by this same engine — no extra JS. */
(function () {
  if (!document.querySelector('[data-collection]')) return;

  function q(sel) { return document.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }
  function sectionId() {
    var el = q('[data-collection]');
    return el ? el.getAttribute('data-collection-section') : null;
  }

  // Smooth-scroll the filter bar + grid into view (Vuori-style), offset for a
  // sticky header so the toolbar isn't hidden under it. Used on category-card
  // clicks, where the results otherwise stay below the tall card row.
  function scrollToResults() {
    var anchor = q('.collection__toolbar') || q('[data-collection]');
    if (!anchor) return;
    // Once scrolled, the sticky header group pins ONLY its inner nav bar
    // (.header-main ~69px) — the announcement bar scrolls off (group sticky top
    // is negative). Offset by that pinned bar so the filter row lands snug just
    // below it (Figma target), not with the full-group gap. +20px breathing room.
    var offset = 0;
    var bar = q('.header-main');
    if (bar) {
      offset = bar.getBoundingClientRect().height;
    } else {
      var grp = q('.shopify-section-group-header-group');
      if (grp) offset = grp.getBoundingClientRect().height + (parseFloat(getComputedStyle(grp).top) || 0);
    }
    var top = anchor.getBoundingClientRect().top + window.scrollY - offset - 20;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  }

  /* ---------- sidebar open / close ---------- */
  var sidebarOpen = false; // tracked across renders to preserve desktop state
  function setFilterBtnActive(on) {
    qa('.collection__filter-btn').forEach(function (b) {
      b.classList.toggle('collection__filter-btn--active', on);
    });
  }
  /* Drives the desktop column count: with the sidebar taking its track the grid
     is 3-up (Figma 7318:78257), without it 4-up (12928:63535). Keyed off an
     explicit class rather than the sidebar's inline display so the CSS does not
     have to sniff a style attribute. Desktop only — below 769 the sidebar is a
     modal overlay and the grid stays 2-up. */
  function setBodyFiltered(on) {
    var body = q('[data-collection-body]');
    if (body) body.classList.toggle('collection__body--filtered', on);
  }
  function openSidebar() {
    var sb = q('[data-filter-sidebar]'), bd = q('[data-filter-backdrop]');
    if (sb) sb.style.display = '';
    if (bd) bd.style.display = '';
    /* QA BUG-BV-128: also lock <html> — body{overflow:hidden} alone doesn't hold
       under the theme's html{overflow-x:clip}, so the grid behind still scrolled. */
    if (isMobile()) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
    setBodyFiltered(!isMobile());
    setFilterBtnActive(true);
    sidebarOpen = true;
    /* QA BUG-BV-126: while the mobile filter drawer is open, hide the Gorgias
       chat launcher so its collapsed bubble can't sit over the Apply button's
       right edge (CSS below is mobile-gated, so desktop keeps the launcher). */
    document.body.classList.add('has-filter-drawer-open');
  }
  function closeSidebar() {
    var sb = q('[data-filter-sidebar]'), bd = q('[data-filter-backdrop]');
    if (sb) sb.style.display = 'none';
    if (bd) bd.style.display = 'none';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    setBodyFiltered(false);
    setFilterBtnActive(false);
    sidebarOpen = false;
    document.body.classList.remove('has-filter-drawer-open');
  }
  function hasActiveFilters() {
    var sb = q('[data-filter-sidebar]');
    return !!(sb && sb.getAttribute('data-has-active-filters') === '1');
  }

  /* ---------- AJAX render via Section Rendering API ---------- */
  var pending = null;
  function ajaxRender(url, push) {
    var sid = sectionId();
    if (!sid || !('fetch' in window) || !('DOMParser' in window)) { window.location = url; return; }
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid);
    var live = q('[data-collection]');
    if (live) live.classList.add('collection--loading');
    if (pending && pending.abort) pending.abort();
    pending = ('AbortController' in window) ? new AbortController() : null;
    fetch(fetchUrl, pending ? { signal: pending.signal } : undefined)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-collection]');
        var current = q('[data-collection]');
        if (!incoming || !current) { window.location = url; return; }
        current.replaceWith(incoming);
        // Mobile item count sits outside [data-collection]; keep it in sync.
        var newCount = doc.querySelector('[data-collection-count]');
        var liveCount = q('[data-collection-count]');
        if (newCount && liveCount) liveCount.replaceWith(newCount);
        if (push !== false) history.pushState({ bvCollection: 1 }, '', url);
        initDynamic();
        // Keep the desktop sidebar open through filtering.
        if (!isMobile() && (sidebarOpen || hasActiveFilters())) openSidebar();
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        window.location = url;
      });
  }

  // Build the filtered URL from the sidebar GET form (mirrors a native submit).
  function buildFormUrl(form) {
    var fd = new FormData(form);
    var parts = [];
    fd.forEach(function (v, k) {
      if (v !== '' && v != null) parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });
    var action = form.getAttribute('action') || location.pathname;
    return action + (parts.length ? '?' + parts.join('&') : '');
  }

  /* ---------- delegated interactions (bound once, survive swaps) ---------- */

  // Desktop: checkbox change auto-applies (CTA bar is hidden on desktop).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'checkbox') return;
    var form = input.closest && input.closest('[data-filter-form]');
    if (!form || isMobile()) return;
    ajaxRender(buildFormUrl(form), true);
  });

  // Filter form submit: mobile Apply (animate sheet down first) / desktop Apply.
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-filter-form]') : null;
    if (!form) return;
    e.preventDefault();
    var url = buildFormUrl(form);
    if (isMobile()) {
      var sb = q('[data-filter-sidebar]'), bd = q('[data-filter-backdrop]');
      if (sb) sb.classList.add('collection__sidebar--closing');
      if (bd) bd.classList.add('collection__sidebar-backdrop--closing');
      setTimeout(function () { closeSidebar(); ajaxRender(url, true); }, 250);
    } else {
      ajaxRender(url, true);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-filter-toggle]')) {
      var sb = q('[data-filter-sidebar]');
      if (sb && sb.style.display !== 'none') closeSidebar(); else openSidebar();
      return;
    }
    if (t.closest('[data-filter-close]') || t.closest('[data-filter-backdrop]')) { closeSidebar(); return; }

    // Mobile: open sidebar with only the tapped group expanded.
    var groupBtn = t.closest('[data-mobile-filter-group]');
    if (groupBtn) {
      var label = groupBtn.getAttribute('data-mobile-filter-group');
      openSidebar();
      qa('[data-filter-sidebar] [data-filter-group]').forEach(function (group) {
        var nameEl = group.querySelector('.filter-group__name');
        var body = group.querySelector('[data-filter-body]');
        if (!body) return;
        var match = nameEl && nameEl.textContent.trim() === label;
        body.style.display = match ? '' : 'none';
        group.classList.toggle('filter-group--open', match);
      });
      return;
    }

    // Accordion open / close.
    var acc = t.closest('[data-filter-accordion]');
    if (acc) {
      var g = acc.closest('[data-filter-group]');
      var body2 = g && g.querySelector('[data-filter-body]');
      if (body2) {
        var open = body2.style.display !== 'none';
        body2.style.display = open ? 'none' : '';
        g.classList.toggle('filter-group--open', !open);
      }
      return;
    }

    // Desktop sort dropdown trigger.
    var sortTrigger = t.closest('[data-sort-trigger]');
    if (sortTrigger) {
      e.stopPropagation();
      var wrap = sortTrigger.closest('[data-sort-wrap]');
      qa('[data-sort-wrap]').forEach(function (o) { if (o !== wrap) o.classList.remove('collection__sort--open'); });
      if (wrap) wrap.classList.toggle('collection__sort--open');
      return;
    }

    // Sort option (desktop dropdown or mobile sheet).
    var sortBtn = t.closest('[data-sort]');
    if (sortBtn) {
      e.stopPropagation();
      var sortVal = sortBtn.getAttribute('data-sort');
      var u = new URL(window.location.href);
      if (sortVal) u.searchParams.set('sort_by', sortVal); else u.searchParams.delete('sort_by');
      u.searchParams.delete('page');
      var target = u.pathname + u.search;
      if (sortBtn.closest('[data-sort-sheet]')) {
        closeSortSheet(function () { ajaxRender(target, true); });
      } else {
        qa('[data-sort-wrap]').forEach(function (w) { w.classList.remove('collection__sort--open'); });
        ajaxRender(target, true);
      }
      return;
    }

    // Mobile sort sheet open / close.
    if (t.closest('[data-sort-sheet-trigger]')) { openSortSheet(); return; }
    if (t.closest('[data-sort-sheet-close]') || t.closest('[data-sort-sheet-backdrop]')) { closeSortSheet(); return; }

    // Top category strip (facet-card mode): clicking a card TOGGLES its facet
    // value (param from data-facet-param, e.g. filter.p.tag) on the current URL
    // — unified with the left "Category" sidebar. Toggle is computed in JS (add
    // if absent, remove if present) so the strip needn't be swapped per filter.
    var facetCard = t.closest('a.collection-guides__card[data-facet-card]');
    if (facetCard) {
      e.preventDefault();
      var param = facetCard.getAttribute('data-facet-param') || 'filter.p.tag';
      var val = facetCard.getAttribute('data-facet-value');
      var cu = new URL(window.location.href);
      var existing = cu.searchParams.getAll(param);
      var wasActive = existing.indexOf(val) !== -1;
      cu.searchParams.delete(param);
      cu.searchParams.delete('page');
      existing.forEach(function (p) { if (p !== val) cu.searchParams.append(param, p); });
      if (!wasActive) cu.searchParams.append(param, val);
      ajaxRender(cu.pathname + cu.search, true);
      // Vuori-style: bring the filter bar + results into view so the filtered
      // products are visible instead of staying hidden under the big card row.
      // Only on card clicks — sidebar/chip/sort are already at results level.
      scrollToResults();
      return;
    }

    // Active-filter chips / clear links → intercept the <a href> and AJAX it.
    // (Mobile checkbox-derived pills carry data-pill-name and are toggled by
    // filter-sidebar's own handler before Apply — don't hijack those on mobile.)
    var link = t.closest('a.collection__tag, a.collection__clear-btn, a.collection__sidebar-clear, a.filter-active-tag[href]');
    if (link && link.getAttribute('href')) {
      if (link.hasAttribute('data-pill-name') && isMobile()) return;
      e.preventDefault();
      ajaxRender(link.getAttribute('href'), true);
      return;
    }

    // Outside click closes any open desktop sort dropdown.
    if (!t.closest('[data-sort-wrap]')) {
      qa('[data-sort-wrap]').forEach(function (w) { w.classList.remove('collection__sort--open'); });
    }
  });

  // Back / forward navigation re-renders the corresponding filtered view.
  window.addEventListener('popstate', function () {
    ajaxRender(location.pathname + location.search, false);
  });

  /* ---------- mobile sort bottom sheet ---------- */
  var SORT_SHEET_ANIM_MS = 250;
  function openSortSheet() {
    var sheet = q('[data-sort-sheet]'), bd = q('[data-sort-sheet-backdrop]');
    if (sheet) sheet.style.display = '';
    if (bd) bd.style.display = 'block';
    requestAnimationFrame(function () {
      if (sheet) sheet.classList.add('is-open');
      if (bd) bd.classList.add('is-open');
    });
  }
  function closeSortSheet(onClosed) {
    var sheet = q('[data-sort-sheet]'), bd = q('[data-sort-sheet-backdrop]');
    if (sheet) sheet.classList.remove('is-open');
    if (bd) bd.classList.remove('is-open');
    setTimeout(function () {
      if (sheet) sheet.style.display = 'none';
      if (bd) bd.style.display = 'none';
      if (typeof onClosed === 'function') onClosed();
    }, SORT_SHEET_ANIM_MS);
  }

  // Reflect the active product-category facet values on the top strip cards
  // (underline). The strip DOM is intentionally NOT swapped on AJAX (keeps its
  // representative images stable), so active state is toggled here from the URL.
  function syncGuideActive() {
    var params = new URL(window.location.href).searchParams;
    qa('a.collection-guides__card[data-facet-card]').forEach(function (card) {
      var p = card.getAttribute('data-facet-param') || 'filter.p.tag';
      var v = card.getAttribute('data-facet-value');
      card.classList.toggle('collection-guides__card--active', params.getAll(p).indexOf(v) !== -1);
    });
  }

  /* ---------- per-render (stateful) init ---------- */
  var observer = null;
  function initDynamic() {
    syncGuideActive();
    if (observer) { observer.disconnect(); observer = null; }
    var grid = q('[data-product-grid]');
    var logoArea = q('[data-infinite-scroll]');
    if (!grid || !logoArea || !logoArea.dataset.nextUrl) return;

    var loading = false;
    var nextUrl = logoArea.dataset.nextUrl;

    function isElementInViewport(el) {
      return el.getBoundingClientRect().top < window.innerHeight + 200;
    }
    function loadMore() {
      if (!nextUrl || loading) return;
      loading = true;
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          // v3 diff: walk the incoming grid's CHILDREN, not `.product-card`.
          // The v3 grid also holds .plp-promo-tile items, and a `.product-card`
          // selector would drop every promo tile that lands on page 2+ — with
          // no error, so the tile would simply never appear.
          var incomingGrid = tmp.querySelector('[data-product-grid]');
          var incoming = incomingGrid ? Array.prototype.slice.call(incomingGrid.children) : [];
          incoming.forEach(function (node) {
            // product-card marks the first row of each rendered page as the LCP
            // candidate (eager + fetchpriority=high, keyed on card_index). That
            // is right for a direct ?page=N load, but an APPENDED page is never
            // the LCP — leaving the hint on makes page 2's first image outrank
            // the images the shopper is currently looking at. Downgrade it.
            node.querySelectorAll('img[fetchpriority="high"]').forEach(function (img) {
              img.setAttribute('fetchpriority', 'auto');
            });
            grid.appendChild(node);
          });
          var newLogoArea = tmp.querySelector('[data-infinite-scroll]');
          if (newLogoArea && newLogoArea.dataset.nextUrl) {
            nextUrl = newLogoArea.dataset.nextUrl;
          } else {
            nextUrl = null;
            if (observer) observer.disconnect();
            logoArea.style.display = 'none';
            grid.classList.add('collection__grid--done');
          }
          loading = false;
          if (nextUrl && isElementInViewport(logoArea)) loadMore();
        })
        .catch(function () { loading = false; });
    }

    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !loading && nextUrl) loadMore();
    }, { rootMargin: '200px' });
    observer.observe(logoArea);
  }

  /* ---------- initial ---------- */
  if (hasActiveFilters() && !isMobile()) openSidebar();
  initDynamic();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
/* Collection v1 — filter column, sorting and in-page filtering.

   BUG-BV-13: every checkbox used to call filterForm.submit(), so each facet the
   shopper ticked cost a full page navigation, and a multi-select meant one round
   trip per value. Reproduced on prod 2026-08-06 on /collections/tees — 19 of the
   39 live collections still render THIS section (the other 20 are v2), so the
   slow path was far from a corner case. Filtering now applies through the
   Section Rendering API exactly the way collection-v2.liquid does: one fetch,
   one DOM swap, no reload.

   BUG-BV-09 rides along: the group open/closed state is restored after each
   render by snippets/filter-sidebar.liquid, so unticking a group's last value no
   longer collapses it under the shopper.

   Design (mirrors collection-v2.liquid): every interaction is DELEGATED on
   document so it survives the swaps. The previous build cached elements at load
   — accordion, close, sort, toggles — and every one of those handlers would go
   dead the first time the section was replaced. Only stateful things (infinite
   scroll observer, column metrics, sidebar restore) are re-run per render via
   initDynamic(). Any fetch failure falls back to a full navigation, so filtering
   can never hard-break. */
(function () {
  if (!document.querySelector('[data-collection]')) return;

  function q(sel) { return document.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  /* v1 has always keyed its sidebar behaviour off innerWidth, not matchMedia —
     kept as-is so the 768px boundary behaves identically to before. */
  function isMobile() { return window.innerWidth <= 768; }

  function sectionId() {
    var el = q('[data-collection]');
    return el ? el.getAttribute('data-collection-section') : null;
  }

  function setFilterBtnActive(isActive) {
    qa('.collection__filter-btn').forEach(function (btn) {
      btn.classList.toggle('collection__filter-btn--active', isActive);
    });
  }

  /* The grid column counts key off this class rather than the sidebar's inline
     display, so the 3-up / 4-up switch is an explicit state instead of a
     style-attribute sniff. Only meaningful >768px — below that the sidebar is a
     modal overlay and the grid is 2-up regardless. */
  function setBodyFiltered(on) {
    var body = q('[data-collection-body]');
    if (body) body.classList.toggle('collection__body--filtered', on);
  }

  /* Desktop filter-column metrics. Both values are derived from the body's
     FULL width, which does not change when the sidebar opens — that is what
     keeps the card width identical in the 4-up and 3-up states, so the grid
     reflows without the cards ever resizing. See the --anim CSS block for the
     geometry. Percentages can't express these: inside the sidebar a % would
     resolve against the column's own animating width, and inside the grid
     against the shrinking list.

     Re-run from initDynamic(): the swap replaces [data-collection] wholesale,
     taking the inline custom properties — and the observed node — with it. */
  var metricsObserver = null;
  function syncFilterMetrics() {
    var body = q('[data-collection-body]');
    if (!body) return;
    var w = body.clientWidth;
    if (!w) return;
    body.style.setProperty('--filters-w', w * 0.25 + 2 + 'px');
    body.style.setProperty('--card-w', (w - 12) / 4 - 0.5 + 'px');
    if (window.ResizeObserver) {
      if (metricsObserver) metricsObserver.disconnect();
      metricsObserver = new ResizeObserver(function () {
        var b = q('[data-collection-body]');
        if (!b || !b.clientWidth) return;
        b.style.setProperty('--filters-w', b.clientWidth * 0.25 + 2 + 'px');
        b.style.setProperty('--card-w', (b.clientWidth - 12) / 4 - 0.5 + 'px');
      });
      metricsObserver.observe(body);
    }
  }

  var sidebarOpen = false; /* tracked across renders to preserve desktop state */

  function openSidebar() {
    var sb = q('[data-filter-sidebar]');
    var bd = q('[data-filter-backdrop]');
    if (sb) sb.style.display = '';
    setBodyFiltered(!isMobile());
    /* Clear inline display so CSS decides: desktop keeps the backdrop hidden
       (preventing a 0-width flex item from adding a 40px gap before the
       sidebar), mobile shows the overlay. */
    if (bd) bd.style.display = '';
    /* Lock body scroll only on mobile — desktop sidebar is inline, not a modal.
       QA BUG-BV-128: body{overflow:hidden} alone does NOT lock scroll here — the
       theme sets html{overflow-x:clip}, which makes <html> the scroll container and
       swallows the propagation, so the grid behind still scrolled. Lock the
       documentElement too. */
    if (isMobile()) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
    setFilterBtnActive(true);
    sidebarOpen = true;
    /* QA BUG-BV-126: while the mobile filter drawer is open, hide the Gorgias
       chat launcher so its collapsed bubble can't sit over the Apply button's
       right edge (CSS below is mobile-gated, so desktop keeps the launcher). */
    document.body.classList.add('has-filter-drawer-open');
  }

  function closeSidebar() {
    var sb = q('[data-filter-sidebar]');
    var bd = q('[data-filter-backdrop]');
    if (sb) sb.style.display = 'none';
    setBodyFiltered(false);
    if (bd) bd.style.display = 'none';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    setFilterBtnActive(false);
    sidebarOpen = false;
    document.body.classList.remove('has-filter-drawer-open');
  }

  function hasActiveFilters() {
    var sb = q('[data-filter-sidebar]');
    return !!(sb && sb.getAttribute('data-has-active-filters') === '1');
  }

  /* Re-open the column without replaying the 300ms slide. The swapped-in body
     always arrives closed, so a plain openSidebar() after a filter tick would
     animate it open again on every single checkbox. */
  function restoreSidebarInstantly() {
    var body = q('[data-collection-body]');
    if (body) body.classList.add('collection__body--instant');
    openSidebar();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var b = q('[data-collection-body]');
        if (b) b.classList.remove('collection__body--instant');
      });
    });
  }

  /* ---------- AJAX render via Section Rendering API ---------- */
  var pending = null;
  function ajaxRender(url, push) {
    var sid = sectionId();
    if (!sid || !('fetch' in window) || !('DOMParser' in window)) { window.location = url; return; }
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid);
    var live = q('[data-collection]');
    if (live) live.classList.add('collection--loading');
    if (pending && pending.abort) pending.abort();
    pending = ('AbortController' in window) ? new AbortController() : null;
    fetch(fetchUrl, pending ? { signal: pending.signal } : undefined)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-collection]');
        var current = q('[data-collection]');
        if (!incoming || !current) { window.location = url; return; }
        current.replaceWith(incoming);
        /* The mobile item count sits outside [data-collection] — keep it in sync. */
        var newCount = doc.querySelector('[data-collection-count]');
        var liveCount = q('[data-collection-count]');
        if (newCount && liveCount) liveCount.replaceWith(newCount);
        if (push !== false) history.pushState({ bvCollection: 1 }, '', url);
        initDynamic();
        /* Keep the desktop sidebar open through filtering. */
        if (!isMobile() && (sidebarOpen || hasActiveFilters())) restoreSidebarInstantly();
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        window.location = url;
      });
  }

  /* Build the filtered URL from the sidebar GET form (mirrors a native submit). */
  function buildFormUrl(form) {
    var fd = new FormData(form);
    var parts = [];
    fd.forEach(function (v, k) {
      if (v !== '' && v != null) parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });
    var action = form.getAttribute('action') || location.pathname;
    return action + (parts.length ? '?' + parts.join('&') : '');
  }

  function sortedUrl(sortVal) {
    var url = new URL(window.location.href);
    if (sortVal) url.searchParams.set('sort_by', sortVal);
    else url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    return url.pathname + url.search;
  }

  /* ---------- mobile sort bottom sheet ---------- */
  var SORT_SHEET_ANIM_MS = 250;
  function openSortSheet() {
    var sheet = q('[data-sort-sheet]');
    var bd = q('[data-sort-sheet-backdrop]');
    if (sheet) sheet.style.display = '';
    if (bd) bd.style.display = 'block';
    /* Next frame so the browser registers the initial transform/opacity before
       transitioning to the open state. */
    requestAnimationFrame(function () {
      if (sheet) sheet.classList.add('is-open');
      if (bd) bd.classList.add('is-open');
    });
  }
  function closeSortSheet(onClosed) {
    var sheet = q('[data-sort-sheet]');
    var bd = q('[data-sort-sheet-backdrop]');
    if (sheet) sheet.classList.remove('is-open');
    if (bd) bd.classList.remove('is-open');
    setTimeout(function () {
      if (sheet) sheet.style.display = 'none';
      if (bd) bd.style.display = 'none';
      if (typeof onClosed === 'function') onClosed();
    }, SORT_SHEET_ANIM_MS);
  }

  /* ---------- delegated interactions (bound once, survive swaps) ---------- */

  /* Desktop: checkbox change auto-applies (the Apply CTA is hidden on desktop). */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'checkbox') return;
    var form = input.closest && input.closest('[data-filter-form]');
    if (!form || isMobile()) return;
    ajaxRender(buildFormUrl(form), true);
  });

  /* Mobile Apply: slide the bottom sheet down before applying, so the user
     doesn't watch a frozen sheet during the round-trip. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-filter-form]');
    if (!form) return;
    e.preventDefault();
    var url = buildFormUrl(form);
    if (!isMobile()) { ajaxRender(url, true); return; }
    var sb = q('[data-filter-sidebar]');
    var bd = q('[data-filter-backdrop]');
    if (sb) sb.classList.add('collection__sidebar--closing');
    if (bd) bd.classList.add('collection__sidebar-backdrop--closing');
    setTimeout(function () {
      if (sb) sb.classList.remove('collection__sidebar--closing');
      if (bd) bd.classList.remove('collection__sidebar-backdrop--closing');
      closeSidebar();
      ajaxRender(url, true);
    }, 250);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;

    /* Sidebar open / close. */
    if (t.closest('[data-filter-toggle]')) {
      var sb = q('[data-filter-sidebar]');
      if (!sb) return;
      if (sb.style.display !== 'none') closeSidebar(); else openSidebar();
      return;
    }
    if (t.closest('[data-filter-close]') || t.closest('[data-filter-backdrop]')) { closeSidebar(); return; }

    /* Mobile: open the sidebar with only the tapped group expanded, so the user
       lands directly on the relevant section. */
    var groupBtn = t.closest('[data-mobile-filter-group]');
    if (groupBtn) {
      var label = groupBtn.getAttribute('data-mobile-filter-group');
      openSidebar();
      qa('[data-filter-sidebar] [data-filter-group]').forEach(function (group) {
        var nameEl = group.querySelector('.filter-group__name');
        var body = group.querySelector('[data-filter-body]');
        if (!body) return;
        var match = nameEl && nameEl.textContent.trim() === label;
        body.style.display = match ? '' : 'none';
        group.classList.toggle('filter-group--open', match);
      });
      return;
    }

    /* Accordion open / close. */
    var acc = t.closest('[data-filter-accordion]');
    if (acc) {
      var g = acc.closest('[data-filter-group]');
      var accBody = g && g.querySelector('[data-filter-body]');
      if (accBody) {
        var open = accBody.style.display !== 'none';
        accBody.style.display = open ? 'none' : '';
        g.classList.toggle('filter-group--open', !open);
      }
      return;
    }

    /* Desktop sort dropdown trigger. */
    var sortTrigger = t.closest('[data-sort-trigger]');
    if (sortTrigger) {
      e.stopPropagation();
      var wrap = sortTrigger.closest('[data-sort-wrap]');
      qa('[data-sort-wrap]').forEach(function (o) { if (o !== wrap) o.classList.remove('collection__sort--open'); });
      if (wrap) wrap.classList.toggle('collection__sort--open');
      return;
    }

    /* Sort option — desktop dropdown or mobile sheet. */
    var sortBtn = t.closest('[data-sort]');
    if (sortBtn) {
      e.stopPropagation();
      var target = sortedUrl(sortBtn.getAttribute('data-sort'));
      var sheet = sortBtn.closest('[data-sort-sheet]');
      if (sheet) {
        /* Mark the tapped option active so the choice registers before the
           sheet slides away. */
        sheet.querySelectorAll('.sort-sheet__option--active').forEach(function (el) {
          el.classList.remove('sort-sheet__option--active');
        });
        sortBtn.classList.add('sort-sheet__option--active');
        closeSortSheet(function () { ajaxRender(target, true); });
      } else {
        qa('[data-sort-wrap]').forEach(function (w) { w.classList.remove('collection__sort--open'); });
        ajaxRender(target, true);
      }
      return;
    }

    /* Mobile sort sheet open / close. */
    if (t.closest('[data-sort-sheet-trigger]')) { openSortSheet(); return; }
    if (t.closest('[data-sort-sheet-close]') || t.closest('[data-sort-sheet-backdrop]')) { closeSortSheet(); return; }

    /* Active-filter chips / clear links → intercept the <a href> and AJAX it.
       (Mobile checkbox-derived pills carry data-pill-name and are toggled by
       filter-sidebar's own handler before Apply — don't hijack those on mobile.) */
    var link = t.closest('a.collection__tag, a.collection__clear-btn, a.collection__sidebar-clear, a.filter-active-tag[href]');
    if (link && link.getAttribute('href')) {
      if (link.hasAttribute('data-pill-name') && isMobile()) return;
      e.preventDefault();
      ajaxRender(link.getAttribute('href'), true);
      return;
    }

    /* Outside click closes any open desktop sort dropdown. */
    if (!t.closest('[data-sort-wrap]')) {
      qa('[data-sort-wrap]').forEach(function (w) { w.classList.remove('collection__sort--open'); });
    }
  });

  /* Back / forward navigation re-renders the corresponding filtered view. */
  window.addEventListener('popstate', function () {
    ajaxRender(location.pathname + location.search, false);
  });

  /* ---------- per-render (stateful) init ---------- */
  var observer = null;
  function initDynamic() {
    syncFilterMetrics();
    if (observer) { observer.disconnect(); observer = null; }

    /* Infinite scroll — the logo area is both trigger and loading indicator. */
    var grid = q('[data-product-grid]');
    var logoArea = q('[data-infinite-scroll]');
    if (!grid || !logoArea || !logoArea.dataset.nextUrl) return;

    var loading = false;
    var nextUrl = logoArea.dataset.nextUrl;

    function isElementInViewport(el) {
      return el.getBoundingClientRect().top < window.innerHeight + 200;
    }
    function loadMore() {
      if (!nextUrl || loading) return;
      loading = true;
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          tmp.querySelectorAll('[data-product-grid] .product-card').forEach(function (card) {
            /* See collection-v2: an appended page is never the LCP, so drop the
               first-row fetchpriority=high hint product-card renders per page. */
            card.querySelectorAll('img[fetchpriority="high"]').forEach(function (img) {
              img.setAttribute('fetchpriority', 'auto');
            });
            grid.appendChild(card);
          });
          var newLogoArea = tmp.querySelector('[data-infinite-scroll]');
          if (newLogoArea && newLogoArea.dataset.nextUrl) {
            nextUrl = newLogoArea.dataset.nextUrl;
          } else {
            nextUrl = null;
            if (observer) observer.disconnect();
            logoArea.style.display = 'none';
            grid.classList.add('collection__grid--done');
          }
          loading = false;
          if (nextUrl && isElementInViewport(logoArea)) loadMore();
        })
        .catch(function () { loading = false; });
    }

    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !loading && nextUrl) loadMore();
    }, { rootMargin: '200px' });
    observer.observe(logoArea);
  }

  /* ---------- initial ---------- */
  /* initDynamic() first: it seeds --filters-w / --card-w, which the column needs
     before it is shown. Then restore the desktop column when the URL already
     carries active filters, so a filtered link doesn't land with it collapsed. */
  initDynamic();
  if (hasActiveFilters() && !isMobile()) restoreSidebarInstantly();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grid = document.querySelector('[data-collections-grid]');
  var logoArea = document.querySelector('[data-collections-infinite-scroll]');
  if (!grid || !logoArea || !logoArea.dataset.nextUrl) return;

  var loading = false;
  var nextUrl = logoArea.dataset.nextUrl;

  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting && !loading && nextUrl) {
      loadMore();
    }
  }, { rootMargin: '200px' });

  observer.observe(logoArea);

  function loadMore() {
    if (!nextUrl || loading) return;
    loading = true;

    fetch(nextUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var newCards = tmp.querySelectorAll('[data-collections-grid] .collections-card');
        newCards.forEach(function (card) {
          grid.appendChild(card);
        });

        var newLogoArea = tmp.querySelector('[data-collections-infinite-scroll]');
        if (newLogoArea && newLogoArea.dataset.nextUrl) {
          nextUrl = newLogoArea.dataset.nextUrl;
        } else {
          nextUrl = null;
          observer.disconnect();
          logoArea.style.display = 'none';
          grid.classList.add('collections-page__grid--done');
        }
        loading = false;

        if (nextUrl && isElementInViewport(logoArea)) {
          loadMore();
        }
      })
      .catch(function () {
        loading = false;
      });
  }

  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight + 200;
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Must exceed the largest `.faq-page__category { scroll-margin-top }` so a freshly
  // scrolled-to category still satisfies `top <= TRIGGER_Y` after scrollIntoView lands.
  const TRIGGER_Y = 140;
  const SCROLL_END_FALLBACK_MS = 1200;

  document.querySelectorAll('.faq-page').forEach((root) => {
    const nav = root.querySelector('.faq-page__nav');
    const navItems = root.querySelectorAll('.faq-page__nav-item');
    const categories = root.querySelectorAll('.faq-page__category');
    if (navItems.length === 0 || categories.length === 0) return;

    let lockedHandle = null;
    let lockTimer = null;

    const centerActiveInNav = () => {
      if (!nav || nav.scrollWidth <= nav.clientWidth) return;
      const active = nav.querySelector('.faq-page__nav-item--active');
      if (!active) return;
      const target = active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2;
      nav.scrollTo({ left: target, behavior: 'smooth' });
    };

    const setActive = (handle) => {
      let changed = false;
      navItems.forEach((item) => {
        const shouldBeActive = item.dataset.handle === handle;
        if (shouldBeActive !== item.classList.contains('faq-page__nav-item--active')) changed = true;
        item.classList.toggle('faq-page__nav-item--active', shouldBeActive);
      });
      if (changed) centerActiveInNav();
    };

    const syncActiveFromScroll = () => {
      if (lockedHandle) return;
      let active = categories[0].dataset.handle;
      for (const cat of categories) {
        if (cat.getBoundingClientRect().top <= TRIGGER_Y) {
          active = cat.dataset.handle;
        }
      }
      setActive(active);
    };

    const releaseLock = () => {
      lockedHandle = null;
      window.removeEventListener('scrollend', releaseLock);
      clearTimeout(lockTimer);
      syncActiveFromScroll();
    };

    navItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const target = root.querySelector('#faq-cat-' + item.dataset.handle);
        if (!target) return;
        // Lock the active state to the clicked category until the smooth scroll lands,
        // so the scroll-driven sync can't flip it back as we pass other categories.
        lockedHandle = item.dataset.handle;
        setActive(lockedHandle);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        clearTimeout(lockTimer);
        window.removeEventListener('scrollend', releaseLock);
        window.addEventListener('scrollend', releaseLock, { once: true });
        lockTimer = setTimeout(releaseLock, SCROLL_END_FALLBACK_MS);
      });
    });

    window.addEventListener('scroll', syncActiveFromScroll, { passive: true });
    syncActiveFromScroll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-balance"]) return;
  try {
    
(function () {
  const root = document.querySelector('[data-gc-balance]');
  if (!root) return;

  const stateEl = root.querySelector('[data-gcb-state]');
  const subtitleEl = root.querySelector('[data-gcb-subtitle]');
  const footerEl = root.querySelector('[data-gcb-footer]');
  const endpoint = root.dataset.endpoint || '/apps/track-order/gift-card';

  const tplList = document.querySelector('[data-gcb-tpl-list]');
  const tplCard = document.querySelector('[data-gcb-tpl-card]');
  const tplEmpty = document.querySelector('[data-gcb-tpl-empty]');
  const tplError = document.querySelector('[data-gcb-tpl-error]');
  const tplSignin = document.querySelector('[data-gcb-tpl-signin]');

  function show(node) { stateEl.replaceChildren(node); }
  function hideSubtitle() { if (subtitleEl) subtitleEl.hidden = true; }
  function renderError() { hideSubtitle(); show(tplError.content.cloneNode(true)); }
  function renderEmpty() { hideSubtitle(); show(tplEmpty.content.cloneNode(true)); }
  function renderSignin() { hideSubtitle(); if (footerEl) footerEl.hidden = true; show(tplSignin.content.cloneNode(true)); }

  function formatMoney(amount, currency) {
    /* QA BUG-BV-63: the caller already guards with `card.balance || {}`, so a card
       whose balance the proxy omitted arrives here as undefined. The isFinite
       fallback below then concatenated it into the literal string "undefined ",
       and the shopper was shown "undefined" as their gift-card balance. Bail to a
       neutral dash instead — an em dash reads as "not available", not as zero,
       which we must not claim when we simply don't know the balance. */
    if (amount === null || amount === undefined || amount === '') return '—';
    const value = Number(amount);
    if (!isFinite(value)) return '—';
    const code = String(currency || 'USD').toUpperCase();
    const activeCode = window.Shopify && window.Shopify.currency
      ? String(window.Shopify.currency.active || '').toUpperCase()
      : '';

    /* BUG-BV-57 / BUG-46: use the same Shopify-derived formatter as the rest of the
       theme whenever the balance is in the active presentment currency. It
       follows the page/market format and appends AUD/CAD/HKD/NZD/SGD/TWD for
       the ambiguous `$` symbol. A balance can still arrive in another currency,
       so retain an Intl fallback for that case, but bind it to the storefront
       document language (never the browser preference). Cross-currency balances
       always carry their own ISO code — including USD — because a bare `$` on an
       AUD page otherwise reads as AUD even though the card is denominated in USD. */
    if (window.BonvaleMoney && code === activeCode) {
      return window.BonvaleMoney.format(Math.round(value * 100));
    }

    try {
      const locale = document.documentElement.lang || 'en';
      const formatted = new Intl.NumberFormat(locale, {
        style: 'currency', currency: code, currencyDisplay: 'narrowSymbol'
      }).format(value);
      const isCrossCurrency = activeCode && code !== activeCode;
      const hasAmbiguousDollar = code !== 'USD'
        && ['AUD', 'CAD', 'HKD', 'NZD', 'SGD', 'TWD'].indexOf(code) !== -1;
      return isCrossCurrency || hasAmbiguousDollar
        ? formatted + ' ' + code
        : formatted;
    } catch (e) {
      return value.toFixed(2) + ' ' + code;
    }
  }

  // Shopify Date is "YYYY-MM-DD"; format as "30 Jun, 2027" (locale/timezone-safe).
  function shortDate(iso) {
    if (!iso) return '';
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return parseInt(m[3], 10) + ' ' + months[parseInt(m[2], 10) - 1] + ', ' + m[1];
  }

  // "expires on 30 Jun, 2027" (amber pill when expiring soon) / "expired on …".
  function applyExpiry(el, card) {
    const date = shortDate(card.expires_on);
    if (!date) { el.remove(); return; }
    const tpl = card.status === 'expired'
      ? (root.dataset.expiredLabel || 'expired on {date}')
      : (root.dataset.expiresLabel || 'expires on {date}');
    el.textContent = tpl.replace('{date}', date);
    if (card.status === 'expiring') el.classList.add('gcb-card__expiry--expiring');
  }

  function renderList(cards) {
    const wrap = tplList.content.cloneNode(true);
    const list = wrap.querySelector('[data-gcb-list]');
    cards.forEach(function (card) {
      const item = tplCard.content.cloneNode(true);
      if (card.status === 'expired') item.querySelector('[data-card]').classList.add('gcb-card--expired');
      item.querySelector('[data-code]').textContent = '********' + (card.last_characters || '');
      const bal = card.balance || {};
      item.querySelector('[data-balance]').textContent = formatMoney(bal.amount, bal.currency);
      applyExpiry(item.querySelector('[data-expiry]'), card);
      list.appendChild(item);
    });
    if (subtitleEl) subtitleEl.hidden = false;
    show(wrap);
  }

  async function load() {
    try {
      const res = await fetch(endpoint, { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!res.ok) { renderError(); return; }
      const data = await res.json();

      // Worker is authoritative for login state (this page's Liquid render may be
      // a cached logged-out variant). Auto-redirect to login via bvLoginRedirect
      // (snippet account-login-redirect) — its sessionStorage guard prevents a
      // loop if the redirect recurs; the inline sign-in prompt is the fallback.
      if (data.status === 'not_logged_in') {
        renderSignin();
        if (window.bvLoginRedirect) window.bvLoginRedirect();
        return;
      }

      if (data.status === 'ok' && Array.isArray(data.gift_cards)) {
        if (footerEl) footerEl.hidden = false;
        if (data.gift_cards.length === 0) { renderEmpty(); } else { renderList(data.gift_cards); }
        return;
      }
      renderError();
    } catch (err) {
      renderError();
    }
  }

  load();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-gift-card-pdp]').forEach(function (root) {
    if (root.dataset.gcInit) return;
    root.dataset.gcInit = '1';

    var variantInput = root.querySelector('[data-gc-variant-id]');
    var priceEl = root.querySelector('[data-gc-price]');
    var priceFaceEl = root.querySelector('[data-gc-price-face]');
    var amountLabel = root.querySelector('[data-gc-amount-label]');
    var buttons = root.querySelectorAll('[data-gc-amount-btn]');
    var openBtn = root.querySelector('[data-gc-open]');
    var amountGroup = root.querySelector('[data-gc-amount-group]');

    // Card-preview amount lives inside the modal; update it on every change.
    function syncCardAmount(display) {
      document.querySelectorAll('[data-gc-card-amount]').forEach(function (el) {
        el.textContent = display;
      });
    }

    function selectButton(btn) {
      buttons.forEach(function (b) { b.classList.remove('gift-card-pdp__amount-btn--active'); });
      btn.classList.add('gift-card-pdp__amount-btn--active');
      if (variantInput) variantInput.value = btn.dataset.variantId;
      /* face mode (store-currency card in another currency): headline is the
         converted amount prefixed with "≈", with the face value in parentheses
         beside it. data-face-display is only emitted in that mode, so its
         absence selects the plain behaviour. */
      var face = btn.dataset.faceDisplay;
      if (priceEl) priceEl.textContent = (face ? '≈' : '') + btn.dataset.priceDisplay;
      if (priceFaceEl && face) priceFaceEl.textContent = '(' + face + ')';
      if (amountLabel) amountLabel.textContent = face || btn.dataset.amountDisplay;
      /* The card preview shows what the recipient actually gets — the face value. */
      syncCardAmount(face || btn.dataset.amountDisplay);
      if (amountGroup) amountGroup.classList.remove('gift-card-pdp__amount--error');
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;
        selectButton(btn);
      });
    });

    // Seed the card preview with the initial selection.
    var active = root.querySelector('.gift-card-pdp__amount-btn--active');
    if (active) syncCardAmount(active.dataset.faceDisplay || active.dataset.amountDisplay);

    // ADD TO BAG → require an amount, then open the gift modal.
    if (openBtn) {
      openBtn.addEventListener('click', function () {
        if (variantInput && !variantInput.value) {
          if (amountGroup) {
            amountGroup.classList.add('gift-card-pdp__amount--error');
            amountGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }
        window.dispatchEvent(new CustomEvent('gift-card:open'));
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Exclude Bundle Sale (tag `bundle`) and test (tag `test`) products from search.
     On the FULL-TEXT /search page the `-tag:` exclusion is appended invisibly to `q`
     (storefront full-text search supports the `-tag:` operator) so Shopify never returns
     them — accurate result counts + pagination, unlike a render-layer filter. Reused by
     every "view all"/suggestion link and the search-form submits via scopedSearchUrl.

     ⚠️ The Predictive Search API (/search/suggest.json) does NOT support these operators —
     a `-tag:` in its `q` is treated as literal text, and (being the final token) it also
     kills the prefix matching that powers autosuggest (e.g. "soc" → "socks"). So the
     predictive fetch must query the RAW term and exclude bundle/test client-side by tag
     (the predictive product object includes `tags`). See createPredictiveSearch. */
  var SEARCH_EXCLUDE = '-tag:bundle -tag:test -tag:not-sold-separately';
  var SEARCH_EXCLUDE_TAGS = ['bundle', 'test', 'not-sold-separately'];
  /* Shopify's full-text search does NOT prefix-match, but the Predictive Search API
     does. Measured on prod 2026-08-06: the dropdown offered 7 products for "soc"
     while /search?q=soc&type=product returned 0 — the shopper was shown results and
     then landed on the no-results page for the same term (same for "pan" → 0 vs
     "pant" → 8). Full-text search DOES support a trailing `*` wildcard, so append one
     per term and the results page matches what the dropdown promised ("soc*" → 9,
     "pan*" → 22). Left alone: operator tokens (`-tag:`, `field:value`), quoted
     phrases, anything already wildcarded, and single characters — "a*" would drag in
     the whole catalogue. Display-side, search.liquid strips the `*` back out. */
  function wildcardSearchTerms(term) {
    var parts = (term || '').trim().split(/\s+/);
    var out = [];
    for (var i = 0; i < parts.length; i++) {
      var t = parts[i];
      if (!t) continue;
      if (t.length < 2 || t.charAt(0) === '-' || /[*":()]/.test(t)) out.push(t);
      else out.push(t + '*');
    }
    return out.join(' ');
  }
  function scopedSearchQuery(term) {
    return (wildcardSearchTerms(term) + ' ' + SEARCH_EXCLUDE).trim();
  }
  /* Locale root for the current storefront ('/' on English, '/fr/' on the French domain
     path). Liquid is NOT rendered inside a javascript block, so the `routes` object is
     unavailable here — read Shopify.routes.root at runtime instead. Without it every search
     URL built in JS drops the locale prefix and the shopper lands on the ENGLISH results page. */
  function searchRootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function scopedSearchUrl(term) {
    /* type=product scopes the results page to products so results_count matches the
       product grid (pages/articles would otherwise inflate the count over an empty grid). */
    return searchRootUrl() + 'search?q=' + encodeURIComponent(scopedSearchQuery(term)) + '&type=product';
  }
  /* Predictive search (/search/suggest.json) hands back the ORIGINAL image URL —
     a full-resolution master, several hundred KB — for a 267px card slot. Ask the
     CDN for the size we actually render, at the theme's pinned quality (see
     snippets/image-srcset for why quality is a query parameter and what it saves).
     Any non-CDN or already-parameterised URL is returned untouched. */
  function searchThumbUrl(url, width) {
    if (!url || url.indexOf('/cdn/shop/') === -1 && url.indexOf('cdn.shopify.com') === -1) return url;
    if (url.indexOf('width=') !== -1) return url;
    var height = Math.round(width * 1.3296); /* 267 / 355 card box */
    return url + (url.indexOf('?') === -1 ? '?' : '&') +
      'width=' + width + '&height=' + height + '&crop=center&quality=70';
  }
  /* A single 400w src is not enough for any hi-dpi screen and the live results
     rendered visibly soft next to the server-rendered popular-products cards in
     the same panel: the desktop card is 268 CSS px (820px column, 3-up, 8px gaps)
     so DPR 2 wants 536, and the mobile card is a fixed 172 so DPR 3 wants 516 —
     both upscaled the 400px file. Each renderer supplies its own `sizes` (its
     fixed CSS width), so the one list serves both. Returns '' when there is
     nothing useful to build, which leaves the element's plain `src` in charge.

     NOTE the deliberate 540 GAP. Every product master here is 1792x2400 (checked
     across 7 products in different categories), and how cleanly the CDN resamples
     1792 down to the candidate matters more than the candidate's raw pixel count.
     Measured 2026-08-13 against the untouched master as ground truth, all at
     q70, decoded into the real 536x712 device box, averaged over 3 products:

         400w  PSNR 36.75  SSIM 0.9537     (1792/400 = 4.480)
         480w  PSNR 35.26  SSIM 0.9513     (1792/480 = 3.733)
         540w  PSNR 36.07  SSIM 0.9565     (1792/540 = 3.319)
         600w  PSNR 39.41  SSIM 0.9673     (1792/600 = 2.987)
         640w  PSNR 40.17  SSIM 0.9692     (1792/640 = 2.800)
         720w  PSNR 37.73  SSIM 0.9665     (1792/720 = 2.489)

     A ladder containing 540 makes the browser pick it (smallest candidate >= 536)
     — the WORST rung available, barely better than the 400w it replaced. Dropping
     540 sends DPR 2 to 600 instead: +3.3 dB / +0.011 SSIM for +7.5 KB, a bigger
     jump than the original no-srcset fix delivered. Ratios near 3.0 resample
     cleanly, but 640 (2.80) also scores well, so treat the table as measurement
     rather than an integer-ratio rule. RE-MEASURE if the master size changes. */
  var SEARCH_THUMB_WIDTHS = [200, 270, 400, 600];
  function searchThumbSrcset(url) {
    if (!url || url.indexOf('/cdn/shop/') === -1 && url.indexOf('cdn.shopify.com') === -1) return '';
    if (url.indexOf('width=') !== -1) return '';
    var candidates = [];
    for (var i = 0; i < SEARCH_THUMB_WIDTHS.length; i++) {
      candidates.push(searchThumbUrl(url, SEARCH_THUMB_WIDTHS[i]) + ' ' + SEARCH_THUMB_WIDTHS[i] + 'w');
    }
    return candidates.join(', ');
  }

  /* True if a predictive-search product carries an excluded tag (case-insensitive). */
  function isExcludedSearchProduct(p) {
    var tags = p && p.tags;
    if (!tags || !tags.length) return false;
    for (var i = 0; i < tags.length; i++) {
      if (SEARCH_EXCLUDE_TAGS.indexOf(('' + tags[i]).toLowerCase()) !== -1) return true;
    }
    return false;
  }

  /* The announcement-bar <details> outside-click closer and the header/mob
     localization submit handlers were removed with LOC-SEL-01: both switchers
     are now plain [data-region-open] triggers, and the ONLY localization submit
     left in the theme is the region popup's CONFIRM button (which owns
     preference-writing and the cross-domain hand-off). */

  /* Country-switch loading feedback: the localization submit above (and in
     footer.liquid / region-popup.liquid) is a full-page navigation that can
     take seconds with zero native feedback — the site appears frozen. On the
     click that triggers a submit, spin the clicked option (CSS in this
     section's stylesheet), lock further clicks and swallow repeat submits.
     Capture phase so it runs before the bubble-phase submit handlers.
     Since LOC-SEL-01 the ONLY element that submits a localization change is the
     region popup's CONFIRM button — its [data-country-code] options merely
     SELECT — so this watches [data-region-confirm] alone. */
  var countrySwitchPending = false;
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-region-confirm]');
    if (!btn) return;
    if (countrySwitchPending) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    countrySwitchPending = true;
    btn.classList.add('is-country-switching');
    document.documentElement.classList.add('country-switching');
    /* Safety net: if navigation never happens (e.g. submit blocked), unlock. */
    setTimeout(function () {
      countrySwitchPending = false;
      document.documentElement.classList.remove('country-switching');
      btn.classList.remove('is-country-switching');
    }, 10000);
  }, true);
  /* bfcache restore (back button) revives the old page with the lock on — clear it. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    countrySwitchPending = false;
    document.documentElement.classList.remove('country-switching');
    document.querySelectorAll('.is-country-switching').forEach(function (el) {
      el.classList.remove('is-country-switching');
    });
  });

  /* Predictive search helper — debounced /search/suggest.json fetch.
     Returns a function (term, onResult) where onResult is called with
     { queries: [{text, url}], products: [{title, url, image, price}] }
     once results arrive. Products are only requested when opts.productLimit
     is set. Older in-flight requests are aborted to prevent stale-overwrite. */
  /* Predictive search prices arrive as decimal strings in the active
     presentment currency (e.g. "55.90"). Format with the shop's own
     money_format so the symbol matches the money-filter output everywhere
     else on the site (e.g. "$55.90") — Intl renders "US$" for USD, which
     we don't want. money_format is read from a data attribute at runtime
     (Liquid can't run inside the javascript block). */
  var SEARCH_MONEY_FORMAT = null;
  var SEARCH_MONEY_CODE = null;
  /* Prefer the search dropdown itself — it carries the format AND the matching ISO
     code. Fall back to any [data-money-format] host for safety. */
  function searchMoneyHost() {
    return document.querySelector('[data-search-dropdown][data-money-format]') ||
           document.querySelector('[data-money-format]');
  }
  function getSearchMoneyFormat() {
    if (SEARCH_MONEY_FORMAT === null) {
      var el = searchMoneyHost();
      SEARCH_MONEY_FORMAT = (el && el.getAttribute('data-money-format')) || ('$' + '{' + '{amount}}');
    }
    return SEARCH_MONEY_FORMAT;
  }
  /* QA BUG-BV-07: ambiguous-currency suffix (" AUD", " SGD", …) or '' when the symbol
     is unique. Mirrors snippets/currency-code.liquid so "Top results" matches the
     Liquid-rendered "Popular Items" prices sitting right next to it. */
  function getSearchMoneyCode() {
    if (SEARCH_MONEY_CODE === null) {
      var el = searchMoneyHost();
      var code = el && el.getAttribute('data-money-code');
      SEARCH_MONEY_CODE = code || '';
    }
    return SEARCH_MONEY_CODE;
  }
  function formatSearchPrice(value) {
    if (value == null || value === '') return '';
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    function commas(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    var amount = commas(num.toFixed(2));
    var amountNoDec = commas(Math.round(num).toString());
    var amountComma = num.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?:,|$))/g, '.');
    return getSearchMoneyFormat()
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(num).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDec)
      .replace(/\{\{\s*amount\s*\}\}/g, amount) + getSearchMoneyCode();
  }

  function createPredictiveSearch(opts) {
    var DEBOUNCE = 200;
    var QUERY_LIMIT = (opts && opts.limit) || 8;
    var PRODUCT_LIMIT = (opts && opts.productLimit) || 0;
    var timer = null;
    var ctl = null;
    return function (term, onResult) {
      if (timer) { clearTimeout(timer); timer = null; }
      if (ctl) { ctl.abort(); ctl = null; }
      term = (term || '').trim();
      /* Keep the predictive and full-search matching semantics aligned. Single-character
         terms are intentionally not wildcarded by wildcardSearchTerms() because e.g.
         "a*" can pull in most of the catalogue. Do not show prefix-matched predictive
         products that the results page cannot reproduce (BUG-BV-167). */
      if (term.length < 2) { onResult({ queries: [], products: [] }); return; }
      timer = setTimeout(function () {
        ctl = new AbortController();
        var types = PRODUCT_LIMIT > 0 ? 'query,product' : 'query';
        /* RAW term here — /search/suggest.json can't parse `-tag:` and it would break
           prefix matching (see SEARCH_EXCLUDE note). Bundle/test are dropped client-side
           by tag below. Request a few extra (API caps at 10) so filtered-out products
           don't shrink the visible list below the limit. */
        var fetchLimit = Math.min(10, Math.max(QUERY_LIMIT, PRODUCT_LIMIT) + SEARCH_EXCLUDE_TAGS.length);
        var params = 'q=' + encodeURIComponent(term)
          + '&resources[type]=' + types
          + '&resources[limit]=' + fetchLimit
          + '&resources[options][unavailable_products]=last';
        /* Locale-prefixed (see searchRootUrl) — the predictive endpoint returns titles and
           product URLs in the requested locale; bare '/search/suggest.json' always answers
           in English, so a French shopper would see English suggestions. */
        fetch(searchRootUrl() + 'search/suggest.json?' + params, { signal: ctl.signal })
          .then(function (r) {
            /* QA BUG-BV-34: without this check a 429/500 (or an HTML error page,
               which blows up in .json()) fell into the catch below and was reported
               as "no results" — indistinguishable from a genuinely empty search, so
               a rate-limited shopper is told the product doesn't exist. Surface the
               HTTP failure so the renderers can say "try again" instead. */
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (data) {
            var results = (data && data.resources && data.resources.results) || {};
            var queries = (results.queries || []).slice(0, QUERY_LIMIT).map(function (q) {
              /* Build our own scoped URL (ignore q.url) so the bundle/test exclusion is applied. */
              return { text: q.text, url: scopedSearchUrl(q.text) };
            });
            var products = (results.products || []).filter(function (p) {
              return !isExcludedSearchProduct(p);
            }).slice(0, PRODUCT_LIMIT).map(function (p) {
              var imageUrl = (p.featured_image && p.featured_image.url) || p.image || '';
              return {
                title: p.title,
                url: p.url,
                handle: p.handle,
                image: searchThumbUrl(imageUrl, 400),
                imageSrcset: searchThumbSrcset(imageUrl),
                price: formatSearchPrice(p.price)
              };
            });
            onResult({ queries: queries, products: products });
          })
          .catch(function (err) {
            /* An aborted request is a newer keystroke superseding this one — not a
               failure, and rendering it would clobber the fresher result. Everything
               else (HTTP status, JSON parse, network) is flagged so the UI can show
               an error rather than an empty-results state. See BUG-BV-34. */
            if (err && err.name !== 'AbortError') onResult({ queries: [], products: [], error: true });
          });
      }, DEBOUNCE);
    };
  }

  (function() {
    var STORAGE_KEY = 'bonvale_recent_searches';
    var MAX_RECENT = 5;

    var header = document.querySelector('.header-main').parentElement;
    var searchWrap = document.querySelector('[data-search-wrap]');
    var searchInput = document.querySelector('[data-search-input]');
    var searchClear = document.querySelector('[data-search-clear]');
    var searchClose = document.querySelector('[data-search-close]');
    var searchOverlay = document.querySelector('[data-search-overlay]');
    var browseCol = document.querySelector('[data-browse-col]');
    var popularCol = document.querySelector('[data-popular-col]');
    var recentCol = document.querySelector('[data-recent-col]');
    var recentList = document.querySelector('[data-recent-list]');
    var recentClear = document.querySelector('[data-recent-clear]');
    var suggestionsCol = document.querySelector('[data-suggestions-col]');
    var suggestionsList = document.querySelector('[data-suggestions-list]');
    var productsCol = document.querySelector('[data-products-col]');
    var productsList = document.querySelector('[data-products-list]');
    var productsTitle = document.querySelector('[data-products-title]');
    var productsViewall = document.querySelector('[data-products-viewall]');
    var resultsLabel = (productsCol && productsCol.getAttribute('data-results-label')) || 'Top results';
    var addLabel = (productsCol && productsCol.getAttribute('data-add-label')) || 'Add to bag';
    var searchDropdown = document.querySelector('[data-search-dropdown]');
    var searchForm = document.querySelector('[data-search-form]');
    var lastTerm = '';
    var activeSuggestion = -1;

    if (!searchInput || !header) return;

    function suggestionOptions() {
      return suggestionsList ? suggestionsList.querySelectorAll('[role="option"]') : [];
    }

    function setActiveSuggestion(index) {
      var options = suggestionOptions();
      if (!options.length) index = -1;
      if (index >= options.length) index = 0;
      if (index < -1) index = options.length - 1;
      activeSuggestion = index;
      options.forEach(function(option, optionIndex) {
        option.setAttribute('aria-selected', optionIndex === index ? 'true' : 'false');
      });
      if (index >= 0) searchInput.setAttribute('aria-activedescendant', options[index].id);
      else searchInput.removeAttribute('aria-activedescendant');
    }

    function syncCombobox(open) {
      searchInput.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) setActiveSuggestion(-1);
    }

    function getRecent() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
      catch(e) { return []; }
    }

    function saveRecent(list) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
      catch(e) {}
    }

    function addRecent(term) {
      term = term.trim();
      if (!term) return;
      var list = getRecent().filter(function(t) { return t !== term; });
      list.unshift(term);
      if (list.length > MAX_RECENT) list = list.slice(0, MAX_RECENT);
      saveRecent(list);
    }

    function removeRecent(term) {
      var list = getRecent().filter(function(t) { return t !== term; });
      saveRecent(list);
      renderRecent();
      updateDropdownVisibility();
    }

    function renderRecent() {
      var list = getRecent();
      if (!recentList || !recentCol) return;
      recentList.innerHTML = '';
      if (list.length === 0) {
        recentCol.style.display = 'none';
        return;
      }
      recentCol.style.display = '';
      list.forEach(function(term) {
        var li = document.createElement('li');
        li.className = 'search-dropdown__recent';
        var a = document.createElement('a');
        a.className = 'search-dropdown__recent-text';
        a.href = scopedSearchUrl(term);
        a.textContent = term;
        var btn = document.createElement('button');
        btn.className = 'search-dropdown__recent-remove';
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Remove');
        btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 0.5L0.5 10.5M0.5 0.5L10.5 10.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        btn.addEventListener('click', function() { removeRecent(term); });
        li.appendChild(a);
        li.appendChild(btn);
        recentList.appendChild(li);
      });
    }

    function updateDropdownVisibility() {
      if (!searchDropdown) return;
      var searching = searchDropdown.classList.contains('search-dropdown--searching');
      var hasContent;
      if (searching) {
        /* Only count the currently-shown search-state columns, not the
           display:none browse/popular columns still in the DOM. */
        hasContent = searchDropdown.querySelector(
          '[data-suggestions-col]:not([hidden]) .search-dropdown__link, [data-products-col]:not([hidden]) .search-dropdown__product'
        );
      } else {
        hasContent = searchDropdown.querySelector(
          '[data-browse-col] .search-dropdown__link, [data-browse-col] .search-dropdown__recent-text, [data-popular-col] .search-dropdown__product'
        );
      }
      searchDropdown.classList.toggle('search-dropdown--empty', !hasContent);
    }

    function updateHeaderHeight() {
      /* Use the actual viewport bottom of .header-main rather than summing
         offsetHeights. On PDP/Cart the header group is `position: sticky`
         with negative top, so when the user scrolls past the announcement
         bar, summing both heights leaves a gap between the dropdown and the
         visible header. getBoundingClientRect().bottom handles both states. */
      var headerMain = document.querySelector('.header-main');
      if (!headerMain) return;
      var bottom = Math.max(0, headerMain.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--header-total-height', bottom + 'px');
    }

    function updateSearchFormLeft() {
      if (!searchForm) return;
      var left = searchForm.getBoundingClientRect().left;
      document.documentElement.style.setProperty('--search-form-left', left + 'px');
    }

    /* Scroll lock.

       `document.body.style.overflow = 'hidden'` — what this used to do — is a
       NO-OP on this theme. The body's overflow only propagates to the viewport
       while the HTML element's own overflow is `visible`, and critical.css sets
       `html { overflow-x: clip }` (so the computed value is `clip visible`).
       Measured on prod 2026-08-05: with the panel open and body overflow
       `hidden`, a wheel event still took the page from scrollY 0 to 400.

       That is what puts a band of page background between the header and the
       panel: `.search-dropdown` is `position: fixed; top: --header-total-height`
       and that variable is sampled once on open, so the moment the page scrolls
       underneath, the header slides up and the panel stays put. Locking the
       element that actually owns the scroll fixes the cause; updateHeaderHeight
       on scroll below is the belt-and-braces for platforms where a lock can
       still be defeated (iOS momentum, pull-to-refresh).

       padding-right compensates for the scrollbar the lock removes, so the page
       does not jump sideways on platforms with classic (non-overlay) bars. */
    var scrollLockPad = '';
    function lockScroll() {
      var root = document.documentElement;
      var barWidth = window.innerWidth - root.clientWidth;
      scrollLockPad = document.body.style.paddingRight;
      if (barWidth > 0) document.body.style.paddingRight = barWidth + 'px';
      root.style.overflow = 'hidden';
    }
    function unlockScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.paddingRight = scrollLockPad;
    }

    /* Match the input grow/shrink transition (0.3s on .header-main__search and
       .header-main__logo). rAF-track the form's x position so the dropdown's
       padding-left stays aligned with the search box throughout the animation. */
    var searchFormLeftRaf = 0;
    function trackSearchFormLeft(durationMs) {
      cancelAnimationFrame(searchFormLeftRaf);
      var start = performance.now();
      function tick(now) {
        updateSearchFormLeft();
        if (now - start < durationMs) {
          searchFormLeftRaf = requestAnimationFrame(tick);
        }
      }
      searchFormLeftRaf = requestAnimationFrame(tick);
    }

    function openSearch() {
      header.classList.add('header--search-open');
      /* Lock BEFORE measuring: the lock removes the scrollbar and pads the body
         to compensate, which moves the search form's x position. */
      lockScroll();
      updateHeaderHeight();
      trackSearchFormLeft(320);
      /* Resting box is a compact 199px ("Search"); the expanded box shows the full prompt. */
      searchInput.placeholder = searchInput.dataset.placeholderExpanded || 'What are you looking for?';
      /* Reflect the current input: browse state when empty, search state otherwise. */
      if (searchInput.value.trim()) {
        onInput();
      } else {
        setSuggestionMode(false);
        updateDropdownVisibility();
      }
      searchInput.focus();
      updateClear();
    }

    function closeSearch() {
      header.classList.remove('header--search-open');
      syncCombobox(false);
      unlockScroll();
      searchInput.placeholder = searchInput.dataset.placeholderResting || 'Search';
      searchInput.blur();
    }

    function updateClear() {
      if (searchClear) {
        if (searchInput.value.length > 0) {
          searchClear.classList.add('is-visible');
        } else {
          searchClear.classList.remove('is-visible');
        }
      }
    }

    var runPredictive = createPredictiveSearch({ limit: 8, productLimit: 3 });

    function renderPredictive(result) {
      var queries = (result && result.queries) || [];
      var products = (result && result.products) || [];
      /* BUG-BV-34: a failed request must not read as "nothing matched". */
      var searchError = document.querySelector('[data-search-error]');
      if (searchError) searchError.hidden = !(result && result.error);
      /* Enter the live search-results view only when there's something to show.
         A non-empty term that returned nothing stays in / falls back to the
         browse view (Popular / Recent / Trending) instead of the empty
         "Search for products…" panel. */
      var hasResults = queries.length > 0 || products.length > 0;
      setSuggestionMode(hasResults && !!lastTerm);
      if (hasResults) {
        renderSuggestions(result);
        renderResults(products);
      }
      updateDropdownVisibility();
    }

    function renderSuggestions(result) {
      var rows = (result && result.queries) || [];
      if (!suggestionsCol || !suggestionsList) return;
      suggestionsList.innerHTML = '';
      if (rows.length === 0) {
        suggestionsCol.hidden = true;
        syncCombobox(false);
      } else {
        rows.forEach(function (r, index) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.className = 'search-dropdown__link';
          a.id = 'header-search-suggestion-' + index;
          a.setAttribute('role', 'option');
          a.setAttribute('aria-selected', 'false');
          a.href = r.url;
          a.textContent = r.text;
          li.appendChild(a);
          suggestionsList.appendChild(li);
        });
        suggestionsCol.hidden = false;
        syncCombobox(true);
      }
      updateDropdownVisibility();
    }

    function renderResults(products) {
      if (!productsCol || !productsList) return;
      productsList.innerHTML = '';
      if (!products || products.length === 0) {
        productsCol.hidden = true;
        updateDropdownVisibility();
        return;
      }
      if (productsTitle) productsTitle.textContent = resultsLabel.replace('%%QUERY%%', lastTerm);
      if (productsViewall) productsViewall.href = scopedSearchUrl(lastTerm);
      products.forEach(function (p) {
        /* QA BUG-BV-20: mirror the server-rendered card — a non-interactive container with
           the link and the quick-add button as siblings, never a button inside an <a>. */
        var card = document.createElement('div');
        card.className = 'search-dropdown__product';

        var media = document.createElement('div');
        media.className = 'search-dropdown__product-image';
        if (p.image) {
          var img = document.createElement('img');
          /* srcset/sizes before src: assigning src first starts a fetch of the 400w
             candidate that the srcset then supersedes. 268px = the 820px column,
             3-up with 8px gaps. */
          if (p.imageSrcset) {
            img.sizes = '268px';
            img.srcset = p.imageSrcset;
          }
          img.src = p.image;
          img.alt = p.title || '';
          img.loading = 'lazy';
          media.appendChild(img);
        }
        if (p.handle) {
          var add = document.createElement('button');
          add.type = 'button';
          add.className = 'search-dropdown__product-add';
          add.setAttribute('data-quick-add', '');
          add.setAttribute('data-product-handle', p.handle);
          add.setAttribute('aria-label', addLabel);
          add.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M16 7.33333H8.66667V0H7.33333V7.33333H0V8.66667H7.33333V16H8.66667V8.66667H16V7.33333Z"/></svg>';
          media.appendChild(add);
        }

        var info = document.createElement('div');
        info.className = 'search-dropdown__product-info';
        var name = document.createElement('p');
        name.className = 'search-dropdown__product-name';
        var nameLink = document.createElement('a');
        nameLink.className = 'search-dropdown__product-link';
        nameLink.href = p.url;
        nameLink.textContent = p.title || '';
        name.appendChild(nameLink);
        info.appendChild(name);
        if (p.price) {
          var price = document.createElement('p');
          price.className = 'search-dropdown__product-price';
          price.textContent = p.price;
          info.appendChild(price);
        }

        card.appendChild(media);
        card.appendChild(info);
        productsList.appendChild(card);
      });
      productsCol.hidden = false;
      updateDropdownVisibility();
    }

    function setSuggestionMode(active) {
      /* Searching: hide browse/popular columns (CSS) and show the live
         suggestion/results columns. Browse: the reverse. */
      if (searchDropdown) searchDropdown.classList.toggle('search-dropdown--searching', active);
      if (!active) {
        syncCombobox(false);
        renderRecent();
        if (suggestionsCol) {
          suggestionsCol.hidden = true;
          if (suggestionsList) suggestionsList.innerHTML = '';
        }
        if (productsCol) {
          productsCol.hidden = true;
          if (productsList) productsList.innerHTML = '';
        }
      }
    }

    function onInput() {
      updateClear();
      setActiveSuggestion(-1);
      var term = searchInput.value.trim();
      lastTerm = term;
      if (!term) {
        setSuggestionMode(false);
        runPredictive('', renderPredictive);
        return;
      }
      if (term.length < 2) {
        setSuggestionMode(false);
        runPredictive('', renderPredictive);
        return;
      }
      /* Don't switch into searching mode yet — renderPredictive decides based on
         whether results arrive, so the browse view stays put while typing and
         when a term has no matches (no empty-panel flash). */
      runPredictive(term, renderPredictive);
    }

    searchInput.addEventListener('focus', openSearch);
    searchInput.addEventListener('input', onInput);
    searchInput.addEventListener('keydown', function(e) {
      var options = suggestionOptions();
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!options.length) return;
        e.preventDefault();
        setActiveSuggestion(e.key === 'ArrowDown' ? activeSuggestion + 1 : activeSuggestion - 1);
        return;
      }
    });

    // Clicking anywhere in the search box (padding, icon, etc.) focuses the input.
    if (searchWrap) {
      searchWrap.addEventListener('click', function(e) {
        if (e.target.closest('[data-search-clear]')) return;
        if (e.target !== searchInput) searchInput.focus();
      });
    }

    // Mobile search icon — opens mob-search drawer (handled separately below)

    if (searchClear) {
      searchClear.addEventListener('click', function() {
        searchInput.value = '';
        lastTerm = '';
        setSuggestionMode(false);
        updateDropdownVisibility();
        updateClear();
        searchInput.focus();
      });
    }

    if (recentClear) {
      recentClear.addEventListener('click', function() {
        saveRecent([]);
        renderRecent();
        updateDropdownVisibility();
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    if (searchOverlay) {
      searchOverlay.addEventListener('click', closeSearch);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && header.classList.contains('header--search-open')) {
        closeSearch();
      }
    });

    /* Enter-to-search (QA #3): the Shopify Web Pixel hooks form submit events and
       swallows the native GET navigation, so a `submit` listener alone leaves the
       shopper stuck in the overlay. A keydown handler fires independently of the
       submit pipeline; preventDefault stops the (broken) implicit submit and
       location.assign navigates directly. Mirrors the country-switch bypass.
       The submit listener stays as a belt-and-braces fallback. */
    function submitSearch(term) {
      if (!term) return;
      addRecent(term);
      /* scopedSearchUrl appends the -tag: exclusion + type=product; assign (not the
         raw input value) keeps that syntax out of the visible box. */
      window.location.assign(scopedSearchUrl(term));
    }
    if (searchInput) {
      searchInput.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter') return;
        var options = suggestionOptions();
        if (activeSuggestion >= 0 && options[activeSuggestion]) {
          e.preventDefault();
          window.location.assign(options[activeSuggestion].href);
          return;
        }
        var term = searchInput.value.trim();
        if (!term) return;
        e.preventDefault();
        submitSearch(term);
      });
    }
    if (searchForm) {
      searchForm.addEventListener('submit', function(e) {
        var term = searchInput.value.trim();
        if (!term) return;
        e.preventDefault();
        submitSearch(term);
      });
    }

    window.addEventListener('resize', function() {
      if (header.classList.contains('header--search-open')) {
        updateHeaderHeight();
        updateSearchFormLeft();
      }
    });

    /* Safety net for any scroll that survives the lock — see lockScroll above.
       Re-anchors the fixed panel to the header's real viewport bottom so the
       page can never show through between the two. */
    window.addEventListener('scroll', function() {
      if (header.classList.contains('header--search-open')) {
        updateHeaderHeight();
      }
    }, { passive: true });
  })();

  /* Mobile hamburger drawer */
  (function() {
    var hamburger = document.querySelector('.header-main__hamburger');
    var backdrop = document.querySelector('[data-mob-menu-backdrop]');
    var menu = document.querySelector('[data-mob-menu]');
    var closeBtn = document.querySelector('[data-mob-menu-close]');
    var body = menu ? menu.querySelector('.mob-menu__body') : null;
    if (!hamburger || !menu) return;

    /* The header section group has `will-change: transform` and active
       transforms on mobile (scroll hide/compact), which makes it the
       containing block for any descendant `position: fixed` element. Move
       the drawer + backdrop out to <body> so they anchor to the viewport
       instead of riding along with the header's transform. */
    if (backdrop && backdrop.parentNode !== document.body) document.body.appendChild(backdrop);
    if (menu.parentNode !== document.body) document.body.appendChild(menu);

    /* Focus containment. Measured on prod 2026-08-06: opening the drawer left focus on
       the hamburger, and the next 14 Tabs all landed on page content BEHIND the overlay
       (product cards, wishlist hearts) — focus never entered the drawer at all.

       Two separate leaks, so two separate fixes:
       - the page behind: `inert` on every other <body> child, which removes the whole
         subtree from the tab order and the a11y tree in one go.
       - the drawer's own off-screen panels: the sub-panels are only translated out of
         view (translateX(100%)), never display:none, so their links stay tabbable while
         the main panel is showing. Mark whichever panels are not on screen inert too.

       `inert` is the load-bearing mechanism; the Tab handler below only wraps at the
       ends, so on a browser without inert support focus still cannot leave the drawer. */
    var FOCUS_SEL = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var lastFocused = null;

    function setBackgroundInert(on) {
      [].forEach.call(document.body.children, function(el) {
        if (el === menu || el === backdrop) return;
        if (on) el.setAttribute('inert', '');
        else el.removeAttribute('inert');
      });
    }

    /* Only the panel currently on screen is reachable: the sub-panel when one is open,
       otherwise the main panel. The drawer header (logo + close) is outside both and
       always stays live. */
    function syncPanelInert() {
      var subOpen = body && body.classList.contains('mob-menu__body--sub-open');
      menu.querySelectorAll('.mob-menu__panel').forEach(function(panel) {
        var live = subOpen
          ? panel.classList.contains('mob-menu__panel--active')
          : panel.classList.contains('mob-menu__panel--main');
        if (live) panel.removeAttribute('inert');
        else panel.setAttribute('inert', '');
      });
    }

    function focusables() {
      return [].filter.call(menu.querySelectorAll(FOCUS_SEL), function(el) {
        return el.getClientRects().length > 0 && !el.closest('[inert]');
      });
    }

    /* The sub-panels are absolutely positioned and pushed off to the right with
       translateX(100%), which gives .mob-menu__body ~2x its width of SCROLLABLE
       overflow. overflow:hidden only stops the *user* scrolling it — the browser
       still scrolls it programmatically to reveal a newly focused descendant, and
       a plain focus() on the back button fired while the panel was mid-slide left
       the container permanently at scrollLeft ~231. Everything then painted
       sideways: the tail of the open panel on the left, the NEXT panel bleeding in
       on the right. Measured on prod 2026-08-07 at 390px.

       Two guards: focus without the scroll-into-view, and pin scrollLeft to 0 so
       nothing else (a stray scrollIntoView, an anchor jump) can shift it either. */
    function focusNoScroll(el) {
      if (!el) return;
      try { el.focus({ preventScroll: true }); }
      catch (e) { el.focus(); }
      resetPanelScroll();
    }

    function resetPanelScroll() {
      if (body && body.scrollLeft !== 0) body.scrollLeft = 0;
    }
    if (body) body.addEventListener('scroll', resetPanelScroll);

    function openMenu() {
      lastFocused = document.activeElement;
      menu.style.display = 'flex';
      backdrop.style.display = 'block';
      menu.offsetHeight; // force reflow
      menu.classList.add('mob-menu--open');
      menu.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setBackgroundInert(true);
      syncPanelInert();
      var first = focusables();
      focusNoScroll(closeBtn || first[0] || menu);
    }

    function closeMenu() {
      menu.classList.remove('mob-menu--open');
      menu.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      backdrop.style.display = 'none';
      document.body.style.overflow = '';
      /* Un-inert BEFORE restoring focus — focus() is a no-op on an element still
         inside an inert subtree, which is where the hamburger sits. */
      setBackgroundInert(false);
      /* QA BUG-BV-17: `document.contains(lastFocused)` is true for <body>, so a mouse or
         touch open (which leaves activeElement on <body> — a click does not focus a button
         in every engine) restored focus to <body> and the next Tab restarted from the top
         of the page. The opener can also have been re-rendered away. Fall back to the
         hamburger: it owns this drawer and is always the right place to land. */
      var restore = lastFocused;
      if (!restore || restore === document.body || !document.contains(restore) || typeof restore.focus !== 'function') {
        restore = hamburger;
      }
      restore.focus();
      lastFocused = null;
      // Reset any open sub-panel after transition
      menu.addEventListener('transitionend', function hide() {
        menu.style.display = 'none';
        closeSubPanel();
        menu.removeEventListener('transitionend', hide);
      });
    }

    menu.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab' || !menu.classList.contains('mob-menu--open')) return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === menu)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    /* Which row opened the current sub-panel, so Back can hand focus straight back to
       it instead of dropping the shopper at the top of the main list. */
    var lastSubOpener = null;

    function openSubPanel(handle) {
      var sub = menu.querySelector('[data-mob-panel="' + handle + '"]');
      if (!sub || !body) return;
      // Hide any already-active sub-panel
      menu.querySelectorAll('.mob-menu__panel--sub.mob-menu__panel--active').forEach(function(p) {
        p.classList.remove('mob-menu__panel--active');
      });
      sub.classList.add('mob-menu__panel--active');
      body.classList.add('mob-menu__body--sub-open');
      /* The row we just came from is about to go inert, taking focus with it — move
         focus into the panel that slid in before that happens. */
      syncPanelInert();
      resetPanelScroll();
      var target = sub.querySelector('[data-mob-back]') || sub.querySelector(FOCUS_SEL);
      focusNoScroll(target);
    }

    function closeSubPanel() {
      if (!body) return;
      var wasOpen = menu.classList.contains('mob-menu--open');
      body.classList.remove('mob-menu__body--sub-open');
      menu.querySelectorAll('.mob-menu__panel--sub.mob-menu__panel--active').forEach(function(p) {
        p.classList.remove('mob-menu__panel--active');
      });
      /* Restore every accordion to its AUTHORED state so re-entry starts fresh.
         Not a blanket collapse any more — the first column is expanded by default
         (Figma 13501:65286), and collapsing it left the panel opening empty on the
         second visit. */
      menu.querySelectorAll('[data-mob-accordion]').forEach(function(acc) {
        var open = acc.hasAttribute('data-mob-accordion-default-open');
        var t = acc.querySelector('[data-mob-accordion-toggle]');
        var p = acc.querySelector('[data-mob-accordion-panel]');
        if (open) acc.setAttribute('data-mob-accordion-open', '');
        else acc.removeAttribute('data-mob-accordion-open');
        if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (p) {
          if (open) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        }
      });
      /* Skipped when this runs off closeMenu's transitionend — the drawer is gone by
         then and focus already belongs to the hamburger. */
      if (!wasOpen) { lastSubOpener = null; return; }
      syncPanelInert();
      resetPanelScroll();
      var back = lastSubOpener && document.contains(lastSubOpener) ? lastSubOpener : focusables()[0];
      focusNoScroll(back);
      lastSubOpener = null;
    }

    hamburger.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (backdrop) backdrop.addEventListener('click', closeMenu);

    // Open sub-panel
    menu.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-mob-open]');
      if (btn) { lastSubOpener = btn; openSubPanel(btn.dataset.mobOpen); }
    });

    // Back button in sub-panels
    menu.addEventListener('click', function(e) {
      if (e.target.closest('[data-mob-back]')) closeSubPanel();
    });

    /* QA BUG-BV-131: the Country/Region picker inside the drawer opens the SHARED
       region popup (snippets/region-popup.liquid, a <body>-child <dialog> opened
       via showModal). openMenu() sets `inert` on every <body> child except the
       drawer, so that dialog is inert — showModal still paints it, but the X,
       "skip" and backdrop are all dead and body stays scroll-locked: the page
       looks frozen. Close the drawer first so setBackgroundInert(false) runs and
       un-inerts the dialog. This listener is on `menu` (a descendant), so it fires
       BEFORE the popup's document-level open handler; we do NOT stop propagation,
       so that handler still runs and opens a now-live dialog on top. */
    menu.addEventListener('click', function(e) {
      if (e.target.closest('[data-region-open]')) closeMenu();
    });

    // Accordion toggles inside sub-panels (Use case / Fabric etc.)
    menu.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-mob-accordion-toggle]');
      if (!toggle) return;
      var acc = toggle.closest('[data-mob-accordion]');
      if (!acc) return;
      var panel = acc.querySelector('[data-mob-accordion-panel]');
      var open = acc.hasAttribute('data-mob-accordion-open');
      if (open) {
        acc.removeAttribute('data-mob-accordion-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (panel) panel.setAttribute('hidden', '');
      } else {
        acc.setAttribute('data-mob-accordion-open', '');
        toggle.setAttribute('aria-expanded', 'true');
        if (panel) panel.removeAttribute('hidden');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('mob-menu--open')) closeMenu();
    });
  })();


  /* Mobile search drawer */
  (function() {
    var STORAGE_KEY = 'bonvale_recent_searches';
    var MAX_RECENT = 5;

    var trigger = document.querySelector('[data-search-mobile-trigger]');
    var drawer = document.querySelector('[data-mob-search]');
    if (!trigger || !drawer) return;

    /* Same containing-block escape hatch as the mobile menu drawer: the
       header section group's transform makes it the containing block for
       any descendant `position: fixed` element, so the drawer would
       otherwise anchor to the header (clipped) instead of the viewport. */
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);

    var input = drawer.querySelector('[data-mob-search-input]');
    var closeBtn = drawer.querySelector('[data-mob-search-close]');
    var trendingSection = drawer.querySelector('.mob-search__section:not(.mob-search__section--recent):not(.mob-search__section--suggestions)');
    var recentSection = drawer.querySelector('[data-mob-search-recent-section]');
    var recentList = drawer.querySelector('[data-mob-search-recent-list]');
    var suggestionsSection = drawer.querySelector('[data-mob-search-suggestions-section]');
    var suggestionsList = drawer.querySelector('[data-mob-search-suggestions-list]');
    var resultsSection = drawer.querySelector('[data-mob-search-results-section]');
    var resultsList = drawer.querySelector('[data-mob-search-results-list]');
    var resultsTitle = drawer.querySelector('[data-mob-search-results-title]');
    var viewAll = drawer.querySelector('[data-mob-search-viewall]');
    var resultsLabel = (resultsSection && resultsSection.getAttribute('data-results-label')) || 'Top results';
    var form = drawer.querySelector('[data-mob-search-form]');
    var activeSuggestion = -1;

    var runPredictive = createPredictiveSearch({ limit: 8, productLimit: 6 });
    var lastTerm = '';

    function suggestionOptions() {
      return suggestionsList ? suggestionsList.querySelectorAll('[role="option"]') : [];
    }

    function setActiveSuggestion(index) {
      var options = suggestionOptions();
      if (!options.length) index = -1;
      if (index >= options.length) index = 0;
      if (index < -1) index = options.length - 1;
      activeSuggestion = index;
      options.forEach(function(option, optionIndex) {
        option.setAttribute('aria-selected', optionIndex === index ? 'true' : 'false');
      });
      if (index >= 0) input.setAttribute('aria-activedescendant', options[index].id);
      else input.removeAttribute('aria-activedescendant');
    }

    function syncCombobox(open) {
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) setActiveSuggestion(-1);
    }

    function renderPredictive(result) {
      var queries = (result && result.queries) || [];
      var products = (result && result.products) || [];
      /* BUG-BV-34: a failed request must not read as "nothing matched". */
      var mobError = drawer.querySelector('[data-mob-search-error]');
      if (mobError) mobError.hidden = !(result && result.error);
      /* Only show the live results view when there's something to show; otherwise
         keep the browse view (Trending / Recent) rather than an empty results panel. */
      var hasResults = queries.length > 0 || products.length > 0;
      setSuggestionMode(hasResults && !!lastTerm);
      if (hasResults) {
        renderSuggestions(queries);
        renderResults(products);
      }
    }

    function renderSuggestions(rows) {
      if (!suggestionsSection || !suggestionsList) return;
      suggestionsList.innerHTML = '';
      if (rows.length === 0) {
        suggestionsSection.hidden = true;
        syncCombobox(false);
        return;
      }
      rows.forEach(function (r, index) {
        var li = document.createElement('li');
        li.className = 'mob-search__item';
        var a = document.createElement('a');
        a.className = 'mob-search__keyword';
        a.id = 'mobile-search-suggestion-' + index;
        a.setAttribute('role', 'option');
        a.setAttribute('aria-selected', 'false');
        a.href = r.url;
        a.textContent = r.text;
        li.appendChild(a);
        suggestionsList.appendChild(li);
      });
      suggestionsSection.hidden = false;
      syncCombobox(true);
    }

    function renderResults(products) {
      if (!resultsSection || !resultsList) return;
      resultsList.innerHTML = '';
      if (products.length === 0) {
        resultsSection.hidden = true;
        return;
      }
      if (resultsTitle) resultsTitle.textContent = resultsLabel.replace('%%QUERY%%', lastTerm);
      if (viewAll) viewAll.href = scopedSearchUrl(lastTerm);
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'mob-search__card';
        a.href = p.url;

        var imgWrap = document.createElement('div');
        imgWrap.className = 'mob-search__card-image';
        if (p.image) {
          var img = document.createElement('img');
          /* 172px = the fixed .mob-search__card flex-basis. See the desktop
             renderer for why srcset/sizes are assigned before src. */
          if (p.imageSrcset) {
            img.sizes = '172px';
            img.srcset = p.imageSrcset;
          }
          img.src = p.image;
          img.alt = p.title || '';
          img.loading = 'lazy';
          imgWrap.appendChild(img);
        }

        var info = document.createElement('div');
        info.className = 'mob-search__card-info';
        var name = document.createElement('p');
        name.className = 'mob-search__card-name';
        name.textContent = p.title || '';
        info.appendChild(name);
        if (p.price) {
          var price = document.createElement('p');
          price.className = 'mob-search__card-price';
          price.textContent = p.price;
          info.appendChild(price);
        }

        a.appendChild(imgWrap);
        a.appendChild(info);
        resultsList.appendChild(a);
      });
      resultsSection.hidden = false;
    }

    function setSuggestionMode(active) {
      if (trendingSection) trendingSection.style.display = active ? 'none' : '';
      if (recentSection) {
        if (active) {
          recentSection.style.display = 'none';
        } else {
          renderRecent();
        }
      }
      if (!active) {
        syncCombobox(false);
        if (suggestionsSection) {
          suggestionsSection.hidden = true;
          if (suggestionsList) suggestionsList.innerHTML = '';
        }
        if (resultsSection) {
          resultsSection.hidden = true;
          if (resultsList) resultsList.innerHTML = '';
        }
      }
    }

    function getRecent() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
      catch(e) { return []; }
    }

    function saveRecent(list) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch(e) {}
    }

    function removeRecent(term) {
      var list = getRecent().filter(function(t) { return t !== term; });
      saveRecent(list);
      renderRecent();
    }

    function renderRecent() {
      var list = getRecent();
      if (!recentList || !recentSection) return;
      recentList.innerHTML = '';
      if (list.length === 0) { recentSection.style.display = 'none'; return; }
      recentSection.style.display = '';
      list.forEach(function(term) {
        var li = document.createElement('li');
        li.className = 'mob-search__item mob-search__item--recent';
        var a = document.createElement('a');
        a.className = 'mob-search__keyword';
        a.href = scopedSearchUrl(term);
        a.textContent = term;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mob-search__remove';
        btn.setAttribute('aria-label', 'Remove');
        btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15"/></svg>';
        btn.addEventListener('click', function() { removeRecent(term); });
        li.appendChild(a);
        li.appendChild(btn);
        recentList.appendChild(li);
      });
    }

    function openDrawer() {
      drawer.style.display = 'flex';
      drawer.offsetHeight;
      drawer.classList.add('mob-search--open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      renderRecent();
      if (input) setTimeout(function() { input.focus(); }, 300);
    }

    function closeDrawer() {
      drawer.classList.remove('mob-search--open');
      drawer.setAttribute('aria-hidden', 'true');
      syncCombobox(false);
      document.body.style.overflow = '';
      trigger.focus();
      var done = false;
      function hide() {
        if (done) return;
        done = true;
        drawer.style.display = 'none';
        drawer.removeEventListener('transitionend', hide);
      }
      drawer.addEventListener('transitionend', hide);
      setTimeout(hide, 400);
    }

    trigger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    if (input) {
      input.addEventListener('input', function () {
        setActiveSuggestion(-1);
        var term = input.value.trim();
        lastTerm = term;
        if (!term) {
          setSuggestionMode(false);
          runPredictive('', renderPredictive);
          return;
        }
        if (term.length < 2) {
          setSuggestionMode(false);
          runPredictive('', renderPredictive);
          return;
        }
        /* renderPredictive decides the mode from the results (see desktop note). */
        runPredictive(term, renderPredictive);
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('mob-search--open')) closeDrawer();
    });

    /* Enter-to-search (QA #3): keydown fires independently of the submit event the
       Shopify Web Pixel breaks; preventDefault stops the broken implicit submit and
       location.assign navigates directly. Submit listener kept as a fallback. */
    function submitMobSearch(term) {
      if (!term) return;
      var list = getRecent().filter(function(t) { return t !== term; });
      list.unshift(term);
      if (list.length > MAX_RECENT) list = list.slice(0, MAX_RECENT);
      saveRecent(list);
      window.location.assign(scopedSearchUrl(term));
    }
    if (input) {
      input.addEventListener('keydown', function(e) {
        var options = suggestionOptions();
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          if (!options.length) return;
          e.preventDefault();
          setActiveSuggestion(e.key === 'ArrowDown' ? activeSuggestion + 1 : activeSuggestion - 1);
          return;
        }
        if (e.key === 'Enter' && activeSuggestion >= 0 && options[activeSuggestion]) {
          e.preventDefault();
          window.location.assign(options[activeSuggestion].href);
          return;
        }
        if (e.key !== 'Enter') return;
        var term = input.value.trim();
        if (!term) return;
        e.preventDefault();
        submitMobSearch(term);
      });
    }
    if (form && input) {
      form.addEventListener('submit', function(e) {
        var term = input.value.trim();
        if (!term) return;
        e.preventDefault();
        submitMobSearch(term);
      });
    }
  })();

  /* Mega menu — pointer AND keyboard interaction.

     The panel is `display: none` until .header-nav__item--active, and that class was
     only ever set by mouseenter. Measured on prod 2026-08-06: 22 consecutive Tabs from
     the nav never reached a single submenu link, and Enter/Space/ArrowDown on the
     top-level link did nothing (Enter just followed the href) — every mega-menu
     destination was keyboard-unreachable.

     Focus opens the panel, so Tab flows link → submenu → next link with no new key to
     discover. The top-level element stays an <a> (Enter must still navigate to the
     collection), so ArrowDown is the "jump into the panel" affordance and Escape closes
     and hands focus back to the link — which doubles as the skip-the-submenu escape
     hatch, since a closed panel is display:none and drops out of the tab order. */
  (function() {
    var DELAY = 150;
    var nav = document.querySelector('.header-nav');
    var overlay = document.querySelector('[data-mega-overlay]');
    if (!nav || !overlay) return;

    var items = nav.querySelectorAll('[data-mega-item]');
    var activeItem = null;
    var closeTimer = null;

    function setExpanded(item, open) {
      var link = item && item.querySelector('.header-nav__link');
      if (link && link.hasAttribute('aria-expanded')) {
        link.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }

    function openMega(item) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (activeItem && activeItem !== item) {
        activeItem.classList.remove('header-nav__item--active');
        setExpanded(activeItem, false);
      }
      activeItem = item;
      item.classList.add('header-nav__item--active');
      setExpanded(item, true);
      var navRect = nav.getBoundingClientRect();
      overlay.style.setProperty('--header-height', (navRect.bottom) + 'px');
      overlay.classList.add('mega-menu-overlay--active');
    }

    function closeMega() {
      if (activeItem) {
        activeItem.classList.remove('header-nav__item--active');
        setExpanded(activeItem, false);
        activeItem = null;
      }
      overlay.classList.remove('mega-menu-overlay--active');
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMega, DELAY);
    }

    items.forEach(function(item) {
      var panel = item.querySelector('[data-mega-panel]');
      if (!panel) return;
      var link = item.querySelector('.header-nav__link');

      item.addEventListener('mouseenter', function() { openMega(item); });
      item.addEventListener('mouseleave', scheduleClose);

      /* focusin/focusout bubble (focus/blur do not), so one pair on the item covers
         the link and every link inside the panel. relatedTarget is the element about
         to receive focus — still inside the item means we are just moving between the
         trigger and its own panel, so hold it open. */
      item.addEventListener('focusin', function() { openMega(item); });
      item.addEventListener('focusout', function(e) {
        if (!e.relatedTarget || !item.contains(e.relatedTarget)) scheduleClose();
      });

      if (link) {
        link.addEventListener('keydown', function(e) {
          if (e.key !== 'ArrowDown') return;
          e.preventDefault();
          openMega(item);
          var first = panel.querySelector('a[href]');
          if (first) first.focus();
        });
      }
    });

    overlay.addEventListener('click', closeMega);

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape' || !activeItem) return;
      /* Focus the trigger BEFORE closing. Closing first would hide the element focus
         currently sits on and dump focus onto <body>; focusing first also keeps the
         subsequent focusout inside the item, so nothing re-opens the panel behind us. */
      var link = activeItem.querySelector('.header-nav__link');
      if (link && activeItem.contains(document.activeElement)) link.focus();
      closeMega();
    });
  })();

  /* Tap acknowledgement for the mobile category strip. The collection page takes
     seconds to arrive, so without this the tap has no visible effect (the old
     ungated :hover underline was standing in for it, which is why it looked
     broken). Pointer devices keep the hover bar and are skipped here. */
  (function() {
    var nav = document.querySelector('.header-nav');
    if (!nav) return;
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var pending = null;
    var timer = null;

    function clear() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (pending) { pending.classList.remove('header-nav__link--pending'); pending = null; }
    }

    nav.addEventListener('pointerdown', function(e) {
      var link = e.target.closest ? e.target.closest('.header-nav__link') : null;
      if (!link) return;
      clear();
      pending = link;
      link.classList.add('header-nav__link--pending');
      /* Safety net: if the tap turned out to be a scroll gesture (the strip is a
         horizontal scroller) or the navigation was cancelled, don't leave the
         link stuck in the pending state. */
      timer = setTimeout(clear, 8000);
    }, { passive: true });

    nav.addEventListener('pointercancel', clear, { passive: true });
    /* Back/forward cache restore hands back the same DOM — drop the stale state. */
    window.addEventListener('pageshow', function(e) { if (e.persisted) clear(); });
  })();

  /* Announcement marquee (mobile only, ≤900px — same breakpoint as the mobile
     announcement styles). Localized copy runs up to ~2x the English length: the
     French tagline is ~95 chars against 50, so at 13px it is ~600px wide in a
     ~343px bar. The slide is `white-space: nowrap` and `html { overflow-x: clip }`
     silently cut BOTH ends of the sentence. When a slide overflows we clone its
     copy into the track and scroll the pair as a seamless marquee.

     Two non-obvious bits:
     - The period is snapped to a whole divisor of the crossfade cycle and shares
       its delay, so the slide always fades in at x=0 (start of the sentence)
       rather than at whatever offset a free-running marquee happens to be at.
     - The cycle itself is stretched to 16s while a marquee is live, because the
       8s default leaves each slide visible ~3.2s — not enough to scroll a
       translated sentence past at a readable speed. */
  (function() {
    var mq = window.matchMedia('(max-width: 900px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var SPEED = 45;         /* px/s — fast enough to finish, slow enough to read */
    var MOBILE_CYCLE = 16;  /* s, crossfade cycle while a marquee is running */
    var MIN_OVERFLOW = 4;   /* px of overflow worth scrolling for */

    function apply() {
      /* Re-queried every pass so a theme-editor section reload is picked up. */
      var inner = document.querySelector('.header-announcement__inner');
      var message = document.querySelector('.header-announcement__message');
      if (!inner || !message) return;
      var slides = message.querySelectorAll('.header-announcement__slide');

      message.style.removeProperty('--announcement-fade-duration');
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.remove('header-announcement__slide--marquee');
        slides[i].style.removeProperty('--marquee-duration');
        var stale = slides[i].querySelector('[data-marquee-clone]');
        if (stale) stale.parentNode.removeChild(stale);
      }
      /* Reduced motion falls back to wrapping — handled in CSS. */
      if (!mq.matches || reduce.matches) return;

      var pad = window.getComputedStyle(inner);
      var available = inner.clientWidth - parseFloat(pad.paddingLeft) - parseFloat(pad.paddingRight);
      if (!(available > 0)) return;

      var overflowing = [];
      for (var j = 0; j < slides.length; j++) {
        var copy = slides[j].querySelector('.header-announcement__copy');
        /* MIN_OVERFLOW, not 0: sub-pixel text metrics report phantom overflows,
           and scrolling a whole sentence to recover 2-3px (well under one
           character) would be far more distracting than the hairline clip. */
        if (copy && copy.getBoundingClientRect().width - available > MIN_OVERFLOW) {
          overflowing.push(slides[j]);
        }
      }
      if (!overflowing.length) return;

      var rotating = message.classList.contains('header-announcement__message--rotating');
      var cycle = 0;
      if (rotating) {
        cycle = MOBILE_CYCLE;
        message.style.setProperty('--announcement-fade-duration', cycle + 's');
      }

      for (var k = 0; k < overflowing.length; k++) {
        var slide = overflowing[k];
        var track = slide.querySelector('.header-announcement__track');
        var source = slide.querySelector('.header-announcement__copy');
        if (!track || !source) continue;

        var clone = source.cloneNode(true);
        clone.setAttribute('data-marquee-clone', '');
        /* The duplicate is decoration: off the a11y tree and out of the tab order. */
        clone.setAttribute('aria-hidden', 'true');
        var links = clone.querySelectorAll('a');
        for (var l = 0; l < links.length; l++) {
          links[l].setAttribute('tabindex', '-1');
        }
        track.appendChild(clone);
        slide.classList.add('header-announcement__slide--marquee');

        /* Measured after the class lands so the copy's marquee padding (the
           inter-copy gap) is included in the travel distance. */
        var period = track.getBoundingClientRect().width / 2 / SPEED;
        if (cycle) {
          period = cycle / Math.max(1, Math.round(cycle / period));
        }
        slide.style.setProperty('--marquee-duration', period.toFixed(2) + 's');
      }
    }

    var timer = null;
    function schedule() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(apply, 150);
    }

    apply();
    /* Web fonts change the measurement — remeasure once they land. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(apply);
    }
    window.addEventListener('resize', schedule, { passive: true });
    mq.addEventListener('change', apply);
    reduce.addEventListener('change', apply);
    document.addEventListener('shopify:section:load', schedule);
  })();

  /* Sticky header: publish announcement height as CSS var so the wrapper
     can offset itself upward by that amount, hiding the announcement on scroll. */
  (function() {
    var group = document.querySelector('.site-banner');
    var announcement = document.querySelector('.header-announcement');
    if (!group || !announcement) return;

    function sync() {
      group.style.setProperty('--announcement-height', announcement.offsetHeight + 'px');
    }
    sync();
    window.addEventListener('resize', sync, { passive: true });
  })();

  /* Mobile auto-hide on scroll. Adds/removes .header-group--hidden based on
     scroll direction; PC behavior is unaffected because the relevant CSS is
     inside @media (max-width: 900px). Scrolling DOWN only hides once the
     shopper has scrolled past one full header height (announcement + main
     row): the announcement scrolls off first, the main row then sits frozen
     at the top for ~60px, and only then does it retract. On the PDP that
     frozen beat is where the breadcrumb reveals itself under the pinned row
     (sections/product.liquid, same announcement-height trigger); the retract
     then uncovers it at the top and it scrolls away with the page — the three
     beats of the Lululemon reference (Slack 2026-09-10). */
  (function() {
    var group = document.querySelector('.site-banner');
    if (!group) return;
    var mq = window.matchMedia('(max-width: 900px)');

    var lastY = window.scrollY;
    var TOP_THRESHOLD = 10;
    var DELTA_THRESHOLD = 5;
    var ticking = false;

    function hideAfter() {
      return Math.max(TOP_THRESHOLD, group.offsetHeight);
    }

    function update() {
      ticking = false;
      var y = window.scrollY;
      if (!mq.matches || y <= TOP_THRESHOLD) {
        group.classList.remove('header-group--hidden');
        lastY = y;
        return;
      }
      var delta = y - lastY;
      if (Math.abs(delta) < DELTA_THRESHOLD) return;
      if (delta > 0) {
        if (y > hideAfter()) group.classList.add('header-group--hidden');
      } else {
        group.classList.remove('header-group--hidden');
      }
      lastY = y;
    }

    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });

    mq.addEventListener('change', function() {
      group.classList.remove('header-group--hidden');
      lastY = window.scrollY;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-categories"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.home-categories').forEach(function(section) {
    var track = section.querySelector('[data-categories-track]');
    var prev = section.querySelector('[data-categories-prev]');
    var next = section.querySelector('[data-categories-next]');
    if (!track || !prev || !next) return;

    var index = 0;
    var items = track.children.length;
    var cols = parseInt(getComputedStyle(section).getPropertyValue('--cat-columns')) || 5;
    var maxIndex = Math.max(items - cols, 0);

    function slide() {
      var card = track.children[0];
      var gap = parseFloat(getComputedStyle(track).gap) || 40;
      var step = card.getBoundingClientRect().width + gap;
      track.style.transform = 'translateX(' + (-index * step) + 'px)';
      prev.style.display = index <= 0 ? 'none' : '';
      next.style.display = index >= maxIndex ? 'none' : '';
    }

    next.addEventListener('click', function() {
      if (index < maxIndex) { index++; slide(); }
    });
    prev.addEventListener('click', function() {
      if (index > 0) { index--; slide(); }
    });

    slide();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["materials-content"]) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-materials]');
    if (!root) return;

    var tabs = root.querySelectorAll('[data-materials-tab]');
    var panels = root.querySelectorAll('[data-materials-panel]');
    var validKeys = Array.prototype.map.call(tabs, function(t) { return t.dataset.materialsTab; });
    var defaultKey = root.dataset.materialsDefault || validKeys[0];

    function setActive(key) {
      if (validKeys.indexOf(key) === -1) key = defaultKey;
      tabs.forEach(function(t) {
        var on = t.dataset.materialsTab === key;
        t.classList.toggle('materials__tab--active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function(p) {
        p.hidden = p.dataset.materialsPanel !== key;
      });
    }

    tabs.forEach(function(t) {
      t.addEventListener('click', function() {
        var key = t.dataset.materialsTab;
        setActive(key);
        if (history.replaceState) {
          history.replaceState(null, '', '#' + key);
        } else {
          location.hash = key;
        }
      });
    });

    window.addEventListener('hashchange', function() {
      var k = (location.hash || '').replace(/^#/, '');
      if (k) setActive(k);
    });

    var initial = (location.hash || '').replace(/^#/, '') || defaultKey;
    setActive(initial);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-more-to-explore"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DRAG_THRESHOLD = 5;
  var PER_PAGE = 4;

  var section = document.querySelector('[data-mte]');
  if (!section) return;
  var viewport = section.querySelector('[data-mte-viewport]');
  var track = section.querySelector('[data-mte-track]');
  var prev = section.querySelector('[data-mte-prev]');
  var next = section.querySelector('[data-mte-next]');
  var dotsEl = section.querySelector('[data-mte-dots]');
  /* This block is static JS and cannot run Liquid, so the translated string
     crosses over as a data attribute with a %%N%% placeholder — same pattern as
     taste-grid. Hardcoding 'Page ' left it English in every locale. */
  var labelPage = section.dataset.labelPage || 'Page %%N%%';
  if (!viewport || !track) return;

  /* When Wear It With hides itself (< 4 complementary products), move this
     section's shopify-section wrapper into WIW's original DOM position. */
  document.addEventListener('wear-it-with:hidden', function () {
    var wiwEl = document.querySelector('[data-ctl]');
    var wiwShopifySection = wiwEl && wiwEl.closest('.shopify-section');
    var mteShopifySection = section.closest('.shopify-section');
    if (!wiwShopifySection || !mteShopifySection) return;
    if (wiwShopifySection === mteShopifySection) return;
    if (mteShopifySection.parentNode !== wiwShopifySection.parentNode) return;
    wiwShopifySection.parentNode.insertBefore(mteShopifySection, wiwShopifySection);
  });

  var productJson = document.querySelector('script[id^="product-json-"]');
  if (!productJson) return;
  var productId = JSON.parse(productJson.textContent).id;

  var totalPages = 0;
  var currentPage = 1;

  function renderDots(count) {
    if (!dotsEl) return;
    dotsEl.innerHTML = '';
    for (var i = 1; i <= count; i++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'more-to-explore__dot' + (i === currentPage ? ' more-to-explore__dot--active' : '');
      btn.setAttribute('data-mte-dot', i);
      btn.setAttribute('aria-label', labelPage.replace('%%N%%', i));
      dotsEl.appendChild(btn);
    }
  }

  function updateUI() {
    if (prev) prev.disabled = currentPage <= 1;
    if (next) {
      /* Mobile is a free-scroll rail (not paginated), so the single arrow's
         disabled state tracks actual scroll position, not page count. */
      if (window.matchMedia('(max-width: 768px)').matches) {
        next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
      } else {
        next.disabled = currentPage >= totalPages;
      }
    }
    if (dotsEl) {
      var dots = dotsEl.querySelectorAll('.more-to-explore__dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('more-to-explore__dot--active', i + 1 === currentPage);
      }
    }
  }

  function scrollToPage(page) {
    if (page < 1 || page > totalPages) return;
    viewport.scrollTo({ left: (page - 1) * viewport.clientWidth, behavior: 'smooth' });
  }

  function buildPages(cards) {
    track.innerHTML = '';
    totalPages = Math.ceil(cards.length / PER_PAGE);
    for (var p = 1; p <= totalPages; p++) {
      var pageEl = document.createElement('div');
      pageEl.className = 'more-to-explore__page';
      pageEl.dataset.mtePage = p;
      var slice = cards.slice((p - 1) * PER_PAGE, p * PER_PAGE);
      slice.forEach(function (c) { pageEl.appendChild(c); });
      track.appendChild(pageEl);
    }
    currentPage = 1;
    viewport.scrollLeft = 0;
    renderDots(totalPages);
    if (window.Wishlist) window.Wishlist.updateAll();
    updateUI();
  }

  fetch(window.Shopify.routes.root + 'recommendations/products?product_id=' + productId + '&limit=10&intent=related&section_id=more-to-explore-content')
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var cards = Array.prototype.slice.call(tmp.querySelectorAll('.product-card'));
      if (cards.length === 0) {
        section.style.display = 'none';
        return;
      }
      buildPages(cards);
    })
    .catch(function () { section.style.display = 'none'; });

  /* Scroll listener — sync currentPage with native scroll position. */
  var scrollRaf = null;
  viewport.addEventListener('scroll', function () {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = null;
      var w = viewport.clientWidth;
      if (w === 0) return;
      var page = Math.round(viewport.scrollLeft / w) + 1;
      if (page !== currentPage) {
        currentPage = page;
        updateUI();
      }
    });
  });

  if (prev) prev.addEventListener('click', function () { scrollToPage(currentPage - 1); });
  if (next) next.addEventListener('click', function () {
    if (window.matchMedia('(max-width: 768px)').matches) {
      viewport.scrollBy({ left: viewport.clientWidth * 0.9, behavior: 'smooth' });
    } else {
      scrollToPage(currentPage + 1);
    }
  });
  if (dotsEl) {
    dotsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mte-dot]');
      if (!btn) return;
      scrollToPage(parseInt(btn.dataset.mteDot, 10));
    });
  }

  /* PC mouse drag. dragMoved tracked so a drag does not also fire a click. */
  var isDown = false;
  var dragStartX = 0;
  var dragStartScroll = 0;
  var dragMoved = 0;
  viewport.addEventListener('mousedown', function (e) {
    if (e.button !== 0) return;
    isDown = true;
    dragMoved = 0;
    dragStartX = e.pageX;
    dragStartScroll = viewport.scrollLeft;
    viewport.classList.add('more-to-explore__viewport--grabbing');
  });
  document.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    var dx = e.pageX - dragStartX;
    dragMoved = Math.abs(dx);
    if (dragMoved > DRAG_THRESHOLD) {
      viewport.scrollLeft = dragStartScroll - dx;
    }
  });
  document.addEventListener('mouseup', function () {
    if (!isDown) return;
    isDown = false;
    viewport.classList.remove('more-to-explore__viewport--grabbing');
  });
  viewport.addEventListener('click', function (e) {
    if (dragMoved > DRAG_THRESHOLD) {
      e.preventDefault();
      e.stopPropagation();
      dragMoved = 0;
    }
  }, true);

  /* Re-anchor scroll position on resize so currentPage stays visible. */
  window.addEventListener('resize', function () {
    viewport.scrollLeft = (currentPage - 1) * viewport.clientWidth;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Locale-aware root: '' on the primary locale, '/fr' etc. on secondary ones.
     Section Rendering fetches MUST carry it or the injected cards come back in
     the shop's DEFAULT locale (untranslated badges/labels). */
  var LOCALE_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');

  var STORAGE_KEY = 'bonvale_recently_viewed';
  var MAX_ITEMS = 20;
  var EXCLUDED_TAGS = ['bundle', 'test', 'not-sold-separately'];
  var FETCH_LIMIT = 8;
  var PER_PAGE = 4;
  var DRAG_THRESHOLD = 5;

  var section = document.querySelector('[data-recently-viewed]');
  if (!section) return;

  var currentHandle = section.dataset.currentHandle;
  var currentId = section.dataset.currentId;
  var viewport = section.querySelector('[data-rv-viewport]');
  var track = section.querySelector('[data-rv-track]');
  var prev = section.querySelector('[data-rv-prev]');
  var next = section.querySelector('[data-rv-next]');
  var dotsEl = section.querySelector('[data-rv-dots]');

  if (!viewport || !track) return;

  /* Normalize storage entries — legacy entries were plain handle strings, now {handle, id}. */
  function normalize(raw) {
    if (typeof raw === 'string') return { handle: raw, id: null };
    if (raw && typeof raw === 'object' && raw.handle) return { handle: raw.handle, id: raw.id || null };
    return null;
  }

  /* Whether the current product carries an excluded tag (bundle / test) —
     such products are never recorded into the recently-viewed list. */
  var currentTags = (section.dataset.currentTags || '').split(',');
  /* This block is static JS and cannot run Liquid, so the translated string
     crosses over as a data attribute with a %%N%% placeholder — same pattern as
     taste-grid. Hardcoding 'Page ' left it English in every locale. */
  var labelPage = section.dataset.labelPage || 'Page %%N%%';
  var isExcluded = currentTags.some(function(t) {
    return EXCLUDED_TAGS.indexOf(t.trim()) !== -1;
  });

  /* Record current product (unless it's an excluded product) */
  if (!isExcluded) {
    try {
      var items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
        .map(normalize)
        .filter(function(it) { return it && it.handle !== currentHandle; });
      items.unshift({ handle: currentHandle, id: currentId || null });
      if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch(e) {}
  }

  /* Load recently viewed (excluding current) */
  var entries = [];
  try {
    entries = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
      .map(normalize)
      .filter(function(it) { return it && it.handle !== currentHandle; });
  } catch(e) {}

  if (entries.length === 0) return;
  var handles = entries.map(function(e) { return e.handle; }).slice(0, FETCH_LIMIT);

  var totalPages = 0;
  var currentPage = 1;

  function renderDots(count) {
    if (!dotsEl) return;
    dotsEl.innerHTML = '';
    dotsEl.style.display = count <= 1 ? 'none' : '';
    for (var i = 1; i <= count; i++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'recently-viewed__dot' + (i === currentPage ? ' recently-viewed__dot--active' : '');
      btn.setAttribute('data-rv-dot', i);
      btn.setAttribute('aria-label', labelPage.replace('%%N%%', i));
      dotsEl.appendChild(btn);
    }
  }

  function updateUI() {
    if (prev) prev.disabled = currentPage <= 1;
    if (next) {
      /* Mobile is a free-scroll rail (not paginated), so the single arrow's
         disabled state tracks actual scroll position, not page count. */
      if (window.matchMedia('(max-width: 768px)').matches) {
        next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
      } else {
        next.disabled = currentPage >= totalPages;
      }
    }
    if (dotsEl) {
      var dots = dotsEl.querySelectorAll('.recently-viewed__dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('recently-viewed__dot--active', i + 1 === currentPage);
      }
    }
  }

  function scrollToPage(page) {
    if (page < 1 || page > totalPages) return;
    viewport.scrollTo({ left: (page - 1) * viewport.clientWidth, behavior: 'smooth' });
  }

  function buildPages(cards) {
    track.innerHTML = '';
    totalPages = Math.ceil(cards.length / PER_PAGE);
    for (var p = 1; p <= totalPages; p++) {
      var pageEl = document.createElement('div');
      pageEl.className = 'recently-viewed__page';
      pageEl.dataset.rvPage = p;
      var slice = cards.slice((p - 1) * PER_PAGE, p * PER_PAGE);
      slice.forEach(function(c) { pageEl.appendChild(c); });
      track.appendChild(pageEl);
    }
    currentPage = 1;
    viewport.scrollLeft = 0;
    renderDots(totalPages);
    if (window.Wishlist) window.Wishlist.updateAll();
    updateUI();
  }

  /* Fetch each handle's card HTML, preserving order. Concurrency is capped —
     one request per handle at once trips Shopify's 429 rate limit alongside
     the page's other fetches. */
  var CONCURRENCY = 3;
  var fetched = 0;
  var nextIndex = 0;
  var cardSlots = new Array(handles.length);

  function fetchOne() {
    if (nextIndex >= handles.length) return;
    var index = nextIndex++;
    fetch(LOCALE_ROOT + '/products/' + handles[index] + '?section_id=recently-viewed-card')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var card = tmp.querySelector('.product-card');
        if (card) cardSlots[index] = card;
      })
      .catch(function() {})
      .finally(function() {
        fetched++;
        if (fetched === handles.length) {
          var cards = cardSlots.filter(Boolean);
          if (cards.length === 0) return;
          section.style.display = '';
          buildPages(cards);
        } else {
          fetchOne();
        }
      });
  }
  for (var i = 0; i < CONCURRENCY && i < handles.length; i++) fetchOne();

  /* Scroll listener — sync currentPage with native scroll position. */
  var scrollRaf = null;
  viewport.addEventListener('scroll', function() {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(function() {
      scrollRaf = null;
      var w = viewport.clientWidth;
      if (w === 0) return;
      var page = Math.round(viewport.scrollLeft / w) + 1;
      if (page !== currentPage) {
        currentPage = page;
        updateUI();
      }
    });
  });

  if (prev) prev.addEventListener('click', function() { scrollToPage(currentPage - 1); });
  if (next) next.addEventListener('click', function() {
    if (window.matchMedia('(max-width: 768px)').matches) {
      viewport.scrollBy({ left: viewport.clientWidth * 0.9, behavior: 'smooth' });
    } else {
      scrollToPage(currentPage + 1);
    }
  });
  if (dotsEl) {
    dotsEl.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-rv-dot]');
      if (!btn) return;
      scrollToPage(parseInt(btn.dataset.rvDot, 10));
    });
  }

  /* PC mouse drag. */
  var isDown = false;
  var dragStartX = 0;
  var dragStartScroll = 0;
  var dragMoved = 0;
  viewport.addEventListener('mousedown', function(e) {
    if (e.button !== 0) return;
    isDown = true;
    dragMoved = 0;
    dragStartX = e.pageX;
    dragStartScroll = viewport.scrollLeft;
    viewport.classList.add('recently-viewed__viewport--grabbing');
  });
  document.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    var dx = e.pageX - dragStartX;
    dragMoved = Math.abs(dx);
    if (dragMoved > DRAG_THRESHOLD) {
      viewport.scrollLeft = dragStartScroll - dx;
    }
  });
  document.addEventListener('mouseup', function() {
    if (!isDown) return;
    isDown = false;
    viewport.classList.remove('recently-viewed__viewport--grabbing');
  });
  viewport.addEventListener('click', function(e) {
    if (dragMoved > DRAG_THRESHOLD) {
      e.preventDefault();
      e.stopPropagation();
      dragMoved = 0;
    }
  }, true);

  /* Re-anchor on resize. */
  window.addEventListener('resize', function() {
    viewport.scrollLeft = (currentPage - 1) * viewport.clientWidth;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-wear-it-with"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrapper = document.querySelector('[data-ctl]');
  if (!wrapper) return;
  var container = wrapper.querySelector('[data-ctl-products]');
  if (!container) return;

  var productId = wrapper.getAttribute('data-product-id');
  if (!productId) return;

  var url =
    window.Shopify.routes.root +
    'recommendations/products?product_id=' +
    productId +
    /* complementary-content-quick-add → the SIMPLIFIED card (card_mode
       'quick-add': "+" top-right, no heart, no swatches, whole card opens the
       quick-add sheet), per Dux 2026-09-07 / Product card v1.3. The plain
       complementary-content section used to be fetched here and the heart /
       swatches hidden in CSS below, which left phones with no control at all
       once the default card dropped its "+". */
    '&limit=6&intent=complementary&section_id=complementary-content-quick-add';

  function signalHidden() {
    document.dispatchEvent(new CustomEvent('wear-it-with:hidden'));
  }

  fetch(url)
    .then(function (response) { return response.text(); })
    .then(function (text) {
      var temp = document.createElement('div');
      temp.innerHTML = text;
      var cards = temp.querySelectorAll('.product-card');
      /* Hide WIW when fewer than 4 complementary products are available —
         More to Explore will move into this slot via the wear-it-with:hidden event. */
      if (!cards || cards.length < 4) {
        signalHidden();
        return;
      }

      var html = '';
      for (var i = 0; i < cards.length && i < 6; i++) {
        html += cards[i].outerHTML;
      }
      container.innerHTML = html;
      wrapper.style.display = '';
      if (window.Wishlist) window.Wishlist.updateAll();
    })
    .catch(function (err) {
      console.error('[wear-it-with] Error:', err);
      signalHidden();
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Persists across in-page bundle swaps so we can disconnect the previous
  // section's sticky observer before observing the freshly swapped-in one.
  var stickyObserver = null;

  // ---------- switching (loading) feedback ----------
  // Two of the three option rows on a PDP do NOT resolve instantly:
  //   • Quantity (6-Pack / 3-Pack / Singles) → AJAX Section Rendering fetch of a
  //     sibling product, then a gallery + buy-box swap.
  //   • Combined-listing Colour / Style values → a real navigation to another product.
  // Both take ~0.5–2s on mobile, and until now neither acknowledged the tap, so the
  // control read as dead and shoppers double-tapped. beginSwitching() marks the pressed
  // control (spinner) and freezes/dims the parts of the page that are about to change.
  function switchRoot() {
    return document.querySelector('[id^="product-main-"]');
  }

  function isSwitching() {
    var root = switchRoot();
    return !!root && root.classList.contains('product-main--switching');
  }

  function beginSwitching(control) {
    var root = switchRoot();
    if (root) root.classList.add('product-main--switching');
    if (control) control.classList.add('is-switching');
  }

  function endSwitching() {
    var root = switchRoot();
    if (root) root.classList.remove('product-main--switching');
    // The AJAX swap replaces the buy box, so the pressed control is usually gone
    // already — this clears the state on the paths where it survives.
    document.querySelectorAll('.is-switching').forEach(function (el) {
      el.classList.remove('is-switching');
    });
  }

  // Re-runnable section initializer. Called once on load and again after each
  // bundle quantity swap replaces the [id^="product-main-"] DOM. Everything below
  // is scoped to the `section` argument so it rebinds cleanly against fresh DOM.
  function initProductSection(section) {
  if (!section) return;

  const sectionId = section.id.replace('product-main-', '');
  const productJson = document.getElementById('product-json-' + sectionId);
  if (!productJson) return;

  const product = JSON.parse(productJson.textContent);
  const variants = product.variants;

  // Current selected options.
  // Options flagged data-option-required (everything except Color and combined-
  // listing options) start UNSELECTED — the shopper must pick them deliberately.
  const requiredIndexes = [];
  section.querySelectorAll('[data-option-required="true"]').forEach(function (el) {
    requiredIndexes.push(parseInt(el.dataset.optionIndex));
  });
  const selectedOptions = {};
  const currentVariant = variants.find(function (v) { return v.id === parseInt(section.querySelector('input[data-variant-id]').value); });
  if (currentVariant) {
    product.options.forEach(function (optName, i) {
      if (requiredIndexes.indexOf(i) === -1) {
        selectedOptions[i] = currentVariant.options[i];
      }
    });
  }

  function clearOptionError(index) {
    var c = section.querySelector('[data-option-type="size"][data-option-index="' + index + '"]');
    if (c) c.classList.remove('product-info__sizes--error');
  }

  // "Only few items left for this size" — shown only while the shopper has a fully
  // picked, in-stock size whose variant id is in the server-rendered low-stock list
  // (`data-low-stock-ids`, built in Liquid because `product | json` carries no
  // inventory numbers). `match` is undefined until every required option is set, so
  // an incomplete selection hides the note.
  function updateLowStockNote(match) {
    section.querySelectorAll('[data-low-stock]').forEach(function (el) {
      var show = false;
      if (match && match.available) {
        var ids = (el.dataset.lowStockIds || '').split(',');
        show = ids.indexOf(String(match.id)) !== -1;
      }
      el.style.display = show ? '' : 'none';
    });
  }

  // --- Retail price normalized to active currency ---
  // `data-retail-price-cents` is in shop base currency when retail came from UK fallback
  // (`data-retail-fallback="true"`); otherwise it's already in the visitor's active
  // currency. Variant prices (`current_variant.price` in Liquid, `match.price` in JS) are
  // always presented in active currency via Shopify Markets, so without this normalization
  // the "You save X%" math mixes GBP retail with USD/AUD variant and renders nonsense.
  var priceSectionRoot = section.querySelector('[data-price-section]');
  var retailFallbackFlag = !!(priceSectionRoot && priceSectionRoot.dataset.retailFallback === 'true');
  var retailPriceCentsRaw = parseInt((priceSectionRoot && priceSectionRoot.dataset.retailPriceCents) || '0');
  var activeCurrencyRate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
  var retailPriceCentsActive = retailFallbackFlag ? Math.round(retailPriceCentsRaw * activeCurrencyRate) : retailPriceCentsRaw;

  function refreshRetailSavings(matchPrice, hasSale) {
    if (retailPriceCentsActive <= 0 || retailPriceCentsActive <= matchPrice) return;
    var pct = Math.round((retailPriceCentsActive - matchPrice) / retailPriceCentsActive * 100);
    section.querySelectorAll('[data-retail-savings-pct]').forEach(function (el) {
      el.textContent = pct + '%';
    });
    // Sticky CTA: only update from retail when there's no compare_at sale active —
    // otherwise sticky_pct already represents the (correctly-computed) sale percentage.
    if (!hasSale) {
      var stickyPctEl = section.querySelector('[data-sticky-cta-savings-pct]');
      if (stickyPctEl) stickyPctEl.textContent = pct;
    }
  }

  // Option buttons (color + size + bundle pack — all share the same machinery)
  section.querySelectorAll('[data-option-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const index = parseInt(this.dataset.optionIndex);
      const value = this.dataset.optionValue;

      selectedOptions[index] = value;
      clearOptionError(index);
      updateVariant();
    });
  });

  // ===== Bundle Sale: per-section wiring (safe no-ops on non-bundle PDPs) =====
  fillPackThumbnails(section, product);
  bindPackToggle(section);
  bindBundleOptionAnalytics(section);
  fireBundleView(section);

  function updateVariant() {
    // Reflect the current selection in the option UI immediately — runs even when
    // the selection is incomplete (a required option still unset) so the clicked
    // button highlights right away.
    syncOptionUI();

    // Find matching variant. Stays null until every option (including required
    // ones like Size) is chosen, so price/cart state only updates on a full pick.
    const match = variants.find(function (v) {
      return product.options.every(function (_, i) {
        return v.options[i] === selectedOptions[i];
      });
    });

    // Runs BEFORE the incomplete-selection bail below: switching to a colour whose
    // size is not yet re-picked has to clear the previous size's note, not keep it.
    updateLowStockNote(match);

    if (!match) return;

    // Update hidden input
    const variantInput = section.querySelector('input[data-variant-id]');
    if (variantInput) variantInput.value = match.id;

    // Wishlist writes must use the shopper's selected variant, not the
    // server-rendered first available variant. Swym reads this dataset value
    // when the heart is clicked.
    const wishlistBtn = section.querySelector('.product-info__wishlist [data-wishlist-btn]');
    if (wishlistBtn) wishlistBtn.dataset.variantId = match.id;

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url);

    // --- Price update ---
    // Bundle deal test: a pack in a deal market has no compare_at — its reference price
    // is single × pieces, server-derived onto data-bundle-original (cents, market
    // currency). It wins over compare_at whenever present.
    var dealOriginal = parseInt(section.getAttribute('data-bundle-original') || '0') || 0;
    var compareBase = dealOriginal > 0 ? dealOriginal : match.compare_at_price;
    var hasDiscount = !!(compareBase && compareBase > match.price);
    var saleWrap = document.querySelector('[data-price-sale]');
    var regularWrap = document.querySelector('[data-price-regular]');

    // Toggle sale vs regular layout
    if (saleWrap) saleWrap.style.display = hasDiscount ? '' : 'none';
    if (regularWrap) regularWrap.style.display = hasDiscount ? 'none' : '';

    // Update sale layout elements
    var compareEl = document.querySelector('[data-compare-price]');
    var discountTag = document.querySelector('[data-discount-tag]');
    var salePrice = document.querySelector('[data-sale-price]');
    if (salePrice) salePrice.textContent = formatMoney(match.price);
    if (compareEl) compareEl.textContent = hasDiscount ? formatMoney(compareBase) : '';
    if (discountTag && hasDiscount) {
      // Bundle deal test: a pack in a deal market shows the per-item price instead of
      // "% off" (Figma 16436:64693). The translated template rides on the tag itself.
      var perItemTpl = discountTag.getAttribute('data-per-item-template');
      var dealQty = parseInt(section.getAttribute('data-bundle-qty') || '1') || 1;
      if (perItemTpl && dealQty > 1) {
        // Liquid renders the tag with `| money` (no ISO code — the code sits next to
        // the main price only), so drop the suffix BonvaleMoney appends for
        // ambiguous currencies; otherwise a size change flips "$31.66/item" to
        // "$31.66 AUD/item".
        var unit = formatMoney(Math.floor(match.price / dealQty));
        var isoCode = window.BonvaleMoney && window.BonvaleMoney.parts && window.BonvaleMoney.parts.code;
        if (isoCode && unit.slice(-isoCode.length) === isoCode) unit = unit.slice(0, -isoCode.length).trim();
        discountTag.textContent = perItemTpl.replace('__PRICE__', unit);
      } else {
        var salePct = Math.round((compareBase - match.price) / compareBase * 100);
        discountTag.textContent = salePct + '% off';
      }
    }

    // Update regular layout price (savings text is refreshed via refreshRetailSavings below)
    var regularPrice = document.querySelector('[data-regular-price]');
    if (regularPrice) regularPrice.textContent = formatMoney(match.price);

    // Update comparison table own price & saving. On a pack the table compares
    // PER ITEM (see the Liquid above the table), so divide by the pack's pieces.
    var compareOwnPrice = document.querySelector('[data-compare-own-price]');
    var compareOwnCents = compareOwnPriceCents(match.price);
    if (compareOwnPrice) {
      var compareTbl = document.querySelector('.product-info__compare-table');
      var perItemCompareTpl = compareTbl ? compareTbl.getAttribute('data-compare-per-item-tmpl') : '';
      if (perItemCompareTpl && compareOwnCents !== match.price) {
        var ownUnit = formatMoney(compareOwnCents);
        var ownIso = window.BonvaleMoney && window.BonvaleMoney.parts && window.BonvaleMoney.parts.code;
        if (ownIso && ownUnit.slice(-ownIso.length) === ownIso) ownUnit = ownUnit.slice(0, -ownIso.length).trim();
        compareOwnPrice.textContent = perItemCompareTpl.replace('__PRICE__', ownUnit);
      } else {
        compareOwnPrice.textContent = formatMoney(match.price);
      }
    }
    applyCompareFallback(compareOwnCents);
    var compareOwnSaving = document.querySelector('[data-compare-own-saving]');
    if (compareOwnSaving) {
      if (retailPriceCentsActive > 0 && retailPriceCentsActive > match.price) {
        compareOwnSaving.textContent = Math.round((retailPriceCentsActive - match.price) / retailPriceCentsActive * 100) + '%';
      } else {
        compareOwnSaving.textContent = '';
      }
    }

    // Refresh all retail-based "You save X%" elements (gallery tag, sale/regular savings,
    // sticky CTA when not on sale) using the normalized retail price.
    refreshRetailSavings(match.price, hasDiscount);

    // Update transparent pricing bar chart
    updatePricingChart(match.price);

    // Update add to cart / notify me states
    var addBtn = document.querySelector('[data-add-to-cart]');
    var notifyBtn = document.querySelector('[data-notify-btn]');
    var oosSku = document.querySelector('[data-oos-sku]');
    var notifyForm = document.querySelector('[data-notify-form]');
    var notifyConfirm = document.querySelector('[data-notify-confirm]');
    var installmentRow = document.querySelector('[data-installment-row]');
    var shippingBanner = document.querySelector('[data-shipping-banner]');
    var appBlocks = document.querySelectorAll('[data-app-block]');

    if (match.available) {
      if (addBtn) { addBtn.style.display = ''; addBtn.disabled = false; addBtn.textContent = addBtn.dataset.addText || 'Add To Bag'; }
      if (notifyBtn) notifyBtn.style.display = 'none';
      if (oosSku) oosSku.style.display = 'none';
      if (notifyForm) notifyForm.style.display = 'none';
      if (notifyConfirm) notifyConfirm.style.display = 'none';
      if (installmentRow) {
        installmentRow.style.display = '';
        var instEl = installmentRow.querySelector('[data-installment]');
        /* BUG-BV-32: rebuild from the server-rendered translation, never a literal. */
        var instTpl = installmentRow.dataset.installmentTemplate;
        if (instEl && instTpl) instEl.innerHTML = instTpl.replace('%%AMOUNT%%', formatMoney(Math.round(match.price / 3)));
      }
      if (shippingBanner) shippingBanner.style.display = '';
      appBlocks.forEach(function (el) { el.style.display = ''; });
    } else {
      if (addBtn) addBtn.style.display = 'none';
      if (notifyBtn) notifyBtn.style.display = '';
      if (oosSku) oosSku.style.display = '';
      if (notifyForm) notifyForm.style.display = 'none';
      if (notifyConfirm) notifyConfirm.style.display = 'none';
      if (installmentRow) installmentRow.style.display = 'none';
      if (shippingBanner) shippingBanner.style.display = 'none';
      appBlocks.forEach(function (el) { el.style.display = 'none'; });
    }

    // Sync mobile sticky CTA with variant state
    updateStickyCta(match, retailPriceCentsActive, hasDiscount);

    // Fetch fresh HTML via section rendering API to update availability states
    var optionValueIds = [];
    section.querySelectorAll('[data-option-value]').forEach(function (btn) {
      var idx = parseInt(btn.dataset.optionIndex);
      if (btn.dataset.optionValueId && selectedOptions[idx] === btn.dataset.optionValue) {
        optionValueIds.push(btn.dataset.optionValueId);
      }
    });
    var sectionUrl = window.location.pathname + '?variant=' + match.id +
      (optionValueIds.length > 0 ? '&option_values=' + optionValueIds.join(',') : '') +
      '&section_id=' + sectionId;
    fetch(sectionUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        // Sync color swatch soldout states
        tmp.querySelectorAll('.product-info__color-swatch').forEach(function (freshBtn) {
          var val = freshBtn.dataset.optionValue;
          var liveBtn = section.querySelector('.product-info__color-swatch[data-option-value="' + val + '"]');
          if (liveBtn) {
            liveBtn.classList.toggle('product-info__color-swatch--soldout',
              freshBtn.classList.contains('product-info__color-swatch--soldout'));
          }
        });

        // Sync size button soldout states
        tmp.querySelectorAll('.product-info__size-btn').forEach(function (freshBtn) {
          var idx = freshBtn.dataset.optionIndex;
          var val = freshBtn.dataset.optionValue;
          var liveBtn = section.querySelector('.product-info__size-btn[data-option-index="' + idx + '"][data-option-value="' + val + '"]');
          if (liveBtn) {
            var isSoldout = freshBtn.classList.contains('product-info__size-btn--soldout');
            liveBtn.classList.toggle('product-info__size-btn--soldout', isSoldout);
            var strike = liveBtn.querySelector('.product-info__size-strikethrough');
            if (isSoldout && !strike) {
              strike = document.createElement('span');
              strike.className = 'product-info__size-strikethrough';
              strike.setAttribute('aria-hidden', 'true');
              liveBtn.appendChild(strike);
            } else if (!isSoldout && strike) {
              strike.remove();
            }
          }
        });
      })
      .catch(function () {});
  }

  // Reflect the current `selectedOptions` in the option UI: active button/swatch
  // states and the value text next to each option label. Pure DOM sync — safe to
  // call with an incomplete selection (a required option still unset).
  // Bundle Sale: rebuild the gallery from the selected Pack's image list (custom.pack_gallery,
  // emitted as [data-pack-gallery-map]) when the Pack changes. The initial gallery is already
  // server-rendered for the default Pack, so we seed lastGalleryPack to skip a redundant rebuild.
  var packGalleryMap = null;
  try {
    var _pgEl = section.querySelector('[data-pack-gallery-map]');
    if (_pgEl) packGalleryMap = JSON.parse(_pgEl.textContent);
  } catch (e) { packGalleryMap = null; }
  var lastGalleryPack = null;
  (function () {
    var pe = section.querySelector('[data-option-type="pack"]');
    if (pe) lastGalleryPack = selectedOptions[parseInt(pe.dataset.optionIndex)];
  })();
  function rebuildBundleGallery() {
    if (!packGalleryMap) return;
    var pe = section.querySelector('[data-option-type="pack"]');
    if (!pe) return;
    var pack = selectedOptions[parseInt(pe.dataset.optionIndex)];
    if (!pack || pack === lastGalleryPack) return;
    var imgs = packGalleryMap[pack];
    if (!imgs || !imgs.length) return;
    var gallery = section.querySelector('[data-product-gallery]');
    if (!gallery) return;
    lastGalleryPack = pack;
    // Mirror snippets/product-gallery-image: same <picture> structure, srcsets,
    // sizes, crop, quality split (mobile q65 / desktop q70) and index-derived
    // priority, so a Pack swap doesn't silently downgrade to one fixed
    // full-quality 840w file per image. `imgs` entries are
    // {src, srcset, srcsetMobile} — see [data-pack-gallery-map].
    var GALLERY_SIZES = '(max-width: 768px) 92vw, (max-width: 999px) calc((100vw - 128px) / 2), calc((100vw - 120px) / 3)';
    var GALLERY_SIZES_MOBILE = '92vw';
    var GALLERY_MEDIA_MOBILE = '(max-width: 768px)';
    // Detach the server-rendered badge overlay (Best Seller / Save X% / tag badges)
    // before the innerHTML wipe below, then re-attach it to the new first item.
    // It must be MOVED, not rebuilt: the labels are translated Liquid output that
    // JS has no access to, and [data-retail-savings-pct] inside it is the node the
    // variant-change handler keeps in sync — recreating it would both hardcode
    // English and orphan that reference. Setting innerHTML only detaches children;
    // this reference keeps the node alive.
    var galleryTags = gallery.querySelector('.product-gallery__tags');
    gallery.innerHTML = imgs.map(function (im, i) {
      var loading = i < 2 ? 'eager' : 'lazy';
      var priority = i === 0 ? 'high' : (i === 1 ? 'low' : 'auto');
      return '<div class="product-gallery__item"><picture>' +
        '<source media="' + GALLERY_MEDIA_MOBILE + '" srcset="' + (im.srcsetMobile || im.srcset) + '"' +
        ' sizes="' + GALLERY_SIZES_MOBILE + '">' +
        '<img class="product-gallery__image"' +
        ' src="' + im.src + '"' +
        ' srcset="' + im.srcset + '"' +
        ' sizes="' + GALLERY_SIZES + '"' +
        ' width="750" height="1000"' +
        ' loading="' + loading + '" fetchpriority="' + priority + '" alt="">' +
        '</picture></div>';
    }).join('');
    if (galleryTags) {
      var firstItem = gallery.querySelector('.product-gallery__item');
      if (firstItem) firstItem.appendChild(galleryTags);
    }
    // The swapped-in images are usually uncached, so the strip would otherwise sit
    // blank at full opacity. Fade it until the first image lands (or we give up).
    var firstImg = gallery.querySelector('img');
    if (!firstImg || firstImg.complete) return;
    gallery.classList.add('product-gallery--loading');
    var clearGalleryLoading = function () { gallery.classList.remove('product-gallery--loading'); };
    firstImg.addEventListener('load', clearGalleryLoading, { once: true });
    firstImg.addEventListener('error', clearGalleryLoading, { once: true });
    setTimeout(clearGalleryLoading, 3000);
  }

  function syncOptionUI() {
    // Active states for option buttons
    section.querySelectorAll('[data-option-value]').forEach(function (btn) {
      var optIndex = parseInt(btn.dataset.optionIndex);
      var isActive = selectedOptions[optIndex] === btn.dataset.optionValue;
      if (btn.classList.contains('product-info__color-swatch')) {
        btn.classList.toggle('product-info__color-swatch--active', isActive);
      }
      if (btn.classList.contains('product-info__size-btn')) {
        btn.classList.toggle('product-info__size-btn--active', isActive);
      }
      if (btn.classList.contains('bundle-pack__card')) {
        btn.classList.toggle('bundle-pack__card--active', isActive);
      }
    });

    // Bundle Pack value display (the combo name next to the "Pack" label)
    var packContainer = section.querySelector('[data-option-type="pack"]');
    if (packContainer) {
      var packIdx = parseInt(packContainer.dataset.optionIndex);
      var packValueEl = packContainer.querySelector('[data-pack-value]');
      if (packValueEl && selectedOptions[packIdx]) packValueEl.textContent = selectedOptions[packIdx];
    }

    // Color value display
    var colorContainer = section.querySelector('[data-option-type="color"]');
    if (colorContainer) {
      var colorIdx = parseInt(colorContainer.dataset.optionIndex);
      var colorGroups = colorContainer.querySelectorAll('[data-color-group]');
      if (colorGroups.length > 0) {
        var selectedColor = selectedOptions[colorIdx] || '';
        var activeBtn = colorContainer.querySelector('.product-info__color-swatch--active');
        var activeGroup = activeBtn ? activeBtn.dataset.colorGroup : '';
        colorContainer.querySelectorAll('.product-info__color-group').forEach(function (grp) {
          var grpName = grp.dataset.colorGroup;
          var valEl = grp.querySelector('[data-color-value]');
          if (grpName === activeGroup) {
            if (valEl) {
              valEl.textContent = selectedColor;
            } else {
              var label = grp.querySelector('.product-info__option-label');
              if (label) {
                valEl = document.createElement('span');
                valEl.className = 'product-info__option-value';
                valEl.setAttribute('data-color-value', grpName);
                valEl.textContent = selectedColor;
                label.appendChild(valEl);
              }
            }
          } else {
            if (valEl) valEl.remove();
          }
        });
      } else {
        var colorValueEl = colorContainer.querySelector('[data-color-value]');
        if (colorValueEl) colorValueEl.textContent = selectedOptions[colorIdx] || '';
      }
    }

    // Non-color option value display. When unselected, fall back to the
    // "Choose a …" placeholder — unless an error is currently showing, which
    // owns the label text until the shopper makes a pick.
    section.querySelectorAll('[data-option-type="size"]').forEach(function (container) {
      var optIdx = parseInt(container.dataset.optionIndex);
      var valueEl = container.querySelector('[data-size-value]');
      if (!valueEl) return;
      var sel = selectedOptions[optIdx];
      if (sel) {
        valueEl.textContent = sel;
      } else if (!container.classList.contains('product-info__sizes--error')) {
        valueEl.textContent = valueEl.dataset.placeholder || '';
      }
    });

    // Bundle Sale: reflect the selected Pack in the gallery (no-op unless Pack changed).
    rebuildBundleGallery();
  }

  var moneyFormatter = null;
  if (window.Shopify && window.Shopify.currency) {
    try {
      moneyFormatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify.currency.active,
        currencyDisplay: 'narrowSymbol'
      });
    } catch (e) {}
  }

  function formatMoney(cents) {
    /* Shared formatter first (snippets/money-format). It derives its format from a
       Liquid-rendered sample, so JS-written prices match the server-rendered ones
       byte for byte AND carry the ambiguous-currency ISO suffix.

       The local Intl path below is a degradation route only. It is knowingly
       wrong in two ways, which is exactly what it used to produce on the live
       PDP: `narrowSymbol` drops the ISO code (so a Singapore shopper saw
       "$43.62" where the server had rendered "$43.62 SGD"), and Intl formats by
       BROWSER locale, not by the shop's money format. Because this function
       overwrites [data-retail-price], [data-pricing-our-price] and
       [data-pricing-retail-price] on load, it silently undid the Liquid output. */
    if (window.BonvaleMoney) return window.BonvaleMoney.format(cents);
    var amount = cents / 100;
    if (moneyFormatter) return moneyFormatter.format(amount);
    return '$' + amount.toFixed(2);
  }

  // --- Transparent pricing bar chart ---
  // `costNum` (from custom.transparent_pricing.total) is always stored in shop base
  // currency (GBP on live), so multiply by Shopify.currency.rate in every market to
  // keep the cost-overlay proportion correct.
  // `rtlCentsChart` (from custom.compare_data competitor.price) is per-country: in
  // native au/uk/nz markets it's already in the customer's active currency, but in
  // fallback mode it's the UK GBP value and also needs the rate applied.
  function updatePricingChart(matchPriceCents) {
    var pricingOur = document.querySelector('[data-pricing-our]');
    var pricingRetail = document.querySelector('[data-pricing-retail]');
    if (!pricingOur || !pricingRetail) return;

    var rate = 1;
    if (window.Shopify && window.Shopify.currency) {
      rate = parseFloat(window.Shopify.currency.rate) || 1;
    }
    var isFallback = pricingRetail.dataset.pricingFallback === 'true';
    // Bundle packs: this section is server-rendered from the SINGLE product's
    // metafields (bundles carry no compare_data / transparent_pricing), so the
    // retail reference and make-cost are PER-UNIT while matchPriceCents is the
    // whole pack. Scale both by the pack quantity so the bars compare like with
    // like (3 tees vs 3 tees), not pack price vs one competitor tee.
    var packQty = parseInt(section.getAttribute('data-bundle-qty') || '1') || 1;
    var rtlCentsChart = parseInt(pricingRetail.dataset.pricingRetailCents || '0');
    var maxPrice = (rtlCentsChart / 100) * (isFallback ? rate : 1) * packQty;
    // transparent_pricing values are always in shop base currency (GBP on prod), so always
    // convert by rate — regardless of which country branch they came from. Compare to
    // compare_data competitor prices above, which are per-country native currency.
    var costNum = parseFloat(pricingRetail.dataset.pricingCostNum || '0') * rate * packQty;
    var ourPrice = matchPriceCents / 100;
    var maxBarHeight = 280;

    if (maxPrice <= 0) return;

    var ourBarH = Math.round(ourPrice * maxBarHeight / maxPrice);
    var costH = Math.round(costNum * maxBarHeight / maxPrice);

    var ourPriceEl = pricingOur.querySelector('[data-pricing-our-price]');
    if (ourPriceEl) ourPriceEl.textContent = formatMoney(matchPriceCents);

    var ourBar = pricingOur.querySelector('[data-pricing-our-bar]');
    if (ourBar) ourBar.style.height = ourBarH + 'px';

    var ourMarkup = pricingOur.querySelector('[data-pricing-our-markup]');
    if (ourMarkup) ourMarkup.style.height = Math.max(0, ourBarH - costH) + 'px';

    var ourCost = pricingOur.querySelector('[data-pricing-our-cost]');
    if (ourCost) ourCost.style.height = costH + 'px';

    // Retail bar always represents the maximum (full maxBarHeight). Always re-set
    // its cost/markup heights from costH so both bars share the same value — Liquid's
    // server-rendered retail_cost_height can be off when transparent_pricing falls back
    // to UK GBP while compare_data has native country data (cross-fallback), since the
    // server computes ratios with mixed units.
    var retailBar = pricingRetail.querySelector('[data-pricing-retail-bar]');
    if (retailBar) retailBar.style.height = maxBarHeight + 'px';

    var retailMarkup = pricingRetail.querySelector('[data-pricing-retail-markup]');
    if (retailMarkup) retailMarkup.style.height = Math.max(0, maxBarHeight - costH) + 'px';

    var retailCost = pricingRetail.querySelector('[data-pricing-retail-cost]');
    if (retailCost) retailCost.style.height = costH + 'px';

    // Update the displayed retail price text — Liquid's `| money` filter does NOT
    // auto-convert arbitrary integers through Markets (fallback mode renders e.g.
    // "$80.00" for a £80 input), and the server-rendered figure is always the
    // per-unit value, so a pack selection needs the ×qty rewrite — and switching
    // back to Singles needs the ×1 rewrite to restore it.
    var retailPriceEl = pricingRetail.querySelector('[data-pricing-retail-price]');
    if (retailPriceEl) retailPriceEl.textContent = formatMoney(Math.round(maxPrice * 100));

    // Cost breakdown table: same per-unit source (data-usd holds the shop-base
    // major-unit figure; currency-convert already wrote ×rate on load). Re-render
    // ×rate×qty so the rows and the "What it costs to make" total track the pack.
    document.querySelectorAll('.pricing__value[data-usd]').forEach(function (el) {
      var base = parseFloat(el.dataset.usd);
      if (!isNaN(base)) el.textContent = formatMoney(Math.round(base * rate * packQty * 100));
    });
  }

  if (currentVariant) {
    updatePricingChart(currentVariant.price);
    // Server-rendered "You save X%" can be wrong when shop base ≠ active currency
    // (Liquid mixes per-country variant.price with shop-base retail_price_cents).
    // Recompute against the normalized retail value to fix the initial paint.
    var initDealOriginal = parseInt(section.getAttribute('data-bundle-original') || '0') || 0;
    var initCompareBase = initDealOriginal > 0 ? initDealOriginal : currentVariant.compare_at_price;
    var initHasSale = !!(initCompareBase && initCompareBase > currentVariant.price);
    refreshRetailSavings(currentVariant.price, initHasSale);
  }

  // --- Retail price text fallback (UK data for unconfigured markets) ---
  // Liquid's `| money` filter does NOT auto-convert arbitrary integers through Markets,
  // so the server renders the UK GBP value as "$XX" in fallback mode. Re-format using
  // the normalized active-currency cents computed above.
  if (retailFallbackFlag && window.Shopify && window.Shopify.currency) {
    var retailFmt = null;
    try {
      retailFmt = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify.currency.active,
        currencyDisplay: 'narrowSymbol'
      });
    } catch (e) {}
    /* The `> currentVariant.price` guard matches refreshRetailSavings's own early return:
       without it a converted retail below the asking price would reveal an EMPTY
       percentage, trading the wrong number for a broken-looking one. */
    if ((window.BonvaleMoney || retailFmt) && retailPriceCentsActive > 0 && retailPriceCentsActive > currentVariant.price) {
      section.querySelectorAll('[data-retail-price]').forEach(function (el) {
        /* This is the line that used to strip the ISO code off the PDP's
           "Traditional retail" figure: Liquid rendered "$43.62 SGD", this
           overwrote it with Intl's narrowSymbol "$43.62". */
        el.textContent = window.BonvaleMoney
          ? window.BonvaleMoney.format(retailPriceCentsActive)
          : retailFmt.format(retailPriceCentsActive / 100);
      });
      /* BUG-BV-51: both the price and the percentage now hold converted values
         (refreshRetailSavings ran just above), so reveal the slots Liquid left blank.
         Gated on the same success conditions as the rewrite itself — if we could not
         produce a figure, the reference stays hidden rather than showing an empty
         strikethrough or a base-currency number. */
      section.querySelectorAll('.product-info__retail--deferred').forEach(function (el) {
        el.classList.remove('product-info__retail--deferred');
      });
      var deferredSticky = section.querySelector('[data-sticky-cta-savings]');
      if (deferredSticky && retailPriceCentsActive > currentVariant.price) {
        deferredSticky.hidden = !currentVariant.available;
      }
    }
  }

  // --- Compare table fallback (UK data for unconfigured markets) ---
  // The competitor base price in `data-compare-base-price` is in the shop's primary
  // currency (GBP on live). Convert it via Shopify.currency.rate, then do "X% more" /
  // saving % math against the variant price — which Shopify Markets already presents
  // in the customer's active currency.
  var compareFallbackTable = section.querySelector('[data-compare-fallback="true"]');
  var compareFallbackRate = 1;
  var compareFallbackFormatter = null;
  var compareFallbackMoreTmpl = '';
  if (compareFallbackTable && window.Shopify && window.Shopify.currency) {
    compareFallbackRate = parseFloat(window.Shopify.currency.rate) || 1;
    compareFallbackMoreTmpl = compareFallbackTable.dataset.compareMoreTmpl || '__PCT__% more';
    try {
      compareFallbackFormatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify.currency.active,
        currencyDisplay: 'narrowSymbol'
      });
    } catch (e) {}
  }

  // Pack tables compare per item: pack price ÷ data-compare-pieces (1 on a single).
  function compareOwnPriceCents(priceCents) {
    var tbl = section.querySelector('.product-info__compare-table');
    var pieces = tbl ? (parseInt(tbl.getAttribute('data-compare-pieces') || '1', 10) || 1) : 1;
    return pieces > 1 ? Math.floor(priceCents / pieces) : priceCents;
  }

  function compareFallbackMoney(amountMajor) {
    if (window.BonvaleMoney) return window.BonvaleMoney.format(Math.round(amountMajor * 100));
    return compareFallbackFormatter.format(amountMajor);
  }

  function applyCompareFallback(matchPriceCents) {
    if (!compareFallbackTable) return;
    if (!window.BonvaleMoney && !compareFallbackFormatter) return;
    var bonvaleActive = matchPriceCents / 100;

    compareFallbackTable.querySelectorAll('[data-compare-comp-cell]').forEach(function (cell) {
      var basePrice = parseFloat(cell.dataset.compareBasePrice);
      if (isNaN(basePrice)) return;
      var compActive = basePrice * compareFallbackRate;

      var priceSpan = cell.querySelector('[data-compare-comp-price]');
      if (priceSpan) priceSpan.textContent = compareFallbackMoney(compActive);

      var moreSpan = cell.querySelector('[data-compare-comp-more]');
      if (moreSpan) {
        if (bonvaleActive > 0 && compActive > bonvaleActive) {
          var pct = Math.round((compActive - bonvaleActive) / bonvaleActive * 100);
          moreSpan.textContent = compareFallbackMoreTmpl.replace('__PCT__', pct);
          moreSpan.hidden = false;
        } else {
          moreSpan.textContent = '';
          moreSpan.hidden = true;
        }
      }
    });

    compareFallbackTable.querySelectorAll('[data-compare-comp-saving]').forEach(function (cell) {
      var basePrice = parseFloat(cell.dataset.compareBasePrice);
      if (isNaN(basePrice)) return;
      var compActive = basePrice * compareFallbackRate;
      if (bonvaleActive > 0 && compActive > bonvaleActive) {
        var saving = Math.round((compActive - bonvaleActive) / compActive * 100);
        cell.textContent = saving + '%';
      } else {
        cell.textContent = '—';
      }
    });
  }

  if (currentVariant) applyCompareFallback(compareOwnPriceCents(currentVariant.price));

  // --- Mobile sticky CTA ---
  // Shows a fixed action bar at the bottom of the viewport when the
  // Color/Size/CTA area scrolls out of view. Tap scrolls back to the pickers.
  var stickyCta = section.querySelector('[data-sticky-cta]');
  var productForm = section.querySelector('[data-product-form]');

  // Add-to-bag validation: block the submit when a required option (e.g. Size)
  // hasn't been picked, and flag each unselected option in red. Runs on the
  // button click — preventDefault here stops the form submit before the global
  // cart-drawer submit handler (snippets/cart-drawer.liquid) can fire.
  var addToCartBtn = section.querySelector('[data-add-to-cart]');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      var missing = requiredIndexes.filter(function (i) { return !selectedOptions[i]; });
      if (missing.length === 0) return;
      e.preventDefault();
      e.stopPropagation();
      var firstContainer = null;
      missing.forEach(function (i) {
        var c = section.querySelector('[data-option-type="size"][data-option-index="' + i + '"]');
        if (!c) return;
        c.classList.add('product-info__sizes--error');
        var valEl = c.querySelector('[data-size-value]');
        if (valEl && valEl.dataset.error) valEl.textContent = valEl.dataset.error;
        if (!firstContainer) firstContainer = c;
      });
      if (firstContainer) firstContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  if (stickyCta && productForm && 'IntersectionObserver' in window) {
    if (stickyObserver) stickyObserver.disconnect();
    stickyObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      // Show when the form is fully out of view AND we've scrolled past it
      // (i.e. the form sits above the viewport, not below).
      var pastForm = entry.boundingClientRect.bottom < 0;
      var visible = !entry.isIntersecting && pastForm;
      stickyCta.classList.toggle('product-info__sticky-cta--visible', visible);
      stickyCta.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('has-product-sticky-cta', visible);
    }, { threshold: 0 });
    stickyObserver.observe(productForm);
  }

  var stickyBtn = stickyCta ? stickyCta.querySelector('[data-sticky-cta-btn]') : null;
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var target = section.querySelector('[data-option-type="color"]')
        || section.querySelector('[data-option-type="size"]')
        || productForm;
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function updateStickyCta(match, retailPriceCents, hasDiscount) {
    if (!stickyCta) return;
    var labelEl = stickyCta.querySelector('[data-sticky-cta-label]');
    var priceEl = stickyCta.querySelector('[data-sticky-cta-price]');
    var sepEl = stickyCta.querySelector('.product-info__sticky-cta-sep');
    var savingsEl = stickyCta.querySelector('[data-sticky-cta-savings]');
    var savingsPctEl = stickyCta.querySelector('[data-sticky-cta-savings-pct]');

    if (match.available) {
      if (labelEl) labelEl.textContent = (productForm && productForm.querySelector('[data-add-to-cart]') && productForm.querySelector('[data-add-to-cart]').dataset.addText) || stickyCta.dataset.labelAdd || 'Add To Bag';
      if (priceEl) {
        priceEl.textContent = formatMoney(match.price);
        priceEl.hidden = false;
      }
      if (sepEl) sepEl.hidden = false;
    } else {
      if (labelEl) labelEl.textContent = stickyCta.dataset.labelNotify || 'Notify Me';
      if (priceEl) priceEl.hidden = true;
      if (sepEl) sepEl.hidden = true;
    }

    if (savingsEl && savingsPctEl) {
      var pct = 0;
      if (hasDiscount) {
        pct = Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100);
      } else if (retailPriceCents > 0 && retailPriceCents > match.price) {
        pct = Math.round((retailPriceCents - match.price) / retailPriceCents * 100);
      }
      if (pct > 0 && match.available) {
        savingsPctEl.textContent = pct;
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }
  }

  // --- Shipping address toggle ---
  var shippingToggle = section.querySelector('[data-shipping-toggle]');
  var shippingList = section.querySelector('[data-shipping-list]');
  if (shippingToggle && shippingList) {
    shippingToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      shippingList.classList.toggle('product-info__shipping-list--open');
    });
    // Outside-click close is bound once at the top level (see below) so it isn't
    // duplicated each time a bundle swap re-runs initProductSection.
    shippingList.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-addr]');
      if (!opt) return;
      var addrEl = section.querySelector('[data-shipping-addr]');
      if (addrEl) addrEl.textContent = opt.dataset.addr;
      shippingList.querySelectorAll('.product-info__shipping-option').forEach(function (o) {
        o.classList.remove('product-info__shipping-option--active');
      });
      opt.classList.add('product-info__shipping-option--active');
      shippingList.classList.remove('product-info__shipping-list--open');
    });
  }

  // --- Notify Me flow ---
  var notifyBtnEl = section.querySelector('[data-notify-btn]');
  var notifyFormEl = section.querySelector('[data-notify-form]');
  var notifyEmailEl = section.querySelector('[data-notify-email]');
  var notifySubmitEl = section.querySelector('[data-notify-submit]');
  var notifyConfirmEl = section.querySelector('[data-notify-confirm]');
  var notifyErrorEl = section.querySelector('[data-notify-error]');

  var klaviyoKey = notifyBtnEl ? notifyBtnEl.dataset.klaviyoKey || '' : '';
  var klaviyoRevision = notifyBtnEl ? notifyBtnEl.dataset.klaviyoRevision || '2026-01-15' : '2026-01-15';

  async function submitNotify() {
    var email = notifyEmailEl.value.trim();
    if (!email || !notifyEmailEl.checkValidity()) return;

    var variantId = section.querySelector('input[data-variant-id]').value;
    if (notifyErrorEl) notifyErrorEl.hidden = true;
    if (notifySubmitEl) {
      notifySubmitEl.disabled = true;
      notifySubmitEl.setAttribute('aria-busy', 'true');
    }

    /* Subscribe to Klaviyo back-in-stock ONLY. This fires the "Subscribed to Back
       in Stock" event which triggers the restock alert flow. We intentionally do NOT
       add the profile to any marketing list or set email marketing consent here —
       a back-in-stock request is not a newsletter opt-in. */
    try {
      if (!klaviyoKey) throw new Error('Missing Klaviyo public key');
      var response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + klaviyoKey, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': klaviyoRevision
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + variantId
                }
              }
            }
          }
        })
      });
      if (!response.ok) throw new Error('Klaviyo BIS subscription failed');

      /* Identify the browser to Klaviyo onsite JS so this visitor becomes an
         "identifiable browser" — the raw client API above creates the profile
         server-side but does NOT cookie the browser, which Viewed Product /
         Active on Site (and Browse Abandonment) require.
         country_code = current market; the BIS subscription payload can't carry
         profile properties, so this identify is what lets currency-less flows
         (BIS Alert etc.) resolve the shopper's market. Read from data-country-code
         (Liquid doesn't render inside the javascript tag). */
      try {
        var bisCountry = notifyBtnEl ? notifyBtnEl.dataset.countryCode : '';
        var bisIdentity = { email: email };
        if (bisCountry) bisIdentity.country_code = bisCountry;
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify(bisIdentity);
        } else if (window._learnq) {
          window._learnq.push(['identify', Object.assign({ '$email': email }, bisCountry ? { country_code: bisCountry } : {})]);
        }
      } catch (e) {}

      notifyBtnEl.style.display = 'none';
      if (notifyFormEl) notifyFormEl.style.display = 'none';
      if (notifyConfirmEl) notifyConfirmEl.style.display = '';

      /* Auto-add to wishlist if not already wishlisted */
      if (window.Wishlist && window._swat && !window.Wishlist.isWishlisted(product.id)) {
        var wishlistVariantId = parseInt(section.querySelector('input[data-variant-id]').value);
        var wishlistProduct = {
          epi: wishlistVariantId,
          empi: product.id,
          du: window.location.origin + product.url,
          dt: product.title,
          pr: product.price / 100,
          iu: product.featured_image || ''
        };
        var lid = window.Wishlist.debug().defaultListId;
        if (lid) {
          window._swat.addToList(lid, wishlistProduct, function() {
            window.Wishlist.updateAll();
          });
        }
      }
    } catch (error) {
      if (notifyConfirmEl) notifyConfirmEl.style.display = 'none';
      if (notifyFormEl) notifyFormEl.style.display = '';
      if (notifyErrorEl) notifyErrorEl.hidden = false;
    } finally {
      if (notifySubmitEl) {
        notifySubmitEl.disabled = false;
        notifySubmitEl.removeAttribute('aria-busy');
      }
    }
  }

  if (notifyBtnEl) {
    notifyBtnEl.addEventListener('click', function () {
      var oosSku = document.querySelector('[data-oos-sku]');
      var oosSpu = document.querySelector('[data-oos-spu]');
      if (oosSku) oosSku.style.display = 'none';
      if (oosSpu) oosSpu.style.display = 'none';

      // Logged-in user with pre-filled email — skip form, submit directly
      if (notifyEmailEl && notifyEmailEl.value.trim() && notifyEmailEl.checkValidity()) {
        submitNotify();
        return;
      }

      notifyBtnEl.style.display = 'none';
      if (notifyFormEl) notifyFormEl.style.display = '';
      if (notifyEmailEl) notifyEmailEl.focus();
    });
  }

  if (notifySubmitEl) {
    notifySubmitEl.addEventListener('click', submitNotify);
  }
  if (notifyEmailEl) {
    notifyEmailEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitNotify(); }
    });
  }
  } // ===== end initProductSection =====

  // ---------- Bundle Sale helpers (take the section as an argument) ----------

  // Fill each Pack card's thumbnail from the product JSON: a Pack value's image =
  // the featured_image of the first variant carrying that Pack value. Done in JS
  // to avoid Liquid's 50-iteration variant-loop cap.
  function fillPackThumbnails(section, product) {
    var packEl = section.querySelector('.bundle-pack');
    if (!packEl || !product || !product.variants) return;
    var packIndex = parseInt(packEl.dataset.optionIndex);
    section.querySelectorAll('.bundle-pack__card[data-option-value]').forEach(function (card) {
      var holder = card.querySelector('[data-pack-img]');
      if (!holder || holder.querySelector('img')) return;
      var packName = card.dataset.optionValue;
      var variant = product.variants.find(function (v) {
        return v.options[packIndex] === packName && v.featured_image;
      });
      var src = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image || '';
      if (!src) return;
      var img = document.createElement('img');
      img.src = src.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_200x$1$2');
      img.alt = packName;
      img.loading = 'lazy';
      holder.appendChild(img);
    });
  }

  // "+" card expands the collapsed pack grid to reveal overflow combos.
  function bindPackToggle(section) {
    var toggle = section.querySelector('[data-bundle-pack-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var pgrid = section.querySelector('[data-bundle-pack-grid]');
      if (!pgrid) return;
      pgrid.classList.add('bundle-pack__grid--expanded');
      toggle.setAttribute('aria-expanded', 'true');
    });
  }

  // PRD §11 analytics for pack/size selection (bundle PDPs only).
  function bindBundleOptionAnalytics(section) {
    if (!section.querySelector('[data-bundle-quantity]')) return;
    section.querySelectorAll('[data-option-type="pack"] [data-option-value], [data-option-type="size"] [data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!window.BonvaleAnalytics) return;
        var typeEl = this.closest('[data-option-type]');
        var type = typeEl ? typeEl.dataset.optionType : '';
        window.BonvaleAnalytics.track('section_clicked', {
          section_name: type === 'pack' ? 'bundle_pack_picker' : 'bundle_size_picker',
          option_value: this.dataset.optionValue
        });
      });
    });
  }

  // PRD §11 page-view style event carrying quantity_type (single|bundle).
  // NOTE: confirm the final event name against PRD §11 (placeholder below).
  function fireBundleView(section) {
    if (!window.BonvaleAnalytics) return;
    if (!section.querySelector('[data-bundle-quantity]')) return;
    window.BonvaleAnalytics.track('product_quantity_view', {
      quantity_type: section.getAttribute('data-bundle-state') || 'single'
    });
  }

  // Scope to the REAL Size option only (data-option-required). Combined-listing
  // options (e.g. Style/Fit on the Single) are also rendered as
  // [data-option-type="size"] but are ALWAYS pre-selected (not required) and come
  // first in the DOM — without this scope, querySelector grabs their active value
  // (e.g. "Drawstring") instead of the chosen size, so swapping to a pack that has
  // no such option (e.g. Single → 2-Pack) couldn't match it and dropped the size.
  function readSelectedSize(root) {
    var active = root.querySelector('[data-option-type="size"][data-option-required="true"] .product-info__size-btn--active');
    return active ? active.dataset.optionValue : null;
  }

  function applyPreservedSize(root, name) {
    if (!name) return;
    var safe = (window.CSS && CSS.escape) ? CSS.escape(name) : name.replace(/"/g, '\\"');
    var btn = root.querySelector('[data-option-type="size"][data-option-required="true"] .product-info__size-btn[data-option-value="' + safe + '"]');
    // Click even when sold out (PRD §9: preserve the chosen size across a quantity
    // switch). Sold-out sizes are deliberately selectable everywhere else — they flip
    // the CTA to "Notify me" — so the old soldout guard here silently dropped the size
    // on a 0-stock target pack (e.g. all of prod), breaking preservation.
    if (btn) btn.click();
  }

  // Quantity switch = swap to a SEPARATE product. Fetch its rendered section via
  // the Section Rendering API using the file name `product` (NOT the page's
  // dynamic instance id, which only resolves on the originating page), replace the
  // section DOM in place, re-init, preserve the chosen size, and pushState so the
  // URL stays shareable. Falls back to full navigation on any failure.
  // Product path that keeps a /collections/<handle>/ prefix from the current URL
  // (JS twin of the Liquid `pdp_url_prefix`), so the collection context — and the
  // breadcrumb built from it — survives the in-page pack switch, its full-navigation
  // fallbacks and the section fetch (whose swatches are rendered with `collection`).
  function productPath(handle) {
    var m = location.pathname.match(/^(.*\/collections\/[^\/]+)\/products\//);
    var base = m ? m[1] + '/products/' : (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/';
    return base + handle;
  }

  function swapToHandle(handle, opts) {
    opts = opts || {};
    var current = document.querySelector('[id^="product-main-"]');
    if (!current) { window.location.href = productPath(handle); return; }
    // Pack-only family (BXR3-08): no path — popstate on the single's URL, the no-JS
    // fallback href, a stale caller — may land on a single's buy box. Every entry
    // point funnels through here, so redirect the target to the default pack once.
    if (current.getAttribute('data-bundle-singles-hidden') === 'true') {
      var singleHandles = (current.getAttribute('data-bundle-single-handles') || '').split(',');
      var defaultHandle = current.getAttribute('data-bundle-default-handle');
      if (defaultHandle && singleHandles.indexOf(handle) !== -1) handle = defaultHandle;
    }
    // Covers the entry points that don't come from a pill tap (popstate, the
    // ?bundle= landing) — beginSwitching is idempotent.
    beginSwitching(null);
    var keepSize = readSelectedSize(current);
    var sectionId = current.id.replace('product-main-', '');
    // Quantity switch keeps the SINGLE's gallery-context decisions per design: the
    // gallery + buy box (price/options/CTA) swap to the target product, but the
    // accordions (Details / material / size & fit / care) are PRESERVED from the
    // current product because bundle products don't carry that content. Reviews,
    // "wear it with", "more to explore" are separate sections and never swap.
    var curInfo = current.querySelector('.product-info-content');
    var curGallery = current.querySelector('.product-gallery');
    var keepAccordions = curInfo ? curInfo.querySelector('.product-info__accordions') : null;
    var swapUrl = productPath(handle) + '?section_id=product';
    // Pack-only family landing pack: the colour single resolved which Pack variant
    // its shopper should get (data-bundle-landing-variant). Ask the Section
    // Rendering API for that variant so the pack arrives already on it — same
    // ?variant= contract the size buttons use. Empty on every other family.
    if (handle === current.getAttribute('data-bundle-default-handle')) {
      var landingVariant = current.getAttribute('data-bundle-landing-variant');
      if (landingVariant) swapUrl += '&variant=' + encodeURIComponent(landingVariant);
    }
    fetch(swapUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[id^="product-main-"]');
        var freshInfo = fresh ? fresh.querySelector('.product-info-content') : null;
        var freshGallery = fresh ? fresh.querySelector('.product-gallery') : null;
        var freshJson = tmp.querySelector('[id^="product-json-"]');
        if (!fresh || !freshInfo || !freshJson) { window.location.href = productPath(handle); return; }
        // Graft the single's accordions into the fresh (bundle) info-content so the
        // Details/description stays the single's. <details> are native (no JS), so
        // moving the nodes and re-initing does not double-bind.
        if (keepAccordions) {
          var freshAcc = freshInfo.querySelector('.product-info__accordions');
          if (freshAcc) {
            freshAcc.replaceWith(keepAccordions);
          } else {
            var freshSticky = freshInfo.querySelector('[data-sticky-cta]');
            if (freshSticky) { freshSticky.parentNode.insertBefore(keepAccordions, freshSticky); }
            else { freshInfo.appendChild(keepAccordions); }
          }
        }
        // The product JSON script tag lives OUTSIDE [id^="product-main-"]; under the
        // Section Rendering API it is id="product-json-product". We keep the existing
        // section element (id unchanged), so re-id the fresh JSON to match THIS section,
        // otherwise initProductSection bails at `if (!productJson) return`.
        freshJson.id = 'product-json-' + sectionId;
        var curJson = document.getElementById('product-json-' + sectionId);
        if (curJson) { curJson.replaceWith(freshJson); } else { current.parentNode.insertBefore(freshJson, current.nextSibling); }
        // Swap gallery (target product's) + buy box, keep the rest of the section.
        if (curGallery && freshGallery) { curGallery.replaceWith(freshGallery); }
        if (curInfo) { curInfo.replaceWith(freshInfo); }
        current.setAttribute('data-bundle-state', fresh.getAttribute('data-bundle-state') || 'single');
        current.setAttribute('data-bundle-qty', fresh.getAttribute('data-bundle-qty') || '1');
        current.setAttribute('data-bundle-deal', fresh.getAttribute('data-bundle-deal') || 'false');
        current.setAttribute('data-bundle-original', fresh.getAttribute('data-bundle-original') || '0');
        // Pack-only flags ride on every family member; keep the current ones if the
        // fresh section somehow lacks them so the BXR3-08 guard never switches off.
        ['data-bundle-singles-hidden', 'data-bundle-default-handle', 'data-bundle-single-handles', 'data-bundle-landing-variant'].forEach(function (name) {
          current.setAttribute(name, fresh.getAttribute(name) || current.getAttribute(name) || '');
        });
        initProductSection(current);
        // The fragment's inline <script>s did not run (innerHTML), so the star
        // rating under the title is still empty — render it from the global.
        // The reviews section never swaps, so the rating follows IT: a pack's
        // server render points at the pack's source single, which is not always
        // the colour this page was opened on (black tee → 6-Pack → charcoal
        // single), and then "(N Reviews)" would count one product and scroll
        // to nothing. Re-point the fresh rating at the reviews on this page.
        var pageReviews = document.querySelector('.okendo-reviews[id^="okendo-reviews-"]');
        var freshRating = current.querySelector('.okendo-star-rating');
        if (pageReviews && freshRating) {
          var pageReviewsPid = pageReviews.id.replace('okendo-reviews-', '');
          freshRating.id = 'okendo-sr-' + pageReviewsPid;
          freshRating.setAttribute('data-product-id', 'shopify-' + pageReviewsPid);
          freshRating.setAttribute('data-reviews-anchor', pageReviews.id);
        }
        if (window.BonvaleStarRating) window.BonvaleStarRating.init(current);
        applyPreservedSize(current, keepSize);
        if (!opts.skipPush) window.history.pushState({ bvBundleHandle: handle }, '', productPath(handle));
        if (window.BonvaleAnalytics && window.BonvaleAnalytics.refresh) window.BonvaleAnalytics.refresh();
        endSwitching();
      })
      // Both failure paths fall back to a full navigation, so the loading state is
      // deliberately left on — the page is about to be replaced.
      .catch(function () { window.location.href = productPath(handle); });
  }

  // ---------- bootstrap + one-time global bindings ----------
  initProductSection(document.querySelector('[id^="product-main-"]'));

  // QA BUG-BV-112: a colour/style switch on a combined listing is a full navigation
  // to a SEPARATE sibling product, which used to drop the chosen size. The swatch
  // handler now carries it as ?bv_size=<label>; re-apply it here so the sibling
  // pre-selects that size when it exists (parity with the in-page pack switch), then
  // strip the param so it doesn't linger in the shared URL. Clean the param BEFORE
  // clicking the size — the size button sets ?variant= itself, and that must win.
  //
  // MUST run before the ?bundle= landing below: swapToHandle reads the size out of
  // the CURRENT DOM synchronously, so a bundle Fit switch (which arrives with both
  // ?bundle= and ?bv_size=) would otherwise read "nothing selected" and drop the size.
  (function () {
    var params = new URLSearchParams(window.location.search);
    var size = params.get('bv_size');
    if (!size) return;
    params.delete('bv_size');
    var qs = params.toString();
    window.history.replaceState(window.history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    var root = document.querySelector('[id^="product-main-"]');
    if (root) applyPreservedSize(root, size);
  })();

  // Direct-access redirect landing: a bundle URL redirects here (the single PDP) with
  // ?bundle=<handle>. Pre-select that pack by swapping in its buy box, keeping the single's
  // content + URL (skipPush so we stay on the single and avoid a refresh→redirect loop).
  (function () {
    var bp = new URLSearchParams(window.location.search).get('bundle');
    // Pack-only family (BXR3-06/07): a bare single URL lands on the default pack —
    // still skipPush, so a refresh stays on the single and never meets the pack redirect.
    if (!bp) {
      var root = document.querySelector('[id^="product-main-"]');
      if (root && root.getAttribute('data-bundle-singles-hidden') === 'true') bp = root.getAttribute('data-bundle-default-handle') || '';
    }
    if (bp) { swapToHandle(bp, { skipPush: true }); }
  })();

  // Shipping dropdown outside-click close (delegated; live query; bound once so it
  // survives bundle swaps without accumulating).
  document.addEventListener('click', function () {
    var sl = document.querySelector('[data-shipping-list]');
    if (sl) sl.classList.remove('product-info__shipping-list--open');
  });

  // Quantity switcher pills → intercept for in-page swap. The real <a href> stays
  // a no-JS fallback. section-tracking.liquid ignores [data-bundle-switch] so only
  // the explicit bundle_pack_picker event fires here.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-bundle-switch]');
    if (!link) return;
    e.preventDefault();
    if (link.getAttribute('aria-disabled') === 'true') return;
    // A second tap while the swap is in flight would stack fetches and land on
    // whichever resolves last — the frozen buy box makes the wait explicit instead.
    if (isSwitching()) return;
    // Move the selected state onto the tapped pill straight away — that's where the
    // swap lands anyway, and waiting for the fetch is what made the tap feel dead.
    var pills = link.parentNode;
    if (pills) {
      pills.querySelectorAll('.bundle-quantity__btn--active').forEach(function (el) {
        el.classList.remove('bundle-quantity__btn--active');
      });
    }
    link.classList.add('bundle-quantity__btn--active');
    var qtyValue = document.querySelector('[data-bundle-quantity-value]');
    var qtyLabel = link.querySelector('.bundle-quantity__btn-label');
    if (qtyValue && qtyLabel) qtyValue.textContent = qtyLabel.textContent;
    beginSwitching(link);
    if (window.BonvaleAnalytics) {
      window.BonvaleAnalytics.track('section_clicked', {
        section_name: 'bundle_pack_picker',
        target_url: link.getAttribute('href') || '',
        target_type: 'product'
      });
    }
    swapToHandle(link.dataset.bundleHandle);
  });

  // Combined-listing Colour / Style values are <a href> to a sibling product — a real
  // navigation with no in-page hook to hang feedback on. Acknowledge the tap the moment
  // it happens: move the selected state to the tapped control (that's where it will land
  // anyway) and show the spinner + frozen buy box for the rest of the page load.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a.product-info__color-swatch[href], a.product-info__size-btn[href]');
    if (!link) return;
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    if (isSwitching()) return;
    var isSwatch = link.classList.contains('product-info__color-swatch');
    var activeClass = isSwatch ? 'product-info__color-swatch--active' : 'product-info__size-btn--active';
    var group = link.parentNode;
    if (group) {
      group.querySelectorAll('.' + activeClass).forEach(function (el) { el.classList.remove(activeClass); });
    }
    link.classList.add(activeClass);
    // …and the value text next to the option label, so the whole row reads as
    // already switched while the sibling product loads. Grouped colour pickers
    // (Core / Limited) move the value element between group labels — not worth
    // replaying for a state the page load is about to replace, so skip those.
    var container = link.closest('[data-option-type]');
    var valueEls = container ? container.querySelectorAll(isSwatch ? '[data-color-value]' : '[data-size-value]') : [];
    if (valueEls.length === 1) {
      valueEls[0].textContent = link.getAttribute('title') || link.textContent.trim();
    }
    // QA BUG-BV-112: carry the chosen size across the navigation to the sibling
    // colour/style so it isn't lost. Applies to the colour swatch AND to the
    // combined-listing Fit/Style row (also rendered as .product-info__size-btn) —
    // the one link that must NOT carry it is the real Size picker, where the <a>
    // IS the size being chosen. That one is the only [data-option-required] group.
    // This handler does not preventDefault, so mutating link.href here means the
    // browser navigates with the param.
    if (isSwatch || !link.closest('[data-option-required="true"]')) {
      var swapRoot = link.closest('[id^="product-main-"]') || document.querySelector('[id^="product-main-"]');
      var chosenSize = swapRoot ? readSelectedSize(swapRoot) : null;
      if (chosenSize) {
        try {
          var u = new URL(link.getAttribute('href'), window.location.origin);
          u.searchParams.set('bv_size', chosenSize);
          link.setAttribute('href', u.pathname + u.search + u.hash);
        } catch (e) { /* leave href untouched on any parse failure */ }
      }
    }
    beginSwitching(link);
  });

  // bfcache restore (mobile back gesture) replays the DOM as it was when the shopper
  // left — including the loading state — so clear it on every show.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) endSwitching();
  });

  // Browser back/forward between bundle quantity URLs re-swaps in place.
  window.addEventListener('popstate', function () {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (m) swapToHandle(m[1], { skipPush: true });
  });

})();

  /* Mobile breadcrumb reveal — see the .product-breadcrumb mobile CSS. The nav
     sits outside .product-main, so a pack/colour swap (which replaces gallery +
     info only) never touches it. Fires once, when the shopper has scrolled past
     the announcement bar — the moment the header freezes at the top. */
  (function initMobileBreadcrumbReveal() {
    var nav = document.querySelector('.product-breadcrumb');
    if (!nav) return;
    var REVEALED = 'product-breadcrumb--revealed';
    var mq = window.matchMedia('(max-width: 768px)');
    var announcement = document.querySelector('.header-announcement');

    function threshold() {
      return Math.max(10, announcement ? announcement.offsetHeight : 0);
    }

    function reveal() {
      if (nav.classList.contains(REVEALED)) return;
      // The 38px it grows by lands above the viewport's anchor node; without
      // this Chrome/Android's scroll anchoring scrolls the page by the same
      // amount and leaves the breadcrumb tucked under the pinned header.
      var root = document.documentElement;
      var prevAnchor = root.style.overflowAnchor;
      root.style.overflowAnchor = 'none';
      nav.classList.add(REVEALED);
      setTimeout(function() { root.style.overflowAnchor = prevAnchor; }, 400);
      window.removeEventListener('scroll', onScroll);
    }

    function onScroll() {
      // Above 768px the CSS shows it regardless; keep listening in case of a
      // rotation into the phone layout mid-visit.
      if (!mq.matches) return;
      if (window.scrollY >= threshold()) reveal();
    }

    onScroll(); // back/forward restore or a hash landing already past the fold
    if (!nav.classList.contains(REVEALED)) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function () {
  var filterSidebar = document.querySelector('[data-filter-sidebar]');
  var filterBackdrop = document.querySelector('[data-filter-backdrop]');
  var desktopFilterBtns = document.querySelectorAll('.collection__filter-btn');

  function setFilterBtnActive(isActive) {
    desktopFilterBtns.forEach(function (btn) {
      btn.classList.toggle('collection__filter-btn--active', isActive);
    });
  }

  function openSidebar() {
    if (filterSidebar) filterSidebar.style.display = '';
    if (filterBackdrop) filterBackdrop.style.display = '';
    if (window.innerWidth <= 768) {
      document.body.style.overflow = 'hidden';
    }
    setFilterBtnActive(true);
  }

  function closeSidebar() {
    if (filterSidebar) filterSidebar.style.display = 'none';
    if (filterBackdrop) filterBackdrop.style.display = 'none';
    document.body.style.overflow = '';
    setFilterBtnActive(false);
  }

  // Restore desktop sidebar visibility when URL carries active filter params.
  // Liquid stamps data-has-active-filters="1" on the aside; treat that as the
  // signal to auto-open so users don't lose their place after the auto-submit
  // reload that fires when a checkbox is toggled.
  if (filterSidebar && filterSidebar.dataset.hasActiveFilters === '1' && window.innerWidth > 768) {
    openSidebar();
  }

  var filterClose = document.querySelector('[data-filter-close]');
  if (filterClose) {
    filterClose.addEventListener('click', closeSidebar);
  }

  if (filterBackdrop) {
    filterBackdrop.addEventListener('click', closeSidebar);
  }

  var filterToggles = document.querySelectorAll('[data-filter-toggle]');
  filterToggles.forEach(function (filterToggle) {
    if (filterToggle && filterSidebar) {
      filterToggle.addEventListener('click', function () {
        var isOpen = filterSidebar.style.display !== 'none';
        if (isOpen) {
          closeSidebar();
        } else {
          openSidebar();
        }
      });
    }
  });

  // Mobile filter group buttons: open sidebar with only the tapped group expanded.
  document.querySelectorAll('[data-mobile-filter-group]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var label = this.dataset.mobileFilterGroup;
      openSidebar();
      if (filterSidebar) {
        filterSidebar.querySelectorAll('[data-filter-group]').forEach(function (group) {
          var nameEl = group.querySelector('.filter-group__name');
          var body = group.querySelector('[data-filter-body]');
          if (!body) return;
          var isMatch = nameEl && nameEl.textContent.trim() === label;
          body.style.display = isMatch ? '' : 'none';
          group.classList.toggle('filter-group--open', isMatch);
        });
      }
    });
  });

  document.querySelectorAll('[data-filter-accordion]').forEach(function (btn) {
    var group = btn.closest('[data-filter-group]');
    var body = group ? group.querySelector('[data-filter-body]') : null;
    if (!body) return;

    btn.addEventListener('click', function () {
      var isOpen = body.style.display !== 'none';
      body.style.display = isOpen ? 'none' : '';
      group.classList.toggle('filter-group--open', !isOpen);
    });
  });

  // Desktop: auto-submit filter form on checkbox change.
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm && window.innerWidth > 768) {
    filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        filterForm.submit();
      });
    });
  }

  // Mobile Apply: slide the sheet down before navigating.
  if (filterForm) {
    filterForm.addEventListener('submit', function (e) {
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      if (filterForm.dataset.closing === '1') return;
      e.preventDefault();
      filterForm.dataset.closing = '1';
      if (filterSidebar) filterSidebar.classList.add('collection__sidebar--closing');
      if (filterBackdrop) filterBackdrop.classList.add('collection__sidebar-backdrop--closing');
      setTimeout(function () { filterForm.submit(); }, 250);
    });
  }

  document.querySelectorAll('[data-sort-wrap]').forEach(function (sortWrap) {
    var sortTrigger = sortWrap.querySelector('[data-sort-trigger]');

    if (sortTrigger && sortWrap) {
      sortTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        document.querySelectorAll('[data-sort-wrap]').forEach(function (other) {
          if (other !== sortWrap) other.classList.remove('collection__sort--open');
        });
        sortWrap.classList.toggle('collection__sort--open');
      });
      sortWrap.querySelectorAll('[data-sort]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var sortVal = this.dataset.sort;
          var url = new URL(window.location);
          if (sortVal) {
            url.searchParams.set('sort_by', sortVal);
          } else {
            url.searchParams.delete('sort_by');
          }
          window.location = url.toString();
        });
      });
    }
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('[data-sort-wrap]').forEach(function (sortWrap) {
      sortWrap.classList.remove('collection__sort--open');
    });
  });

  // Mobile sort bottom sheet
  var sortSheet = document.querySelector('[data-sort-sheet]');
  var sortSheetBackdrop = document.querySelector('[data-sort-sheet-backdrop]');
  var SORT_SHEET_ANIM_MS = 250;

  function openSortSheet() {
    if (sortSheet) sortSheet.style.display = '';
    if (sortSheetBackdrop) sortSheetBackdrop.style.display = 'block';
    requestAnimationFrame(function () {
      if (sortSheet) sortSheet.classList.add('is-open');
      if (sortSheetBackdrop) sortSheetBackdrop.classList.add('is-open');
    });
  }

  function closeSortSheet(onClosed) {
    if (sortSheet) sortSheet.classList.remove('is-open');
    if (sortSheetBackdrop) sortSheetBackdrop.classList.remove('is-open');
    setTimeout(function () {
      if (sortSheet) sortSheet.style.display = 'none';
      if (sortSheetBackdrop) sortSheetBackdrop.style.display = 'none';
      if (typeof onClosed === 'function') onClosed();
    }, SORT_SHEET_ANIM_MS);
  }

  var sortSheetTrigger = document.querySelector('[data-sort-sheet-trigger]');
  if (sortSheetTrigger) {
    sortSheetTrigger.addEventListener('click', openSortSheet);
  }

  var sortSheetClose = document.querySelector('[data-sort-sheet-close]');
  if (sortSheetClose) {
    sortSheetClose.addEventListener('click', function () { closeSortSheet(); });
  }

  if (sortSheetBackdrop) {
    sortSheetBackdrop.addEventListener('click', function () { closeSortSheet(); });
  }

  if (sortSheet) {
    sortSheet.querySelectorAll('[data-sort]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sortVal = this.dataset.sort;
        sortSheet.querySelectorAll('.sort-sheet__option--active').forEach(function (el) {
          el.classList.remove('sort-sheet__option--active');
        });
        this.classList.add('sort-sheet__option--active');
        closeSortSheet(function () {
          var url = new URL(window.location);
          if (sortVal) {
            url.searchParams.set('sort_by', sortVal);
          } else {
            url.searchParams.delete('sort_by');
          }
          window.location = url.toString();
        });
      });
    });
  }

  // Infinite scroll
  var grid = document.querySelector('[data-product-grid]');
  var logoArea = document.querySelector('[data-infinite-scroll]');

  if (grid && logoArea && logoArea.dataset.nextUrl) {
  var loading = false;
  var nextUrl = logoArea.dataset.nextUrl;
  var logoSvg = logoArea.querySelector('.logo-loading');

  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting && !loading && nextUrl) {
      loadMore();
    }
  }, { rootMargin: '200px' });

  observer.observe(logoArea);

  function loadMore() {
    if (!nextUrl || loading) return;
    loading = true;
    if (logoSvg) logoSvg.classList.add('logo-loading--active');

    fetch(nextUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var newCards = tmp.querySelectorAll('[data-product-grid] .product-card');
        newCards.forEach(function (card) {
          grid.appendChild(card);
        });

        var newLogoArea = tmp.querySelector('[data-infinite-scroll]');
        if (newLogoArea && newLogoArea.dataset.nextUrl) {
          nextUrl = newLogoArea.dataset.nextUrl;
        } else {
          nextUrl = null;
          observer.disconnect();
          logoArea.style.display = 'none';
          grid.classList.add('collection__grid--done');
        }
        loading = false;
        if (logoSvg) logoSvg.classList.remove('logo-loading--active');

        if (nextUrl && isElementInViewport(logoArea)) {
          loadMore();
        }
      })
      .catch(function () {
        loading = false;
        if (logoSvg) logoSvg.classList.remove('logo-loading--active');
      });
  }

  function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight + 200;
  }
  }

  // Mobile-only: explore-banners arrow advances the horizontal scroll one card
  // forward; wraps back to start once the end is reached.
  var exploreBtn = document.querySelector('[data-explore-scroll]');
  var exploreList = document.querySelector('[data-explore-banners]');
  if (exploreBtn && exploreList) {
    exploreBtn.addEventListener('click', function () {
      var card = exploreList.querySelector('.search-explore__card');
      if (!card) return;
      var gap = parseFloat(getComputedStyle(exploreList).gap) || 8;
      var step = card.getBoundingClientRect().width + gap;
      var atEnd = exploreList.scrollLeft + exploreList.clientWidth >= exploreList.scrollWidth - 4;
      if (atEnd) {
        exploreList.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        exploreList.scrollBy({ left: step, behavior: 'smooth' });
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-returns-content"]) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.shipping-returns');
    roots.forEach(function (root) {
      var nav = root.querySelector('.shipping-returns__nav');
      var links = root.querySelectorAll('.shipping-returns__nav-link');
      var articles = root.querySelectorAll('.shipping-returns__article');
      if (!links.length || !articles.length) return;

      function centerActiveInNav() {
        if (!nav || nav.scrollWidth <= nav.clientWidth) return;
        var active = nav.querySelector('.shipping-returns__nav-link.is-active');
        if (!active) return;
        var li = active.parentElement;
        var target = li.offsetLeft - (nav.clientWidth - li.offsetWidth) / 2;
        nav.scrollTo({ left: target, behavior: 'smooth' });
      }

      function setActive(id) {
        var changed = false;
        links.forEach(function (link) {
          var shouldBeActive = link.getAttribute('data-target') === id;
          if (shouldBeActive !== link.classList.contains('is-active')) changed = true;
          link.classList.toggle('is-active', shouldBeActive);
        });
        if (changed) centerActiveInNav();
      }

      links.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var id = link.getAttribute('data-target');
          var target = root.querySelector('#' + id);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setActive(id);
          if (history.replaceState) {
            history.replaceState(null, '', '#' + id);
          }
        });
      });

      if ('IntersectionObserver' in window) {
        var visible = {};
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            visible[entry.target.id] = entry.isIntersecting ? entry.intersectionRatio : 0;
          });
          var topId = null;
          var topRatio = 0;
          Object.keys(visible).forEach(function (id) {
            if (visible[id] > topRatio) {
              topRatio = visible[id];
              topId = id;
            }
          });
          if (topId) setActive(topId);
        }, {
          rootMargin: '-120px 0px -50% 0px',
          threshold: [0, 0.25, 0.5, 0.75, 1]
        });
        articles.forEach(function (article) { observer.observe(article); });
      }

      var hash = (window.location.hash || '').replace('#', '');
      if (hash && root.querySelector('#' + hash)) {
        setActive(hash);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-open-chat]');
    if (!link) return;
    e.preventDefault();
    var deadline = Date.now() + 5000;
    (function tryOpen() {
      var g = window.GorgiasChat;
      if (g && typeof g.open === 'function') { g.open(); return; }
      if (g && typeof g.init === 'function') { g.init().then(function () { g.open(); }); return; }
      if (Date.now() < deadline) { setTimeout(tryOpen, 100); return; }
      var href = link.getAttribute('href');
      if (href && href !== '#') { window.location.href = href; }
    })();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-my-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('[data-track-order]');
  if (!root) return;

  const form = root.querySelector('[data-track-order-form]');
  const submitBtn = root.querySelector('[data-track-order-submit]');
  const labelIdle = submitBtn.querySelector('[data-label-idle]');
  const labelLoading = submitBtn.querySelector('[data-label-loading]');
  const statusEl = root.querySelector('[data-track-order-status]');
  const tplNotFound = root.querySelector('[data-track-order-tpl-not-found]');
  const tplServiceError = root.querySelector('[data-track-order-tpl-service-error]');
  const tplProcessing = root.querySelector('[data-track-order-tpl-processing]');
  const tplDeliveredDigital = root.querySelector('[data-track-order-tpl-delivered-digital]');
  const tplList = root.querySelector('[data-track-order-tpl-list]');
  const tplRow = root.querySelector('[data-track-order-tpl-row]');

  const endpoint = root.dataset.endpoint || '/apps/track-order';
  const trackingUrlTemplate =
    root.dataset.trackingUrlTemplate || 'https://kec.kln.com/en/track-trace/?tracking={number}';
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  let inFlight = false;

  function setState(state) {
    root.classList.remove(
      'track-my-order--idle',
      'track-my-order--loading',
      'track-my-order--processing',
      'track-my-order--delivered-digital',
      'track-my-order--success',
      'track-my-order--error'
    );
    root.classList.add('track-my-order--' + state);

    const loading = state === 'loading';
    submitBtn.disabled = loading;
    submitBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
    labelIdle.hidden = loading;
    labelLoading.hidden = !loading;
  }

  function clearStatus() {
    statusEl.replaceChildren();
    statusEl.hidden = true;
  }

  function showStatus(node) {
    statusEl.replaceChildren(node);
    statusEl.hidden = false;
  }

  function buildTrackingUrl(f) {
    /* QA BUG-BV-76: prefer the carrier's OWN tracking URL (Shopify returns it for
       carriers like DHL — the page was showing "DHL" but linking to kec.kln.com).
       Only fall back to the Kerry/KEC aggregator template when the fulfillment
       carries just a number and no URL. */
    var url = f && f.url;
    if (url && /^https?:\/\//i.test(url)) return url;
    return trackingUrlTemplate.replace('{number}', encodeURIComponent((f && f.trackingNumber) || ''));
  }

  function renderNotFound() {
    showStatus(tplNotFound.content.cloneNode(true));
    setState('error');
  }

  function renderServiceError() {
    showStatus(tplServiceError.content.cloneNode(true));
    setState('error');
  }

  function renderProcessing() {
    showStatus(tplProcessing.content.cloneNode(true));
    setState('processing');
  }

  function renderDeliveredDigital() {
    showStatus(tplDeliveredDigital.content.cloneNode(true));
    setState('delivered-digital');
  }

  function renderList(fulfillments) {
    const wrap = tplList.content.cloneNode(true);
    const list = wrap.querySelector('[data-track-order-list]');
    fulfillments.forEach(function (f) {
      const row = tplRow.content.cloneNode(true);
      row.querySelector('[data-company]').textContent = f.company || '';
      row.querySelector('[data-number]').textContent = f.trackingNumber || '';
      row.querySelector('[data-track-link]').href = buildTrackingUrl(f);
      list.appendChild(row);
    });
    showStatus(wrap);
    setState('success');
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (inFlight) return;

    const orderNumber = form.elements['order_number'].value.trim();
    const email = form.elements['email'].value.trim();
    if (!orderNumber || !emailRegex.test(email)) {
      renderNotFound();
      return;
    }

    inFlight = true;
    setState('loading');
    clearStatus();

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ order_number: orderNumber, email: email })
      });
      if (!res.ok) {
        renderServiceError();
        return;
      }
      const data = await res.json();

      if (data.status === 'not_found') {
        renderNotFound();
        return;
      }

      if (data.status === 'shipped' && Array.isArray(data.fulfillments) && data.fulfillments.length > 0) {
        if (data.fulfillments.length === 1) {
          window.location.href = buildTrackingUrl(data.fulfillments[0]);
          return;
        }
        renderList(data.fulfillments);
        return;
      }
      if (data.status === 'processing') {
        renderProcessing();
        return;
      }
      if (data.status === 'delivered_digital') {
        renderDeliveredDigital();
        return;
      }
      renderServiceError();
    } catch (err) {
      renderServiceError();
    } finally {
      inFlight = false;
    }
  });

  // Reset to idle when the user edits either field after a result was shown.
  form.addEventListener('input', function () {
    if (root.classList.contains('track-my-order--loading')) return;
    if (statusEl.hidden) return;
    clearStatus();
    setState('idle');
  });

  setState('idle');
})();

  } catch(e) { console.error(e); }
})();
})();
